// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

export const STATUS_INACTIVE = 0
export const STATUS_PAID = 1
export const STATUS_DONE = 2
export const STATUS_FINNISHED = 2
export const STATUS_APPROVED = 2
export const STATUS_PUBLISHED = 3

// User statuses
export const STATUS_UNINTERESTED = -1
export const STATUS_PENDING = 0
export const STATUS_BOOKED_MEETING = 0.1
export const STATUS_ACTIVE = 1
export const STATUS_BLOCKED = 2
export const STATUS_DELETED = 4
export const STATUS_ON_SITE_TRAINING = 5.075
export const STATUS_VIDEO_ONBOARDING_IN_PROGRESS = 5.125
export const STATUS_QUIZ_IN_PROGRESS = 5.25
export const STATUS_PRE_ACCESS = 5.5
export const STATUS_WAITING_FOR_REVIEW = 6
export const STATUS_ONSITE_MEETING = 6.5

// user status rules
export const INTERESTED_UNINTERESTED_RULE = 1
export const QUIZ_UNINTERESTED_RULE = 2
export const VIDEO_ONBOARDING_UNINTERESTED_RULE = 3

// User statuses deprecated
export const STATUS_TERMINATING = 5

// Campaign
export const STATUS_CAMPAIGN_DRAFT = 0
export const STATUS_CAMPAIGN_ACTIVE = 10
export const STATUS_CAMPAIGN_COMPLETED = 15
export const STATUS_CAMPAIGN_ARCHIVE = 20

export const STATUS_CAMPAIGN_ENUM_DRAFT = 'DRAFT'
export const STATUS_CAMPAIGN_ENUM_ACTIVE = 'ACTIVE'
export const STATUS_CAMPAIGN_ENUM_COMPLETED = 'COMPLETED'
export const STATUS_CAMPAIGN_ENUM_ARCHIVE = 'ARCHIVED'

export const GOAL_CAMPAIGN_ACQUISITION = 'ACQUISITION'
export const GOAL_CAMPAIGN_BRAND_AWARENESS = 'BRAND_AWARENESS'
export const GOAL_CAMPAIGN_RETENTION = 'RETENTION'
export const GOAL_CAMPAIGN_RETARGETING = 'RETARGETING'

export const GOAL_CAMPAIGN_OPTIONS = [
  { label: 'Acquisition', value: GOAL_CAMPAIGN_ACQUISITION },
  { label: 'Brand Awareness', value: GOAL_CAMPAIGN_BRAND_AWARENESS },
  { label: 'Retargeting', value: GOAL_CAMPAIGN_RETARGETING },
  { label: 'Retention', value: GOAL_CAMPAIGN_RETENTION },
]

//Document statuses
export const STATUS_DOCUMENT_APPROVED = 1
export const STATUS_DOCUMENT_PENDING = 0
export const STATUS_DOCUMENT_REJECTED = 2
export const STATUS_DOCUMENT_MANUALY_APPLOADED = 3

export const STATUS_CAMPAIGN_ENUM_TO_TYPES_MAP = {
  [STATUS_CAMPAIGN_ENUM_DRAFT]: STATUS_CAMPAIGN_DRAFT,
  [STATUS_CAMPAIGN_ENUM_ACTIVE]: STATUS_CAMPAIGN_ACTIVE,
  [STATUS_CAMPAIGN_ENUM_COMPLETED]: STATUS_CAMPAIGN_COMPLETED,
  [STATUS_CAMPAIGN_ENUM_ARCHIVE]: STATUS_CAMPAIGN_ARCHIVE,
}
export const STATUS_CAMPAIGN_TYPES_TO_ENUM_MAP = {
  [STATUS_CAMPAIGN_DRAFT]: STATUS_CAMPAIGN_ENUM_DRAFT,
  [STATUS_CAMPAIGN_ACTIVE]: STATUS_CAMPAIGN_ENUM_ACTIVE,
  [STATUS_CAMPAIGN_COMPLETED]: STATUS_CAMPAIGN_ENUM_COMPLETED,
  [STATUS_CAMPAIGN_ARCHIVE]: STATUS_CAMPAIGN_ENUM_ARCHIVE,
}

// Location
export const STATUS_DISABLED = 0
export const STATUS_ENABLED = 1
export const LOCATION_RESERVED_HOURS = 3
export const STATUS_LOCATION_ARCHIVED = 20

// missions
export const STATUS_DRAFT = 0
// Not a real mission status: a DRAFT mission a reviewer has signed off shows as
// "Ready to publish". It sits between DRAFT and AVAILABLE so the table sorters
// order it where ops expect, and so the numeric checks that gate editing and
// deleting still treat it as the draft it really is.
export const STATUS_READY_TO_PUBLISH = 5
export const STATUS_AVAILABLE = 10
export const STATUS_BOOKED = 20
export const STATUS_CHECKED_IN = 30
export const STATUS_UNDER_REVIEW = 35
export const STATUS_COMPLETED = 40
export const STATUS_CANCELLED = 50
export const STATUS_PAID_MISSION = 60

export const MISSION_LOG_TYPES = {
  MISSION_BOOKED: 1,
  MISSION_UNBOOKED: 2,
  MISSION_CANCELLED: 3,
}

//Mission time type
export const MISSION_TIME_FLEXIBLE = 'flexible'

// Client
export const STATUS_CLIENT_ACTIVE = 1
export const STATUS_CLIENT_ARCHIVED = 4

// paymentSystemTypes
export const PAYMENT_SYSTEM_TYPES_ENUM = {
  PER_MISSION: 'PER_MISSION',
  PER_HOUR: 'PER_HOUR',
}

// Should match the enum in the graphQL Schema
export const BRAND_AMBASSADOR_STATUS_ENUM = {
  PENDING: 'PENDING',
  PRE_ACCESS: 'PRE_ACCESS',
  WAITING_FOR_REVIEW: 'WAITING_FOR_REVIEW',
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  DELETED: 'DELETED',
  QUIZ_IN_PROGRESS: 'QUIZ_IN_PROGRESS',
  VIDEO_ONBOARDING_IN_PROGRESS: 'VIDEO_ONBOARDING_IN_PROGRESS',
  BOOKED_MEETING: 'BOOKED_MEETING',
  INTERESTED: 'INTERESTED',
  UNINTERESTED: 'UNINTERESTED',
  ON_SITE_TRAINING: 'ON_SITE_TRAINING',
  ONSITE_MEETING: 'ONSITE_MEETING',
}

export const BRAND_AMBASSADORS_STATUS_ENUM_MAP = {
  [BRAND_AMBASSADOR_STATUS_ENUM.PENDING]: STATUS_PENDING,
  [BRAND_AMBASSADOR_STATUS_ENUM.PRE_ACCESS]: STATUS_PRE_ACCESS,
  [BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE]: STATUS_ACTIVE,
  [BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED]: STATUS_BLOCKED,
  [BRAND_AMBASSADOR_STATUS_ENUM.DELETED]: STATUS_DELETED,
  [BRAND_AMBASSADOR_STATUS_ENUM.WAITING_FOR_REVIEW]: STATUS_WAITING_FOR_REVIEW,
  [BRAND_AMBASSADOR_STATUS_ENUM.QUIZ_IN_PROGRESS]: STATUS_QUIZ_IN_PROGRESS,
  [BRAND_AMBASSADOR_STATUS_ENUM.VIDEO_ONBOARDING_IN_PROGRESS]: STATUS_VIDEO_ONBOARDING_IN_PROGRESS,
  [BRAND_AMBASSADOR_STATUS_ENUM.BOOKED_MEETING]: STATUS_BOOKED_MEETING,
  [BRAND_AMBASSADOR_STATUS_ENUM.UNINTERESTED]: STATUS_UNINTERESTED,
  [BRAND_AMBASSADOR_STATUS_ENUM.ON_SITE_TRAINING]: STATUS_ON_SITE_TRAINING,
  [BRAND_AMBASSADOR_STATUS_ENUM.ONSITE_MEETING]: STATUS_ONSITE_MEETING,
}

export const BRAND_AMBASSADORS_STATUS_TYPE_TO_ENUM = {
  [STATUS_PENDING]: BRAND_AMBASSADOR_STATUS_ENUM.PENDING,
  [STATUS_PRE_ACCESS]: BRAND_AMBASSADOR_STATUS_ENUM.PRE_ACCESS,
  [STATUS_ACTIVE]: BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE,
  [STATUS_BLOCKED]: BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED,
  [STATUS_DELETED]: BRAND_AMBASSADOR_STATUS_ENUM.DELETED,
  [STATUS_WAITING_FOR_REVIEW]: BRAND_AMBASSADOR_STATUS_ENUM.WAITING_FOR_REVIEW,
  [STATUS_QUIZ_IN_PROGRESS]: BRAND_AMBASSADOR_STATUS_ENUM.QUIZ_IN_PROGRESS,
  [STATUS_VIDEO_ONBOARDING_IN_PROGRESS]:
    BRAND_AMBASSADOR_STATUS_ENUM.VIDEO_ONBOARDING_IN_PROGRESS,
  [STATUS_BOOKED_MEETING]: BRAND_AMBASSADOR_STATUS_ENUM.BOOKED_MEETING,
  [STATUS_UNINTERESTED]: BRAND_AMBASSADOR_STATUS_ENUM.UNINTERESTED,
  [STATUS_ON_SITE_TRAINING]: BRAND_AMBASSADOR_STATUS_ENUM.ON_SITE_TRAINING,
  [STATUS_ONSITE_MEETING]: BRAND_AMBASSADOR_STATUS_ENUM.ONSITE_MEETING,
}

// Invited status is a combined status below Active
export const INVITED_SPY_STATUS = 'INVITED'

// Should match the enum in the graphQL Schema
export const MISSION_STATUS_ENUM = {
  DRAFT: 'DRAFT',
  AVAILABLE: 'AVAILABLE',
  BOOKED: 'BOOKED',
  CANCELLED: 'CANCELLED',
  CHECKED_IN: 'CHECKED_IN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  COMPLETED: 'COMPLETED',
  PAID: 'PAID',
}

// Deliberately NOT a member of MISSION_STATUS_ENUM above, which has to match
// the GraphQL enum. This is a display-only state derived from
// Mission.isReadyToPublish; see shared/missionReadyToPublish.js.
export const MISSION_DISPLAY_STATUS_READY_TO_PUBLISH = 'READY_TO_PUBLISH'

export const MISSION_STATUS_ENUM_MAP = {
  [MISSION_STATUS_ENUM.DRAFT]: STATUS_DRAFT,
  [MISSION_DISPLAY_STATUS_READY_TO_PUBLISH]: STATUS_READY_TO_PUBLISH,
  [MISSION_STATUS_ENUM.AVAILABLE]: STATUS_AVAILABLE,
  [MISSION_STATUS_ENUM.BOOKED]: STATUS_BOOKED,
  [MISSION_STATUS_ENUM.CANCELLED]: STATUS_CANCELLED,
  [MISSION_STATUS_ENUM.CHECKED_IN]: STATUS_CHECKED_IN,
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: STATUS_UNDER_REVIEW,
  [MISSION_STATUS_ENUM.COMPLETED]: STATUS_COMPLETED,
  [MISSION_STATUS_ENUM.PAID]: STATUS_PAID_MISSION,
}

// its combined status means missions to_be_spied = true and status UNDER_REVIEW and above
export const MISSION_STATUS_SPIED = 'SPIED'
export const MISSION_STATUS_SPYING = 'SPYING'

export const PICKUP_TIME_BEFORE_MS = 15 * 60 * 1000 //  15 minutes before the mission
export const BAD_WEATHER_SURGE_BONUS = 'BAD_WEATHER_SURGE'

export const NEWCOMERS_MISSIONS_LIMIT = 3

// User roles
export const ROLE_ADMIN = 'ADMIN'
export const ROLE_CITY_MANAGER = 'CITY_MANAGER'
export const ROLE_CLIENT_ADMIN = 'CLIENT_ADMIN'
export const ROLE_CLIENT = 'ROLE_CLIENT'
export const ROLE_DISTRIBUTOR = 'DISTRIBUTOR'
export const ROLE_SPY = 'ROLE_SPY'
export const RECRUITER = 'RECRUITER'
export const ROLE_EMPLOYEE = 'EMPLOYEE'

// Permit Cost
export const PERMIT_COST_PENDING = 0
export const PERMIT_COST_PAID = 1

// Inventory movements
export const INVENTORY_MOVEMENT_INIT = 0
export const INVENTORY_MOVEMENT_IN = 1
export const INVENTORY_MOVEMENT_OUT = 2
export const INVENTORY_MOVEMENT_DISTRIBUTED = 3

export const INVENTORY_FLYER_ITEM_TYPE = 3

// Global configuration
export const SURGE_RATIO = 1.2
export const SURGE_BEFORE = 15
export const SURGE_AFTER = 15
export const MAX_STARS_RATING = 5
export const MAX_PAY_RATIO = 2.2

// report
export const STATUS_PROCESSED = 10
export const STATUS_ERROR = 20

// Others
export const DEFAULT_RATIO_MORNING = 0.3333
export const DEFAULT_RATIO_LUNCH = 0.3333
export const DEFAULT_RATIO_AFTERNOON = 0.3333
export const DEFAULT_MISSION_DURATION = 3

export const TIME_MORNING = 'MORNING'
export const TIME_LUNCH = 'LUNCH'
export const TIME_AFTERNOON = 'AFTERNOON'

export const DEFAULT_TIME_MORNING = '07:30:00' // 7.30am
export const DEFAULT_TIME_LUNCH = '11:30:00' // 11.30am
export const DEFAULT_TIME_AFTERNOON = '16:30:00' // 4.30pm

export const AMBASSADOR_PER_MISSION = 2
export const HOURS_PER_MISSION = 3

export const DEFAULT_PROFILE_PIC =
  'https://oppizi-uploads.s3-ap-southeast-2.amazonaws.com/default-profile-pic.png'
export const SAMPLE_CLIENT_PITCH =
  'https://oppizi-uploads.s3-ap-southeast-2.amazonaws.com/sample/sample-pitch.pdf'
export const IMAGE_URL_REGEX = /^https:\/\/.*\.(?:png|jpeg|jpg)$/i
export const DOCUMENT_URL_REGEX = /^https:\/\/.*\.(?:png|jpeg|jpg|pdf)$/i

// flagging rules
export const FLAG_MISSION_DURATION_TOO_SHORT = 1
export const FLAG_MISSION_FLYERS_NOT_DISTRIBUTED = 1 << 1
export const FLAG_MISSION_STEPS_WALKED = 1 << 2
export const FLAG_MISSION_LEAVE_LOCATION = 1 << 3
export const FLAG_MISSION_SHORT_TIME_AND_FLYERS_NOT_DISTRIBUTED = 1 << 4
export const FLAG_MISSION_BA_LEAVING_MISSION_AREA = 1 << 5
export const FLAG_MISSION_NO_ACTIVITY = 1 << 6

// extra payments types
export const EXTRA_PAYMENT_REFERRAL = 'referralReward'
export const EXTRA_PAYMENT_BAD_WEATHER = 'badWeatherSurge'
export const EXTRA_PAYMENT_CONVERSION = 'conversionReward'
export const EXTRA_PAYMENT_PROMO = 'promoReward'

// Global search constants
export const GLOBAL_SEARCH = {
  MISSION: 'MISSION',
  CAMPAIGN: 'CAMPAIGN',
  LOCATION: 'LOCATION',
  USER: 'USER',
  CLIENT: 'CLIENT',
  INVENTORY_CODE: 'INVENTORY_CODE',
  CITY: 'CITY',
  PARTICIPANT: 'PARTICIPANT',
}

export const UNVERIFIED_USER_ERROR = 'EMAIL_NOT_VERIFIED'
export const TOO_FAR_FROM_LOCATION_ERROR = 'TOO_FAR_FROM_LOCATION_ERROR'
export const TOO_FAR_FROM_BA_LOCATION_ERROR = 'TOO_FAR_FROM_BA_LOCATION_ERROR'
export const MISSION_CHECK_IN_EXPIRED_ERROR = 'MISSION_CHECK_IN_EXPIRED_ERROR'
export const MISSION_EXPIRED_ERROR = 'MISSION_EXPIRED_ERROR'
export const MISSION_NOT_YET_ACTIVE_ERROR = 'MISSION_NOT_YET_ACTIVE_ERROR'
export const MISSION_LB_EXPIRED_ERROR = 'MISSION_LB_EXPIRED_ERROR'
export const MISSION_LB_NOT_YET_ACTIVE_ERROR = 'MISSION_LB_NOT_YET_ACTIVE_ERROR'

// Used for the pay per hour feature, will split the payout via this amount
export const MISSION_DURATION = 3

// UNBOOK_REASONS
export const UNBOOK_REASONS = {
  BAD_WEATHER: 'BAD_WEATHER',
  CLIENT_REQUEST: 'CLIENT_REQUEST',
  BA_REQUEST: 'BA_REQUEST',
  CHEATING_SUSPICIOUS_BEHAVIOUR: 'CHEATING_SUSPICIOUS_BEHAVIOUR',
}

export const READABLE_REASONS = {
  [UNBOOK_REASONS.BAD_WEATHER]: 'Bad Weather',
  [UNBOOK_REASONS.CLIENT_REQUEST]: 'Client Request',
  [UNBOOK_REASONS.BA_REQUEST]: 'Brand Ambassador Request',
  [UNBOOK_REASONS.CHEATING_SUSPICIOUS_BEHAVIOUR]:
    'Cheating / Suspicious Behaviour',
}

// WEBSOCKETS
export const WEBSOCKETS_DOMAINS = {
  'dev': 'localhost:3001',
  'development': 'localhost:3001',
  'phoebe': 'sjg8mjdq7c.execute-api.us-east-1.amazonaws.com',
  'Phoebe': 'sjg8mjdq7c.execute-api.us-east-1.amazonaws.com',
  'titan': '5vv67tboy5.execute-api.us-east-1.amazonaws.com',
  'Titan': '5vv67tboy5.execute-api.us-east-1.amazonaws.com',
  'prod': 'f6p30h9gvb.execute-api.us-east-1.amazonaws.com',
  'oppizi': 'f6p30h9gvb.execute-api.us-east-1.amazonaws.com',
  'promofy': 'g7ln94iejh.execute-api.us-east-1.amazonaws.com',
  'Promofy': 'g7ln94iejh.execute-api.us-east-1.amazonaws.com',
}
export const WEBSOCKETS_URLS = {
  'dev': `ws://${WEBSOCKETS_DOMAINS['dev']}`,
  'development': `ws://${WEBSOCKETS_DOMAINS['dev']}`,
  'phoebe': `wss://${WEBSOCKETS_DOMAINS['phoebe']}/phoebe`,
  'Phoebe': `wss://${WEBSOCKETS_DOMAINS['phoebe']}/phoebe`,
  'titan': `wss://${WEBSOCKETS_DOMAINS['titan']}/titan`,
  'Titan': `wss://${WEBSOCKETS_DOMAINS['titan']}/titan`,
  'prod': `wss://${WEBSOCKETS_DOMAINS['prod']}/prod`,
  'oppizi': `wss://${WEBSOCKETS_DOMAINS['prod']}/prod`,
  'promofy': `wss://${WEBSOCKETS_DOMAINS['promofy']}/promofy`,
  'Promofy': `wss://${WEBSOCKETS_DOMAINS['promofy']}/promofy`,
}

// CHAT
export const CHAT_MAX_TEXT_LENGTH = 1023
export const CHAT_STAFF_ACTIVE_DURATION_MINUTES = 120
export const CHAT_MESSAGE_TYPES = {
  TEXT: 'TEXT',
  LOCATION: 'LOCATION',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  FILE: 'FILE',
}

export const NOTIFICATION_TYPES = {
  CHAT_MESSAGE_RECEIVED: 'CHAT_MESSAGE_RECEIVED',
}

// Pitch questions
export const PITCH_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  CHECK_BOX: 'CHECK_BOX',
  DROPDOWN: 'DROPDOWN',
}

// Quiz type
export const QUIZ_TYPES = {
  CLIENT_PITCH: 'CLIENT_PITCH',
  ONBOARDING_PITCH: 'ONBOARDING_PITCH',
  VIDEO_ONBOARDING_PART_ONE: 'VIDEO_ONBOARDING_PART_ONE',
  VIDEO_ONBOARDING_PART_TWO: 'VIDEO_ONBOARDING_PART_TWO',
  VIDEO_ONBOARDING_PART_THREE: 'VIDEO_ONBOARDING_PART_THREE',
}

// Quiz questions
export const QUIZ_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
}

export const MULTIPLE_CHOICE_ANSWER_ERROR =
  'Please select at least 2 correct answers'

export const DELETE_PITCH_FILE_ERROR =
  'Pitch can’t be deleted when there’re BAs in the Test stage'

export const DELETE_ALL_QUESTIONS_ERROR =
  'All questions can’t be deleted when there’re BAs in the Test stage'

export const CHAT_STRING_TYPES = {
  TEXT: 'TEXT',
  URL: 'URL',
}

export const INVOICE_TYPE_GENERAL = 'general'

// Campaign Types

export const CAMPAIGN_TYPES = {
  HANDTOHAND: 1,
  LETTERBOX: 2,
  DIRECTMAIL: 3,
  INSERTS: 4,
}

export const CAMPAIGN_ENUM_TYPES = {
  HANDTOHAND: 'HANDTOHAND',
  LETTERBOX: 'LETTERBOX',
  DIRECTMAIL: 'DIRECTMAIL',
  INSERTS: 'INSERTS',
}

export const CAMPAIGN_SUBTYPES_ENUM = {
  DM_CORE: 'DM_CORE',
  EDDM: 'EDDM',
  ADM: 'ADM',
  AIM: 'AIM',
  DMW: 'DM_WORKFLOWS',
}

export const CAMPAIGN_DASHBOARD_BY_CAMPAIGN_TYPE = {
  [CAMPAIGN_SUBTYPES_ENUM.DM_CORE]: 'overview',
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: 'overview',
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: 'overview',
  [CAMPAIGN_SUBTYPES_ENUM.EDDM]: 'eddm',
  [CAMPAIGN_ENUM_TYPES.INSERTS]: 'aim',
  [CAMPAIGN_SUBTYPES_ENUM.ADM]: 'adm',
}

export const CAMPAIGN_SUBTYPES = {
  1: CAMPAIGN_SUBTYPES_ENUM.DM_CORE,
  2: CAMPAIGN_SUBTYPES_ENUM.EDDM,
  3: CAMPAIGN_SUBTYPES_ENUM.ADM,
}

export const EDDM_DOCUMENT_FORMATS = {
  SMALL: 'SMALL',
  BEST_SELLER: 'BEST_SELLER',
  LARGE: 'LARGE',
  JUMBO: 'JUMBO',
  OVERSIZED: 'OVERSIZED',
}

export const ADM_DOCUMENTS_FORMATS = {
  POSTCARD_6x4: 'POSTCARD_6x4',
  POSTCARD_9x6: 'POSTCARD_9x6',
  POSTCARD_11x6: 'POSTCARD_11x6',
  POSTCARD_15x12: 'POSTCARD_15x12',
}

export const CAMPAIGN_TYPE_PARAM_TO_ENUM = {
  dm: 'DIRECTMAIL',
  h2h: 'HANDTOHAND',
  d2d: 'LETTERBOX',
  inserts: 'INSERTS',
}

export const CAMPAIGN_TYPE_PARAM_TO_TITLE = {
  dm: 'EDDM',
  h2h: 'Flyering',
  d2d: 'Door to door',
  adm: 'Addressed Direct Mail',
  eddm: 'EDDM',
  dmw: 'Direct Mail Workflow',
}

export const CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME = {
  dm: 'EDDM',
  h2h: 'Flyering',
  d2d: 'Door to door',
  adm: 'Addressed DM',
  eddm: 'EDDM',
  dmw: 'Direct Mail Workflow',
}

export const CAMPAIGN_TYPE_PARAM_TO_CHANNEL = {
  h2h: 'Flyering',
  d2d: 'Door to door',
  adm: 'ADM',
  eddm: 'EDDM',
  dmw: 'Direct Mail Workflow',
}

export const CAMPAIGN_TYPE_PARAM_TO_CAMPAIGNS_DASHBOARD_TITLE = {
  dm: 'Direct mail',
  eddm: 'Every Door Direct Mail',
  adm: 'Addressed Direct Mail',
  h2h: 'Flyering',
  d2d: 'Door to door',
  inserts: 'Inserts Marketing',
}

export const CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE = {
  dm: 'Direct mail',
  h2h: 'Flyering campaigns',
  d2d: 'Door to door / Door-hanger campaigns',
  active: 'Active campaigns',
  eddm: 'Every Door Direct Mail',
  adm: 'Addressed Direct Mail',
  inserts: 'Inserts Marketing',
}

export const CAMPAIGN_TYPE_PARAM_TO_ENABLED_CHANNEL = {
  dm: 'enabledChannelEddm',
  d2d: 'enabledChannelLetterbox',
  h2h: 'enabledChannelPreciseLocations',
  adm: 'enabledChannelAdm',
  eddm: 'enabledChannelEddm',
}

export const EDDM_SIGNUP = 'eddm_signup'
export const SS_SIGNUP = 'ss_signup'

export const CAMPAIGN_ENUM_TYPES_TO_CAMPAIGN_NAME = {
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.h2h,
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.d2d,
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.dm,
  [CAMPAIGN_SUBTYPES_ENUM.ADM]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.adm,
  [CAMPAIGN_SUBTYPES_ENUM.EDDM]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.eddm,
  [CAMPAIGN_SUBTYPES_ENUM.DMW]: CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME.dmw,
}

export const CAMPAIGN_ENUM_TYPES_TO_TITLE = {
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: CAMPAIGN_TYPE_PARAM_TO_TITLE.h2h,
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: CAMPAIGN_TYPE_PARAM_TO_TITLE.d2d,
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: CAMPAIGN_TYPE_PARAM_TO_TITLE.dm,
  [CAMPAIGN_SUBTYPES_ENUM.ADM]: CAMPAIGN_TYPE_PARAM_TO_TITLE.adm,
  [CAMPAIGN_SUBTYPES_ENUM.EDDM]: CAMPAIGN_TYPE_PARAM_TO_TITLE.eddm,
  [CAMPAIGN_SUBTYPES_ENUM.DMW]: CAMPAIGN_TYPE_PARAM_TO_TITLE.dmw,
}

export const CAMPAIGN_ENUM_TO_TYPES_MAP = {
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: CAMPAIGN_TYPES.HANDTOHAND,
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: CAMPAIGN_TYPES.LETTERBOX,
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: CAMPAIGN_TYPES.DIRECTMAIL,
  [CAMPAIGN_ENUM_TYPES.INSERTS]: CAMPAIGN_TYPES.INSERTS,
}

export const CAMPAIGN_ENUM_TO_CHANNEL_MAP = {
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: CAMPAIGN_TYPE_PARAM_TO_CHANNEL.h2h,
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: CAMPAIGN_TYPE_PARAM_TO_CHANNEL.d2d,
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: CAMPAIGN_TYPE_PARAM_TO_CHANNEL.dm,
}

export const CAMPAIGN_TYPES_TO_ENUM_MAP = {
  [CAMPAIGN_TYPES.HANDTOHAND]: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
  [CAMPAIGN_TYPES.LETTERBOX]: CAMPAIGN_ENUM_TYPES.LETTERBOX,
  [CAMPAIGN_TYPES.DIRECTMAIL]: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
  [CAMPAIGN_TYPES.INSERTS]: CAMPAIGN_ENUM_TYPES.INSERTS,
  [CAMPAIGN_TYPES.UNCERTAIN]: CAMPAIGN_ENUM_TYPES.UNCERTAIN,
}

export const CAMPAIGN_ENUM_GOALS = {
  ACQUISITION: 'ACQUISITION',
  BRAND_AWARENESS: 'BRAND_AWARENESS',
  RETENTION: 'RETENTION',
  RETARGETING: 'RETARGETING',
}

// Mission Types
export const MISSION_TYPES = {
  HANDTOHAND: 1,
  LETTERBOX: 2,
  DIRECTMAIL: 3,
}

export const MISSION_ENUM_TYPES = {
  HANDTOHAND: 'HANDTOHAND',
  LETTERBOX: 'LETTERBOX',
  DIRECTMAIL: 'DIRECTMAIL',
}

export const MISSION_ENUM_TO_TYPES_MAP = {
  [MISSION_ENUM_TYPES.HANDTOHAND]: MISSION_TYPES.HANDTOHAND,
  [MISSION_ENUM_TYPES.LETTERBOX]: MISSION_TYPES.LETTERBOX,
  [MISSION_ENUM_TYPES.DIRECTMAIL]: MISSION_TYPES.DIRECTMAIL,
}

export const MISSION_TYPES_TO_ENUM_MAP = {
  [MISSION_TYPES.HANDTOHAND]: MISSION_ENUM_TYPES.HANDTOHAND,
  [MISSION_TYPES.LETTERBOX]: MISSION_ENUM_TYPES.LETTERBOX,
  [MISSION_TYPES.DIRECTMAIL]: MISSION_ENUM_TYPES.DIRECTMAIL,
}

export const MISSION_TYPES_DYNAMIC_VALUES = {
  [MISSION_TYPES.HANDTOHAND]: 'Hand to hand',
  [MISSION_TYPES.LETTERBOX]: 'Letterbox',
  [MISSION_TYPES.DIRECTMAIL]: 'Direct mail',
}

// City
export const CITY_STATUS_ENUM_ACTIVE = 'ACTIVE'
export const CITY_STATUS_ENUM_ARCHIVED = 'ARCHIVED'
export const CITY_STATUS_ACTIVE = 1
export const CITY_STATUS_ARCHIVED = 0
export const CITY_STATUSES_TO_ENUM_MAP = {
  [CITY_STATUS_ACTIVE]: CITY_STATUS_ENUM_ACTIVE,
  [CITY_STATUS_ARCHIVED]: CITY_STATUS_ENUM_ARCHIVED,
}

export const CLIENT_STATUS_ENUM = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
}

export const CLIENT_ENUM_TO_TYPES_MAP = {
  [CLIENT_STATUS_ENUM.ACTIVE]: STATUS_ACTIVE,
  [CLIENT_STATUS_ENUM.DELETED]: STATUS_DELETED,
}

export const CLIENT_STATUS_INT_TO_ENUM = {
  [STATUS_ACTIVE]: CLIENT_STATUS_ENUM.ACTIVE,
  [STATUS_DELETED]: CLIENT_STATUS_ENUM.DELETED,
}

export const LOCATION_STATUS_ENUM = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  ARCHIVED: 'ARCHIVED',
}
export const LOCATION_STATUS = {
  DISABLED: STATUS_DISABLED,
  ENABLED: STATUS_ENABLED,
  ARCHIVED: STATUS_LOCATION_ARCHIVED,
}
export const LOCATION_ENUM_TO_TYPES_MAP = {
  [LOCATION_STATUS_ENUM.DISABLED]: LOCATION_STATUS.DISABLED,
  [LOCATION_STATUS_ENUM.ENABLED]: LOCATION_STATUS.ENABLED,
  [LOCATION_STATUS_ENUM.ARCHIVED]: LOCATION_STATUS.ARCHIVED,
}

export const LOCATION_STATUS_TYPE_TO_ENUM = {
  [LOCATION_STATUS.DISABLED]: LOCATION_STATUS_ENUM.DISABLED,
  [LOCATION_STATUS.ENABLED]: LOCATION_STATUS_ENUM.ENABLED,
  [LOCATION_STATUS.ARCHIVED]: LOCATION_STATUS_ENUM.ARCHIVED,
}

export const LOCATION_SORT_COLUMN_ENUM = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  LABEL_ASC: 'LABEL_ASC',
  LABEL_DESC: 'LABEL_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  IS_MORNING_ASC: 'IS_MORNING_ASC',
  IS_MORNING_DESC: 'IS_MORNING_DESC',
  IS_LUNCH_ASC: 'IS_LUNCH_ASC',
  IS_LUNCH_DESC: 'IS_LUNCH_DESC',
  IS_AFTERNOON_ASC: 'IS_AFTERNOON_ASC',
  IS_AFTERNOON_DESC: 'IS_AFTERNOON_DESC',
  IS_SHELTERED_ASC: 'IS_SHELTERED_ASC',
  IS_SHELTERED_DESC: 'IS_SHELTERED_DESC',
  IS_EVENT_ASC: 'IS_EVENT_ASC',
  IS_EVENT_DESC: 'IS_EVENT_DESC',
  IS_REQUIRE_PERMIT_ASC: 'IS_REQUIRE_PERMIT_ASC',
  IS_REQUIRE_PERMIT_DESC: 'IS_REQUIRE_PERMIT_DESC',
  CONVERSION_RATE_ASC: 'CONVERSION_RATE_ASC',
  CONVERSION_RATE_DESC: 'CONVERSION_RATE_DESC',
  SCAN_RATE_ASC: 'SCAN_RATE_ASC',
  SCAN_RATE_DESC: 'SCAN_RATE_DESC',
  DELIVERED_FLYERS_ASC: 'DELIVERED_FLYERS_ASC',
  DELIVERED_FLYERS_DESC: 'DELIVERED_FLYERS_DESC',
  FOOT_TRAFFIC_ASC: 'FOOT_TRAFFIC_ASC',
  FOOT_TRAFFIC_DESC: 'FOOT_TRAFFIC_DESC',
  DELIVERED_FLYERS_NUMBER_ASC: 'DELIVERED_FLYERS_NUMBER_ASC',
  DELIVERED_FLYERS_NUMBER_DESC: 'DELIVERED_FLYERS_NUMBER_DESC',
}

export const ONBOARDING_TYPES = {
  ONLINE: 10,
  OFFLINE: 20,
}

export const ONBOARDING_TYPES_ENUM = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  VIDEO: 'VIDEO',
}

export const VO_QUIZ_TYPES_ENUM = {
  QUIZ: 'QUIZ',
  NO_QUIZ: 'NO_QUIZ',
}

export const ONBOARDING_TYPES_ENUM_TO_INT_MAP = {
  [ONBOARDING_TYPES_ENUM.ONLINE]: ONBOARDING_TYPES.ONLINE,
  [ONBOARDING_TYPES_ENUM.OFFLINE]: ONBOARDING_TYPES.OFFLINE,
}

export const ONBOARDING_TYPES_INT_TO_ENUM_MAP = {
  [ONBOARDING_TYPES.ONLINE]: ONBOARDING_TYPES_ENUM.ONLINE,
  [ONBOARDING_TYPES.OFFLINE]: ONBOARDING_TYPES_ENUM.OFFLINE,
}

export const TAG_TYPE_ENUM = {
  CLIENT: 'CLIENT',
  CAMPAIGN_METRIC: 'CAMPAIGN_METRIC',
}

export const APP_DOWNLOAD_LINK = {
  ANDROID: {
    PROD: 'https://play.google.com/store/apps/details?id=com.oppizi',
    TITAN: 'https://play.google.com/store/apps/details?id=com.oppizi.staging',
    PHOEBE: 'https://play.google.com/store/apps/details?id=com.oppizi.uat',
    PROMOFY: 'https://play.google.com/store/apps/details?id=com.promofy.app',
  },
  IOS: {
    PROD: 'https://apps.apple.com/us/app/oppizi/id1342941948',
    TITAN: ' https://apps.apple.com/us/app/oppizi-titan/id1445613003',
    PHOEBE: 'https://apps.apple.com/us/app/oppizi-phoebe/id1430074345',
    PROMOFY: 'https://apps.apple.com/us/app/promofy/id1483581564',
  },
}

export const CAMPAIGN_DELIVERABILITY_STATUS = {
  DIGITAL_PROOFS: 0,
  PRINTING: 10,
  OUT_FOR_DELIVERY: 20,
  RECEIVED_IN_LOCAL_OFFICE: 30,
  OUT_FOR_POSTAGE: 40,
  DISTRIBUTED: 50,
}

export const CAMPAIGN_DELIVERABILITY_STATUS_ENUM = {
  DIGITAL_PROOFS: 'DIGITAL_PROOFS',
  PRINTING: 'PRINTING',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  RECEIVED_IN_LOCAL_OFFICE: 'RECEIVED_IN_LOCAL_OFFICE',
  OUT_FOR_POSTAGE: 'OUT_FOR_POSTAGE',
  DISTRIBUTED: 'DISTRIBUTED',
}

export const CAMPAIGN_DELIVERABILITY_STATUS_ENUM_TO_INT_MAP = {
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DIGITAL_PROOFS]:
    CAMPAIGN_DELIVERABILITY_STATUS.DIGITAL_PROOFS,
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.PRINTING]:
    CAMPAIGN_DELIVERABILITY_STATUS.PRINTING,
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_DELIVERY]:
    CAMPAIGN_DELIVERABILITY_STATUS.OUT_FOR_DELIVERY,
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.RECEIVED_IN_LOCAL_OFFICE]:
    CAMPAIGN_DELIVERABILITY_STATUS.RECEIVED_IN_LOCAL_OFFICE,
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_POSTAGE]:
    CAMPAIGN_DELIVERABILITY_STATUS.OUT_FOR_POSTAGE,
  [CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DISTRIBUTED]:
    CAMPAIGN_DELIVERABILITY_STATUS.DISTRIBUTED,
}

export const CAMPAIGN_DELIVERABILITY_STATUS_INT_TO_ENUM_MAP = {
  [CAMPAIGN_DELIVERABILITY_STATUS.DIGITAL_PROOFS]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DIGITAL_PROOFS,
  [CAMPAIGN_DELIVERABILITY_STATUS.PRINTING]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.PRINTING,
  [CAMPAIGN_DELIVERABILITY_STATUS.OUT_FOR_DELIVERY]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_DELIVERY,
  [CAMPAIGN_DELIVERABILITY_STATUS.RECEIVED_IN_LOCAL_OFFICE]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.RECEIVED_IN_LOCAL_OFFICE,
  [CAMPAIGN_DELIVERABILITY_STATUS.OUT_FOR_POSTAGE]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_POSTAGE,
  [CAMPAIGN_DELIVERABILITY_STATUS.DISTRIBUTED]:
    CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DISTRIBUTED,
}

export const FILTER_MAP_DENSITY_ENUM = {
  ALL: 'ALL',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
}

export const OUR_LANGUAGES = ['ES', 'EN', 'FR', 'NL']

export const BA_FIRST_NAME = '{{firstName}}'
export const BA_LAST_NAME = '{{lastName}}'
export const BA_EMAIL = '{{email}}'
export const BA_PHONE = '{{phone#}}'
export const BA_SIGNUP_DATE = '{{signupDate}}'
export const BA_ONBOARDING_DATE = '{{onboardingDate}}'
export const BA_ONBOARDING_TIME = '{{onboardingTime}}'
export const BA_STATUS = '{{baStatus}}'
export const BA_MERCHANDISE_HELD = '{{merchandiseHeld}}'
export const BA_NEXT_MISSION_DATE = '{{nextMissionDate}}'
export const BA_NEXT_MISSION_TIME = '{{nextMissionTime}}'
export const BA_NEXT_MISSION_TYPE = '{{next mission type}}'
export const BA_NEXT_MISSION_LOCATION = '{{next mission location}}'
export const BA_NEXT_MISSION_CLIENT = '{{next mission client}}'
export const BA_NEXT_MISSION_PAY_RATIO = '{{next mission pay ratio}}'
export const BA_LAST_MISSION_TIME = '{{lastMissionTime}}'
export const BA_LAST_MISSION_DATE = '{{lastMissionDate}}'
export const BA_MONEY_EARNED = '{{brandAmbassadorMoneyEarned}}'
export const BA_BLOCKED_REASON = '{{blockedReason}}'
export const BA_MISSION_MEETING_POINT_ADDRESS = '{{missionMeetingPointAddress}}'
export const BA_MISSION_MEETING_POINT_DATE = '{{missionMeetingPointDate}}'
export const BA_MISSION_MEETING_POINT_TIME = '{{missionMeetingPointTime}}'
export const CITY_NAME = '{{cityName}}'
export const CITY_PICKUP_LOCATION_LINK = '{{pickupLocationLink}}'
export const CITY_NEXT_PICKUP_DATE = '{{nextPickupDate}}'
export const CITY_NEXT_PICKUP_TIME = '{{nextPickupTime}}'
export const CITY_BAD_WEATHER_WEEK = '{{badWeatherWeek}}'
export const CITY_BAD_WEATHER_WEEK_TARGET = '{{badWeatherWeekTarget}}'
export const CITY_BAD_WEATHER_PAYOUT = '{{badWeatherPayout}}'
export const CITY_BA_REFERRAL_START_DATE = '{{baReferralStartDate}}'
export const CITY_BA_REFERRAL_TRIGGER = '{{baReferralTrigger}}'
export const CITY_BA_REFERRAL_REWARD = '{{baReferralReward}}'
export const CITY_MISSION_AVAILABLE = '{{missionAvailable#}}'
export const CITY_BA_ONBOARDING_LINK = '{{baOnboardingLink}}'
export const DEEPLINK_APP_STORE = '{{app store}}'
export const DEEPLINK_APP_UPDATE = '{{app update}}'
export const DEEPLINK_UPLOAD_PICTURE = '{{upload picture}}'
export const DEEPLINK_ABN = '{{ABN}}'
export const DEEPLINK_BANK_DETAILS = '{{bank details}}'
export const DEEPLINK_CONTACT_DETAILS = '{{contact details}}'
export const DEEPLINK_SET_BASES = '{{set base}}'
export const DEEPLINK_EARNINGS = '{{earnings}}'
export const DEEPLINK_AVAILABILITY = '{{availability}}'
export const DEEPLINK_PAUSE_AVAILABILITY = '{{pause availability}}'
export const DEEPLINK_BOOK_MISSION = '{{book mission}}'
export const DEEPLINK_UPCOMING_MISSION = '{{upcoming missions}}'
export const DEEPLINK_MISSION_CHECKIN = '{{mission check-in}}'
export const DEEPLINK_SURGE_TIME = '{{surge time}}'
export const DEEPLINK_COMPLETED_MISSIONS = '{{completed missions}}'
export const DEEPLINK_HOW_TO_GUIDE = '{{How to guide}}'
export const DEEPLINK_TERMS_OF_SERVICE = '{{terms of service}}'
export const DEEPLINK_PRIVACY_POLICY = '{{privacy policy}}'

export const DEEPLINK_PICKUP_LOCATION = '{{pickup location}}'
export const DEEPLINK_PICKUP_TIME = '{{pickup time}}'
export const DEEPLINK_MISSION_LOCATION = '{{mission location}}'
export const DEEPLINK_CLIENT_PITCH = '{{client pitch}}'
export const DEEPLINK_REFER_FRIEND = '{{refer a friend}}'
export const DEEPLINK_PAYMENT_DATE = '{{payment date}}'
export const DEEPLINK_PICKUP_SCANNER = '{{pick up scanner page}}'
export const DEEPLINK_CHAT = '{{app chat}}'
export const DEEPLINK_MY_MISSIONS = '{{My missions}}'
export const DEEPLINK_BROWSE_MISSIONS_H2H = '{{browse H2H missions}}'
export const DEEPLINK_BROWSE_MISSIONS_LTB = '{{browse letterbox missions}}'
export const DEEPLINK_MY_COMPLETED_MISSIONS = '{{completed missions}}'
export const DEEPLINK_REBOOK_ONBOARDING = '{{rebook onboarding}}'

const KEY_INDEX = 0

export const USER_PROFILE_LOGS_TYPE = {
  WARNING: 'Warning',
  BLOCK: 'Block',
  UNBOOK_ALL_MISSIONS: 'Unbook_all_missions',
  SHADOW_BAN: 'Shadow_ban',
  DISABLED_SHADOW_BAN: 'Disabled_shadow_ban',
  APPROVE: 'Approve',
  REFUSE_SEND_TO_PRE_ACCESS: 'Refuse',
  MISSION_TYPE_ALL: 'Mission_type_all',
  MISSION_TYPE_H2H: 'Mission_type_h2h',
  MISSION_TYPE_D2D: 'Mission_type_d2d',
  WITHHOLD_PAY_TRUE: 'Withhold_pay_true',
  WITHHOLD_PAY_FALSE: 'Withhold_pay_false',
  FORCE_FIXED_TRUE: 'Force_fixed_true',
  FORCE_FIXED_FALSE: 'Force_fixed_false',
}

export const USER_PROFILE_LOGS_LABELS = {
  warning: 'Warning',
  block: 'Block',
  unbook_all_missions: 'Unbook all missions',
  shadow_ban: 'Shadow ban',
  shadow_ban_disabled: 'Shadow ban disabled',
  approve: 'Approve',
  refuse: 'Refuse',
  mission_type_all: 'Mission type all',
  mission_type_h2h: 'Mission type H2H',
  mission_type_d2d: 'Mission type D2D',
  withhold_pay_true: 'Withhold pay TRUE',
  withhold_pay_false: 'Withhold pay FALSE',
  force_fixed_true: 'Force fixed TRUE',
}

export const PLACEHOLDER_LABELS = {
  [Object.keys({ BA_FIRST_NAME })[KEY_INDEX]]: 'First Name',
  [Object.keys({ BA_LAST_NAME })[KEY_INDEX]]: 'Last Name',
  [Object.keys({ BA_EMAIL })[KEY_INDEX]]: 'Email',
  [Object.keys({ BA_PHONE })[KEY_INDEX]]: 'Phone #',
  [Object.keys({ BA_SIGNUP_DATE })[KEY_INDEX]]: 'Signup Date',
  [Object.keys({ BA_ONBOARDING_DATE })[KEY_INDEX]]: 'Onboarding date',
  [Object.keys({ BA_ONBOARDING_TIME })[KEY_INDEX]]: 'Onboarding time',
  [Object.keys({ BA_STATUS })[KEY_INDEX]]: 'BA Status',
  [Object.keys({ BA_MERCHANDISE_HELD })[KEY_INDEX]]: 'Merchandise held',
  [Object.keys({ BA_NEXT_MISSION_DATE })[KEY_INDEX]]: 'Next mission Date',
  [Object.keys({ BA_NEXT_MISSION_TIME })[KEY_INDEX]]: 'Next mission time',
  [Object.keys({ BA_NEXT_MISSION_TYPE })[KEY_INDEX]]: 'Next mission type',
  [Object.keys({ BA_NEXT_MISSION_LOCATION })[KEY_INDEX]]:
    'Next mission location',
  [Object.keys({ BA_NEXT_MISSION_CLIENT })[KEY_INDEX]]: 'Next mission client',
  [Object.keys({ BA_NEXT_MISSION_PAY_RATIO })[KEY_INDEX]]:
    'Next mission pay ratio',
  [Object.keys({ BA_LAST_MISSION_TIME })[KEY_INDEX]]: 'Last mission time',
  [Object.keys({ BA_LAST_MISSION_DATE })[KEY_INDEX]]: 'Last mission date',
  [Object.keys({ BA_MONEY_EARNED })[KEY_INDEX]]: 'BA money earned',
  [Object.keys({ BA_MISSION_MEETING_POINT_ADDRESS })[KEY_INDEX]]:
    'Next Meeting Point Address/Location',
  [Object.keys({ BA_MISSION_MEETING_POINT_DATE })[KEY_INDEX]]:
    'Next Meeting Point Date',
  [Object.keys({ BA_MISSION_MEETING_POINT_TIME })[KEY_INDEX]]:
    'Next Meeting Point Time',
  [Object.keys({ CITY_NAME })[KEY_INDEX]]: 'BA City Name',
  [Object.keys({ CITY_PICKUP_LOCATION_LINK })[KEY_INDEX]]:
    'Pickup location (link)',
  [Object.keys({ CITY_NEXT_PICKUP_DATE })[KEY_INDEX]]: 'Next pickup Date',
  [Object.keys({ CITY_NEXT_PICKUP_TIME })[KEY_INDEX]]: 'Next pickup time',
  [Object.keys({ CITY_BAD_WEATHER_WEEK })[KEY_INDEX]]: 'Bad weather week',
  [Object.keys({ CITY_BAD_WEATHER_WEEK_TARGET })[KEY_INDEX]]: 'BWS target',
  [Object.keys({ CITY_BAD_WEATHER_PAYOUT })[KEY_INDEX]]: 'Bad weather payout',
  [Object.keys({ CITY_BA_REFERRAL_START_DATE })[KEY_INDEX]]:
    'BA Referral START DATE',
  [Object.keys({ CITY_BA_REFERRAL_TRIGGER })[KEY_INDEX]]: 'BA Referral TRIGGER',
  [Object.keys({ CITY_BA_REFERRAL_REWARD })[KEY_INDEX]]: 'BA Referral REWARD',
  [Object.keys({ CITY_MISSION_AVAILABLE })[KEY_INDEX]]: '# mission available',
  [Object.keys({ CITY_BA_ONBOARDING_LINK })[KEY_INDEX]]: 'BA Onboarding link',
  [Object.keys({ DEEPLINK_APP_STORE })[KEY_INDEX]]: 'App store link',
  [Object.keys({ DEEPLINK_APP_UPDATE })[KEY_INDEX]]: 'App Update',
  [Object.keys({ DEEPLINK_UPLOAD_PICTURE })[KEY_INDEX]]: 'Upload picture',
  [Object.keys({ DEEPLINK_ABN })[KEY_INDEX]]: 'ABN',
  [Object.keys({ DEEPLINK_BANK_DETAILS })[KEY_INDEX]]: 'Bank details',
  [Object.keys({ DEEPLINK_CONTACT_DETAILS })[KEY_INDEX]]: 'Contact Details',
  [Object.keys({ DEEPLINK_SET_BASES })[KEY_INDEX]]: 'Set Bases',
  [Object.keys({ DEEPLINK_EARNINGS })[KEY_INDEX]]: 'Earnings',
  [Object.keys({ DEEPLINK_AVAILABILITY })[KEY_INDEX]]: 'Availability',
  [Object.keys({ DEEPLINK_PAUSE_AVAILABILITY })[KEY_INDEX]]:
    'Pause availability',
  [Object.keys({ DEEPLINK_BOOK_MISSION })[KEY_INDEX]]: 'Book a Mission',
  [Object.keys({ DEEPLINK_UPCOMING_MISSION })[KEY_INDEX]]: 'Upcoming missions',
  [Object.keys({ DEEPLINK_MISSION_CHECKIN })[KEY_INDEX]]: 'Mission Checkin',
  [Object.keys({ DEEPLINK_SURGE_TIME })[KEY_INDEX]]: 'Surge Time',
  [Object.keys({ DEEPLINK_COMPLETED_MISSIONS })[KEY_INDEX]]:
    'Completed missions',
  [Object.keys({ DEEPLINK_HOW_TO_GUIDE })[KEY_INDEX]]: 'How to guide',
  [Object.keys({ DEEPLINK_TERMS_OF_SERVICE })[KEY_INDEX]]: 'Terms of Service',
  [Object.keys({ DEEPLINK_PRIVACY_POLICY })[KEY_INDEX]]: 'Privacy Policy',
  [Object.keys({ DEEPLINK_PICKUP_LOCATION })[KEY_INDEX]]:
    'Next Pickup Location',
  [Object.keys({ DEEPLINK_PICKUP_TIME })[KEY_INDEX]]: 'Next Pickup Time',
  [Object.keys({ DEEPLINK_MISSION_LOCATION })[KEY_INDEX]]:
    'Next Mission Location',
  [Object.keys({ DEEPLINK_CLIENT_PITCH })[KEY_INDEX]]:
    'Client Pitch for the next mission',
  [Object.keys({ DEEPLINK_REFER_FRIEND })[KEY_INDEX]]: 'Refer a Friend',
  [Object.keys({ DEEPLINK_PAYMENT_DATE })[KEY_INDEX]]: 'Payment Date',
  [Object.keys({ DEEPLINK_PICKUP_SCANNER })[KEY_INDEX]]: 'Pick Up Scanner Page',
  [Object.keys({ DEEPLINK_CHAT })[KEY_INDEX]]: 'App Chat',
  [Object.keys({ DEEPLINK_MY_MISSIONS })[KEY_INDEX]]: 'My Missions',
  [Object.keys({ DEEPLINK_BROWSE_MISSIONS_H2H })[KEY_INDEX]]:
    'Browse Missions Hand to Hand',
  [Object.keys({ DEEPLINK_BROWSE_MISSIONS_LTB })[KEY_INDEX]]:
    'Browse Missions Letterbox',
  [Object.keys({ DEEPLINK_MY_COMPLETED_MISSIONS })[KEY_INDEX]]:
    'My Completed Missions',
  [Object.keys({ DEEPLINK_REBOOK_ONBOARDING })[KEY_INDEX]]: 'Rebook Onboarding',
}

export const PLACEHOLDER_KEYS = {
  [BA_FIRST_NAME]: Object.keys({ BA_FIRST_NAME })[KEY_INDEX],
  [BA_LAST_NAME]: Object.keys({ BA_LAST_NAME })[KEY_INDEX],
  [BA_EMAIL]: Object.keys({ BA_EMAIL })[KEY_INDEX],
  [BA_PHONE]: Object.keys({ BA_PHONE })[KEY_INDEX],
  [BA_SIGNUP_DATE]: Object.keys({ BA_SIGNUP_DATE })[KEY_INDEX],
  [BA_ONBOARDING_DATE]: Object.keys({ BA_ONBOARDING_DATE })[KEY_INDEX],
  [BA_ONBOARDING_TIME]: Object.keys({ BA_ONBOARDING_TIME })[KEY_INDEX],
  [BA_STATUS]: Object.keys({ BA_STATUS })[KEY_INDEX],
  [BA_MERCHANDISE_HELD]: Object.keys({ BA_MERCHANDISE_HELD })[KEY_INDEX],
  [BA_NEXT_MISSION_DATE]: Object.keys({ BA_NEXT_MISSION_DATE })[KEY_INDEX],
  [BA_NEXT_MISSION_TIME]: Object.keys({ BA_NEXT_MISSION_TIME })[KEY_INDEX],
  [BA_NEXT_MISSION_TYPE]: Object.keys({ BA_NEXT_MISSION_TYPE })[KEY_INDEX],
  [BA_NEXT_MISSION_LOCATION]: Object.keys({ BA_NEXT_MISSION_LOCATION })[
    KEY_INDEX
  ],
  [BA_NEXT_MISSION_CLIENT]: Object.keys({ BA_NEXT_MISSION_CLIENT })[KEY_INDEX],
  [BA_NEXT_MISSION_PAY_RATIO]: Object.keys({ BA_NEXT_MISSION_PAY_RATIO })[
    KEY_INDEX
  ],
  [BA_LAST_MISSION_TIME]: Object.keys({ BA_LAST_MISSION_TIME })[KEY_INDEX],
  [BA_LAST_MISSION_DATE]: Object.keys({ BA_LAST_MISSION_DATE })[KEY_INDEX],
  [BA_MONEY_EARNED]: Object.keys({ BA_MONEY_EARNED })[KEY_INDEX],
  [CITY_NAME]: Object.keys({ CITY_NAME })[KEY_INDEX],
  [CITY_PICKUP_LOCATION_LINK]: Object.keys({ CITY_PICKUP_LOCATION_LINK })[
    KEY_INDEX
  ],
  [CITY_NEXT_PICKUP_DATE]: Object.keys({ CITY_NEXT_PICKUP_DATE })[KEY_INDEX],
  [CITY_NEXT_PICKUP_TIME]: Object.keys({ CITY_NEXT_PICKUP_TIME })[KEY_INDEX],
  [CITY_BAD_WEATHER_WEEK]: Object.keys({ CITY_BAD_WEATHER_WEEK })[KEY_INDEX],
  [CITY_BAD_WEATHER_PAYOUT]: Object.keys({ CITY_BAD_WEATHER_PAYOUT })[
    KEY_INDEX
  ],
  [CITY_BAD_WEATHER_WEEK_TARGET]: Object.keys({
    CITY_BAD_WEATHER_WEEK_TARGET,
  })[KEY_INDEX],
  [CITY_BA_REFERRAL_START_DATE]: Object.keys({
    CITY_BA_REFERRAL_START_DATE,
  })[KEY_INDEX],
  [CITY_BA_REFERRAL_TRIGGER]: Object.keys({ CITY_BA_REFERRAL_TRIGGER })[
    KEY_INDEX
  ],
  [CITY_BA_REFERRAL_REWARD]: Object.keys({ CITY_BA_REFERRAL_REWARD })[
    KEY_INDEX
  ],
  [CITY_MISSION_AVAILABLE]: Object.keys({ CITY_MISSION_AVAILABLE })[KEY_INDEX],
  [CITY_BA_ONBOARDING_LINK]: Object.keys({ CITY_BA_ONBOARDING_LINK })[
    KEY_INDEX
  ],
  [DEEPLINK_APP_STORE]: Object.keys({ DEEPLINK_APP_STORE })[KEY_INDEX],
  [DEEPLINK_APP_UPDATE]: Object.keys({ DEEPLINK_APP_UPDATE })[KEY_INDEX],
  [DEEPLINK_UPLOAD_PICTURE]: Object.keys({ DEEPLINK_UPLOAD_PICTURE })[
    KEY_INDEX
  ],
  [DEEPLINK_ABN]: Object.keys({ DEEPLINK_ABN })[KEY_INDEX],
  [DEEPLINK_BANK_DETAILS]: Object.keys({ DEEPLINK_BANK_DETAILS })[KEY_INDEX],
  [DEEPLINK_CONTACT_DETAILS]: Object.keys({ DEEPLINK_CONTACT_DETAILS })[
    KEY_INDEX
  ],
  [DEEPLINK_SET_BASES]: Object.keys({ DEEPLINK_SET_BASES })[KEY_INDEX],
  [DEEPLINK_EARNINGS]: Object.keys({ DEEPLINK_EARNINGS })[KEY_INDEX],
  [DEEPLINK_AVAILABILITY]: Object.keys({ DEEPLINK_AVAILABILITY })[KEY_INDEX],
  [DEEPLINK_PAUSE_AVAILABILITY]: Object.keys({
    DEEPLINK_PAUSE_AVAILABILITY,
  })[KEY_INDEX],
  [DEEPLINK_BOOK_MISSION]: Object.keys({ DEEPLINK_BOOK_MISSION })[KEY_INDEX],
  [DEEPLINK_UPCOMING_MISSION]: Object.keys({ DEEPLINK_UPCOMING_MISSION })[
    KEY_INDEX
  ],
  [DEEPLINK_MISSION_CHECKIN]: Object.keys({ DEEPLINK_MISSION_CHECKIN })[
    KEY_INDEX
  ],
  [DEEPLINK_SURGE_TIME]: Object.keys({ DEEPLINK_SURGE_TIME })[KEY_INDEX],
  [DEEPLINK_COMPLETED_MISSIONS]: Object.keys({
    DEEPLINK_COMPLETED_MISSIONS,
  })[KEY_INDEX],
  [DEEPLINK_HOW_TO_GUIDE]: Object.keys({ DEEPLINK_HOW_TO_GUIDE })[KEY_INDEX],
  [DEEPLINK_TERMS_OF_SERVICE]: Object.keys({ DEEPLINK_TERMS_OF_SERVICE })[
    KEY_INDEX
  ],
  [DEEPLINK_PRIVACY_POLICY]: Object.keys({ DEEPLINK_PRIVACY_POLICY })[
    KEY_INDEX
  ],
  [DEEPLINK_PICKUP_LOCATION]: Object.keys({ DEEPLINK_PICKUP_LOCATION })[
    KEY_INDEX
  ],
  [DEEPLINK_PICKUP_TIME]: Object.keys({ DEEPLINK_PICKUP_TIME })[KEY_INDEX],
  [DEEPLINK_MISSION_LOCATION]: Object.keys({ DEEPLINK_MISSION_LOCATION })[
    KEY_INDEX
  ],
  [DEEPLINK_CLIENT_PITCH]: Object.keys({ DEEPLINK_CLIENT_PITCH })[KEY_INDEX],
  [DEEPLINK_REFER_FRIEND]: Object.keys({ DEEPLINK_REFER_FRIEND })[KEY_INDEX],
  [DEEPLINK_PAYMENT_DATE]: Object.keys({ DEEPLINK_PAYMENT_DATE })[KEY_INDEX],
  [DEEPLINK_PICKUP_SCANNER]: Object.keys({ DEEPLINK_PICKUP_SCANNER })[
    KEY_INDEX
  ],
  [DEEPLINK_CHAT]: Object.keys({ DEEPLINK_CHAT })[KEY_INDEX],
  [DEEPLINK_MY_MISSIONS]: Object.keys({ DEEPLINK_MY_MISSIONS })[KEY_INDEX],
  [DEEPLINK_BROWSE_MISSIONS_H2H]: Object.keys({ DEEPLINK_BROWSE_MISSIONS_H2H })[
    KEY_INDEX
  ],
  [DEEPLINK_BROWSE_MISSIONS_LTB]: Object.keys({ DEEPLINK_BROWSE_MISSIONS_LTB })[
    KEY_INDEX
  ],
  [DEEPLINK_MY_COMPLETED_MISSIONS]: Object.keys({
    DEEPLINK_MY_COMPLETED_MISSIONS,
  })[KEY_INDEX],
  [DEEPLINK_REBOOK_ONBOARDING]: Object.keys({ DEEPLINK_REBOOK_ONBOARDING })[
    KEY_INDEX
  ],
}

const placeholdersDeepLinksKeys = [
  'DEEPLINK_ABN',
  'DEEPLINK_APP_UPDATE',
  'DEEPLINK_APP_STORE',
  'DEEPLINK_AVAILABILITY',
  'DEEPLINK_BANK_DETAILS',
  'DEEPLINK_BOOK_MISSION',
  'DEEPLINK_HOW_TO_GUIDE',
  'DEEPLINK_SET_BASES',
  'DEEPLINK_COMPLETED_MISSIONS',
  'DEEPLINK_CONTACT_DETAILS',
  'DEEPLINK_EARNINGS',
  'DEEPLINK_UPCOMING_MISSION',
  'DEEPLINK_MISSION_CHECKIN',
  'DEEPLINK_PAUSE_AVAILABILITY',
  'DEEPLINK_PRIVACY_POLICY',
  'DEEPLINK_SURGE_TIME',
  'DEEPLINK_TERMS_OF_SERVICE',
  'DEEPLINK_UPLOAD_PICTURE',
  'DEEPLINK_PICKUP_LOCATION',
  'DEEPLINK_PICKUP_TIME',
  'DEEPLINK_MISSION_LOCATION',
  'DEEPLINK_CLIENT_PITCH',
  'DEEPLINK_REFER_FRIEND',
  'DEEPLINK_PAYMENT_DATE',
  'DEEPLINK_PICKUP_SCANNER',
  'DEEPLINK_CHAT',
  'DEEPLINK_MY_MISSIONS',
  'DEEPLINK_BROWSE_MISSIONS_H2H',
  'DEEPLINK_BROWSE_MISSIONS_LTB',
  'DEEPLINK_MY_COMPLETED_MISSIONS',
  'DEEPLINK_REBOOK_ONBOARDING',
]

export const isPlaceholderKeyDeepLink = placeholderKey => {
  return placeholdersDeepLinksKeys.includes(placeholderKey)
}

export const defaultDynamicVariablesValues = {
  BA_FIRST_NAME: 'BA name not found',
  BA_LAST_NAME: 'BA last name not found',
  BA_EMAIL: 'BA email not found',
  BA_PHONE: 'BA phone not found',
  BA_SIGNUP_DATE: 'BA sign up date not found',
  BA_ONBOARDING_DATE: 'BA onboarding date not found',
  BA_ONBOARDING_TIME: 'BA onboarding time not found',
  BA_STATUS: 'BA status not found',
  BA_MERCHANDISE_HELD: 'BA merchandise held not found',
  BA_NEXT_MISSION_DATE: 'BA next mission date not found',
  BA_NEXT_MISSION_TIME: 'BA next mission time not found',
  BA_NEXT_MISSION_TYPE: 'BA next mission type not found',
  BA_NEXT_MISSION_LOCATION: 'BA next mission location not found',
  BA_NEXT_MISSION_CLIENT: 'BA next mission client not found',
  BA_NEXT_MISSION_PAY_RATIO: 'BA next mission payout ratio not found',
  BA_LAST_MISSION_TIME: 'BA last mission time not found',
  BA_LAST_MISSION_DATE: 'BA last mission date not found',
  BA_MONEY_EARNED: 'BA money earned not found',
  CITY_NAME: 'BA city name not found',
  CITY_PICKUP_LOCATION_LINK: 'Pickup location link not found',
  CITY_NEXT_PICKUP_DATE: 'Next pickup date not found',
  CITY_NEXT_PICKUP_TIME: 'Next pickup time not found',
  CITY_BAD_WEATHER_WEEK: 'Bad weather week not found',
  CITY_BAD_WEATHER_WEEK_TARGET: 'Bad weather week target not found',
  CITY_BAD_WEATHER_PAYOUT: 'Bad weather payout not found',
  CITY_BA_REFERRAL_START_DATE: 'BA referral start date not found',
  CITY_BA_REFERRAL_TRIGGER: 'BA referral trigger not found',
  CITY_BA_REFERRAL_REWARD: 'BA referral reward not found',
  CITY_MISSION_AVAILABLE: 'Mission available not found',
  CITY_BA_ONBOARDING_LINK: 'BA onboarding link not found',
  DEEPLINK_APP_STORE: 'App store link not found',
  DEEPLINK_APP_UPDATE: 'App update link not found',
  DEEPLINK_UPLOAD_PICTURE: 'Upload picture link not found',
  DEEPLINK_ABN: 'ABN link not found',
  DEEPLINK_BANK_DETAILS: 'Bank details link not found',
  DEEPLINK_CONTACT_DETAILS: 'Contact details link not found',
  DEEPLINK_SET_BASES: 'Set bases link not found',
  DEEPLINK_EARNINGS: 'Earnings not found',
  DEEPLINK_AVAILABILITY: 'Availability not found',
  DEEPLINK_PAUSE_AVAILABILITY: 'Pause availability not found',
  DEEPLINK_BOOK_MISSION: 'Book mission link not found',
  DEEPLINK_UPCOMING_MISSION: 'Upcoming mission link not found',
  DEEPLINK_MISSION_CHECKIN: 'Mission checkin link not found',
  DEEPLINK_SURGE_TIME: 'Surge time link not found',
  DEEPLINK_COMPLETED_MISSIONS: 'Completed missions link not found',
  DEEPLINK_HOW_TO_GUIDE: 'How to guide link not found',
  DEEPLINK_TERMS_OF_SERVICE: 'Terms of service link not found',
  DEEPLINK_PRIVACY_POLICY: 'Privacy policy link not found',
}

export const TALK_JS_CHAT_TYPES_MAP = {
  CITY_MANAGERS: 'cityManagers',
  SUPPORT: 'support',
  CITY: 'city',
  COUNTRY: 'country',
  MISSION_REPORT: 'missionReport',
  SPY_TO_BA: 'spyToBa',
  GROUP: 'group',
}
export const SERVICES_ENUM = {
  NO_SERVICE: 'NO_SERVICE',
  INVOKER: 'INVOKER',
}

export const PICKUP_CODE_ERROR_TYPES_MAP = {
  ALREADY_USED_IN_MISSION: 'usedInMission',
  ALREADY_IN_USER_INVENTORY: 'alreadyInInventory',
  ASSIGNED_TO_ANOTHER_USER: 'assignedOnAnotherUser',
  ANY_BOOKED_MISSION_ON_BA: 'anyBookedMission',
  ENOUGH_PACKS_ON_BA: 'enoughFlyerPacks',
  NOT_SAME_CITY: 'notSameCity',
}

export const DocumentFormats = {
  A5: 'A5',
  A6: 'A6',
  DOOR_HANGER: 'DOOR_HANGER',
  TEARAWAY: 'TEARAWAY',
  DL: 'DL',
}

export const DocumentNames = {
  A5: 'A5',
  A6: 'A6',
  DOOR_HANGER: 'Door hanger',
  TEARAWAY: 'Tearaway',
  DL: 'DL',
}

export const DMDocumentFormats = {
  SMALL: 'SMALL',
  BEST_SELLER: 'BEST_SELLER',
  LARGE: 'LARGE',
  JUMBO: 'JUMBO',
  OVERSIZED: 'OVERSIZED',
}

export const DMDocumentLabels = {
  SMALL: 'Small: 4.25” x 11”',
  BEST_SELLER: 'Best seller: 6.25” x 9”',
  LARGE: 'Large: 6.25” x 11”',
  JUMBO: 'Jumbo: 8.5” x 11”',
  OVERSIZED: 'Oversized: 12” x 15”',
}

export const ADMDocumentFormats = {
  POSTCARD_6x4: 'POSTCARD_6x4',
  POSTCARD_9x6: 'POSTCARD_9x6',
  POSTCARD_11x6: 'POSTCARD_11x6',
  POSTCARD_15x12: 'POSTCARD_15x12',
}

export const ADMDocumentLabels = {
  POSTCARD_6x4: 'Postcard: 6” x 4”',
  POSTCARD_9x6: 'Postcard: 9” x 6”',
  POSTCARD_11x6: 'Postcard: 11” x 6”',
  POSTCARD_15x12: 'Postcard: 15” x 12”',
}

export const AggregationCostLabels = {
  DATA_COST: 'Rate of Data Cost',
  TOTAL_DATA_COST: 'Total Cost of Data',
}

export const PrintersLabels = {
  name: 'Printers',
  availableStates: 'States',
  region: 'Region',
  actions: 'Actions',
}

export const StatesRegions = {
  southeast: 'South East',
  midwest: 'Mid West',
  west: 'West',
  northeast: 'North East',
  southwest: 'South West',
}

export const WITHOUT_TIMESTAMP = 1
export const WITH_TIMESTAMP = 2
export const WEBHOOK = 3
export const NO_TYPE = 0

export const CONVERSION_REPORT_TYPE = {
  WITHOUT_TIMESTAMP: 'WITHOUT_TIMESTAMP',
  WITH_TIMESTAMP: 'WITH_TIMESTAMP',
  WEBHOOK: 'WEBHOOK',
  NO_TYPE: 'NO_TYPE',
}

export const CONVERSION_REPORT_TYPE_SHOW = {
  [CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP]: 'Without timestamps',
  [CONVERSION_REPORT_TYPE.WITH_TIMESTAMP]: 'With timestamps',
  [CONVERSION_REPORT_TYPE.WEBHOOK]: 'Webhook',
  [CONVERSION_REPORT_TYPE.NO_TYPE]: 'No Type',
}

export const CONVERSION_REPORT_TYPE_ENUM_MAP = {
  [CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP]: WITHOUT_TIMESTAMP,
  [CONVERSION_REPORT_TYPE.WITH_TIMESTAMP]: WITH_TIMESTAMP,
  [CONVERSION_REPORT_TYPE.WEBHOOK]: WEBHOOK,
  [CONVERSION_REPORT_TYPE.NO_TYPE]: NO_TYPE,
}

export const CONVERSION_REPORT_TYPE_TO_ENUM = {
  [WITHOUT_TIMESTAMP]: CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP,
  [WITH_TIMESTAMP]: CONVERSION_REPORT_TYPE.WITH_TIMESTAMP,
  [WEBHOOK]: CONVERSION_REPORT_TYPE.WEBHOOK,
  [NO_TYPE]: CONVERSION_REPORT_TYPE.NO_TYPE,
}

export const CONVERSION_LOG_SUCCESSED = 0
export const CONVERSION_LOG_DELETED = 1

export const CONVERSION_LOG_STATUS = {
  SUCCESSED: 'Success',
  DELETED: 'Deleted',
}

export const CONVERSION_LOG_STATUS_ENUM_MAP = {
  [CONVERSION_LOG_STATUS.SUCCESSED]: CONVERSION_LOG_SUCCESSED,
  [CONVERSION_LOG_STATUS.DELETED]: CONVERSION_LOG_DELETED,
}

export const CONVERSION_LOG_STATUS_TO_ENUM = {
  [CONVERSION_LOG_SUCCESSED]: CONVERSION_LOG_STATUS.SUCCESSED,
  [CONVERSION_LOG_DELETED]: CONVERSION_LOG_STATUS.DELETED,
}

export const CAMPAIGN_INTERNAL_STATUSES = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  UPLOAD_CODES: 'UPLOAD_CODES',
  UPLOAD_CODES_DECLINED: 'UPLOAD_CODES_DECLINED',
  CODE_REVIEW: 'CODE_REVIEW',
  GENERATING_DIGITAL_PROOF: 'GENERATING_DIGITAL_PROOF',
  PENDING_DIGITAL_PROOF: 'PENDING_DIGITAL_PROOF',
  PAYMENT: 'PAYMENT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
  REJECTED: 'REJECTED',
}

/** means last completed step */
export const CAMPAIGN_LAST_ACTIVE_STEPS = {
  HOME: 'home',
  SEGMENTS: 'segments',
  AUDIENCE: 'audience',
  DESIGN: 'design',
  DETAILS: 'details',
  SUBMIT: 'submit',
}

/** steps shown in the draft board section */
export const CAMPAIGN_DRAFT_STEPS = {
  HOME: 'home',
  ENTRY: 'entry', // segments and audience
  DESIGN: 'design',
  DETAILS: 'details',
  REJECTED: 'rejected',
}

export const CAMPAIGN_DOCUMENT_TYPES = {
  STATEMENT_OF_WORK: 'STATEMENT_OF_WORK',
  DIGITAL_PROOF_FROM_PRINTER: 'DIGITAL_PROOF_FROM_PRINTER',
  DIGITAL_PROOF_SIGNED_BY_CLIENT: 'DIGITAL_PROOF_SIGNED_BY_CLIENT',
}

export const DAY_INDEX_MAP = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
}

export const AVAILABILITY_JOB_STATUS = {
  CREATED_RECORDS: 1,
  NO_RECORDS: 0,
}

export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE = 1
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE = 2
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE = 3
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE = 4
export const NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE = 5
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE = 6
export const USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_TYPE = 7
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_TYPE = 8
export const USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_TYPE = 9
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_TYPE = 10
export const USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_TYPE = 11
export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 12
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 13
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 14
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 15
export const NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 16
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 17
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 18
export const USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 19
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 20
export const USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_TYPE = 21
export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE = 22
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_TYPE = 23
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE = 24
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE = 25
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE = 26
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_TYPE = 27
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_TYPE = 28
export const WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_TYPE = 29
export const NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_TYPE = 30
export const NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_TYPE = 31
export const NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_TYPE = 32
export const NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 33
export const NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 34
export const NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 35
export const NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_TYPE = 36
export const NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_TYPE = 37
export const USER_IS_APPROVED_EMAIL_OPEN_APP_TYPE = 38
export const USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_TYPE = 39
export const NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_TYPE = 40
export const NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_TYPE = 41
export const NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_TYPE = 42
export const NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 43
export const NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 44
export const NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE = 45
export const NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_TYPE = 46
export const NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_TYPE = 47

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_TYPE = 48
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_TYPE = 49
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_TYPE = 50

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_TYPE = 51
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_TYPE = 52
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_TYPE = 53

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_TYPE = 54
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_TYPE = 55
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_TYPE = 56
export const REFUSE_NOTIFICATION_EMAIL_OPEN_APP_TYPE = 57

export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP'
export const USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_ENUM =
  'USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP'
export const USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_ENUM =
  'USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP'
export const NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP'
export const USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_ENUM =
  'USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP'
export const WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_ENUM =
  'WELCOME_TO_OPPIZI_EMAIL_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP'
export const NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP'
export const USER_IS_APPROVED_EMAIL_OPEN_APP_ENUM =
  'USER_IS_APPROVED_EMAIL_OPEN_APP'
export const USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP'
export const NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP'

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP'

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP'

export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP'
export const NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_ENUM =
  'NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP'
export const REFUSE_NOTIFICATION_EMAIL_OPEN_APP_ENUM =
  'REFUSE_NOTIFICATION_EMAIL_OPEN_APP'

export const VIDEO_ONBOARDING_OPEN_APP_ENUM_TO_TYPES_MAP = {
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_ENUM]: USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_ENUM]: USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_ENUM]: USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM]: NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_TYPE,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_ENUM]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_TYPE,
  [WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_ENUM]: WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_ENUM]: NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_TYPE,
  [USER_IS_APPROVED_EMAIL_OPEN_APP_ENUM]: USER_IS_APPROVED_EMAIL_OPEN_APP_TYPE,
  [USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_ENUM]: USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_ENUM]: NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_TYPE,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_ENUM]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_TYPE,
  [REFUSE_NOTIFICATION_EMAIL_OPEN_APP_ENUM]: REFUSE_NOTIFICATION_EMAIL_OPEN_APP_TYPE,
}

export const VIDEO_ONBOARDING_OPEN_APP_TYPES_TO_ENUM_MAP = {
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_TYPE]: USER_PASS_VIDEO_ONBOARDING_EMAIL_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_TYPE]: USER_UPLOAD_ALL_DOC_EMAIL_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_TYPE]: USER_UPLOAD_ALL_DOC_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_3_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_1_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_TYPE]: NOT_START_VIDEO_ONBOARDING_7_DAYS_SMS_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_1_DAYS_SMS_OPEN_APP_ENUM,
  [USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_TYPE]: USER_NOT_UPLOAD_ALL_DOCS_7_DAYS_SMS_OPEN_APP_ENUM,
  [WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_TYPE]: WELCOME_TO_OPPIZI_EMAIL_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_1_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_TYPE]: NOT_ONBOARDING_BOOKED_7_DAYS_SMS_OPEN_APP_ENUM,
  [USER_IS_APPROVED_EMAIL_OPEN_APP_TYPE]: USER_IS_APPROVED_EMAIL_OPEN_APP_ENUM,
  [USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_TYPE]: USER_IS_APPROVED_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_1_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_3_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_7_DAYS_PUSH_NOTIFICATION_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_1_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_TYPE]: NOT_BOOK_FIRST_MISSION_7_DAYS_SMS_OPEN_APP_ENUM,

  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_SMS_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_PUSH_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_PUSH_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_PUSH_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_1_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_3_DAYS_EMAIL_OPEN_APP_ENUM,
  [NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_TYPE]: NOT_COMPLETE_VIDEO_ONBOARDING_QUIZ_7_DAYS_EMAIL_OPEN_APP_ENUM,
  [REFUSE_NOTIFICATION_EMAIL_OPEN_APP_TYPE]: REFUSE_NOTIFICATION_EMAIL_OPEN_APP_ENUM,
}

export const EVENT = {
  CHECKOUT_SPY_SHIFTS: '[CHECKOUT_SPY_SHIFTS]',
}

export const MOCK_PHONE_NUMBER = 'MOCK_PHONE_NUMBER'

export const ACTION = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH_NOTIFICATION: 'NOTIFICATION',
}

export const ACTION_TYPE = {
  EMAIL: 1,
  SMS: 2,
  PUSH_NOTIFICATION: 3,
}
export const CONTACT_US_MOBILE_SCREENS = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  ELIGIBILITY: 'ELIGIBILITY',
  CONGRATULATIONS: 'CONGRATULATIONS',
  RECRUITMENT_ON_HOLD: 'RECRUITMENT_ON_HOLD',
  DOCUMENT_CHECK: 'DOCUMENT_CHECK',
}

export const CONTACT_US_MOBILE_SCREENS_TEXT = {
  EMAIL_VERIFICATION: 'Email verification',
  ELIGIBILITY: 'Eligibility',
  CONGRATULATIONS: 'Congratulations',
  RECRUITMENT_ON_HOLD: 'Recruitment on hold',
  DOCUMENT_CHECK: 'Pre-access documents screen',
}

export const FILTERED_COUNTRIES_SIGN_UP = ['Mexico', 'Azeroth']

export const LOG_TYPES_MAP = {
  USER_ACTION: 'USER_ACTION',
  USER_DOCUMENT_ACTION: 'USER_DOCUMENT_ACTION',
}

export const USER_DOCUMENT_ACTION_LOG_TYPES_MAP = {
  UPLOAD: 'UPLOAD',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  DELETE: 'DELETE',
  MARK_PRIMARY: 'MARK_PRIMARY',
}

export const USER_ACTION_LOG_TYPES_MAP = {
  APPROVE: 'APPROVE',
  REFUSE: 'REFUSE',
  BLOCK: 'BLOCK',
  FADE: 'FADE',
}

export const MONTHS_LIST = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const STATUS_FILTER_OPTIONS = [
  { label: 'Active', value: STATUS_CAMPAIGN_ENUM_ACTIVE },
  { label: 'Completed', value: STATUS_CAMPAIGN_ENUM_COMPLETED },
  { label: 'Draft', value: STATUS_CAMPAIGN_ENUM_DRAFT },
  { label: 'Archived', value: STATUS_CAMPAIGN_ENUM_ARCHIVE },
]

export const CAMPAIGN_LOG_ENUM_TYPES = {
  CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
  ARCHIVE_CAMPAIGN: 'ARCHIVE_CAMPAIGN',
  APPROVE_CAMPAIGN: 'APPROVE_CAMPAIGN',
  DECLINE_CAMPAIGN: 'DECLINE_CAMPAIGN',
  GENERATE_CODES: 'GENERATE_CODES',
  DELETE_CODES: 'DELETE_CODES',
  APPROVE_CODES: 'APPROVE_CODES',
  UPLOAD_DIGITAL_PROOF: 'UPLOAD_DIGITAL_PROOF',
  DELETE_DIGITAL_PROOF: 'DELETE_DIGITAL_PROOF',
  UPLOAD_STATEMENT_OF_WORK: 'UPLOAD_STATEMENT_OF_WORK',
  DELETE_STATEMENT_OF_WORK: 'DELETE_STATEMENT_OF_WORK',
  ACTIVATE_CAMPAIGN: 'ACTIVATE_CAMPAIGN',
  UPLOAD_PDF_DESIGN: 'UPLOAD_PDF_DESIGN',
  DELETE_PDF_DESIGN: 'DELETE_PDF_DESIGN',
  SET_FLYER_ORIENTATION: 'SET_FLYER_ORIENTATION',
  SET_FLYER_DESIGN_URL: 'SET_FLYER_DESIGN_URL',
  SET_CAMPAIGN_NAME: 'SET_CAMPAIGN_NAME',
  SET_COUPON_CODE: 'SET_COUPON_CODE',
  SET_NAME: 'SET_NAME',
  SET_STATUS: 'SET_STATUS',
  SET_START_DATE: 'SET_START_DATE',
  SET_COST_PER_FLYER: 'SET_COST_PER_FLYER',
  SET_OFFER_EXPIRATION_DATE: 'SET_OFFER_EXPIRATION_DATE',
  SET_REDEMPTION_TIME: 'SET_REDEMPTION_TIME',
  SET_DURATION: 'SET_DURATION',
  SET_EXPIRATION: 'SET_EXPIRATION',
  SKIP_PAYMENT: 'SKIP_PAYMENT',
  SET_BONUS_ALLOWANCE: 'SET_BONUS_ALLOWANCE',
  SET_BONUS_PER_CONVERSION: 'SET_BONUS_PER_CONVERSION',
  SET_CONVERSION_API: 'SET_CONVERSION_API',
  SET_SCAN_DATA: 'SET_SCAN_DATA',
  ADD_METRIC: 'ADD_METRIC',
  DELETE_METRIC: 'DELETE_METRIC',
  SET_RECEIVE_REPORT: 'SET_RECEIVE_REPORT',
  SET_PAYMENT_STATUS: 'SET_PAYMENT_STATUS',
  SET_FLYER_TYPE: 'SET_FLYER_TYPE',
  SET_FLYER_WEIGHT: 'SET_FLYER_WEIGHT',
  ADD_AREA: 'ADD_AREA',
  ADD_LOCATION: 'ADD_LOCATION',
  DELETE_AREA: 'DELETE_AREA',
  DELETE_LOCATION: 'DELETE_LOCATION',
  EDIT_LOCATION: 'EDIT_LOCATION',
  SET_FLYER_URL: 'SET_FLYER_URL',
  SET_LAUNCH_DATE: 'SET_LAUNCH_DATE',
  SET_FLYER_HAS_URL_CHECKBOX: 'SET_FLYER_HAS_URL_CHECKBOX',
  SET_COMMENTS: 'SET_COMMENTS',
  CAMPAIGN_SUBMITTED: 'CAMPAIGN_SUBMITTED',
  EDIT_METRIC: 'EDIT_METRIC',
  CHANGE_PRIMARY_METRIC: 'CHANGE_PRIMARY_METRIC',
  SET_GOAL: 'SET_GOAL',
  SET_BONUS_THRESHOLD: 'SET_BONUS_THRESHOLD',
}

export const INDUSTRY_OPTIONS = {
  AUTOMOTIVE: 'Automotive',
  AGRICULTURE_FORESTRY: 'Agriculture and Forestry',
  CONSULTING_LEGAL_MARKETING: 'Consulting, Legal, Marketing',
  EDUCATION: 'Education',
  ENTERTAINMENT: 'Entertainment',
  ENERGY_MINING: 'Energy and Mining',
  DEFENSE: 'Defense',
  FINANCE: 'Finance',
  GAMBLING: 'Gambling',
  GOVERNMENT: 'Government, Non-profit, and Public Services',
  HEALTH: 'Mental Health, Health and Fitness',
  CHARITIES: 'Non-profit and Charities',
  HOTELS_RESTAURANTS_CAFES: 'Hotels, Restaurants, Cafes',
  UTILITIES: 'Local Services. Utilities',
  MANUFACTURING: 'Manufacturing',
  PHARMACEUTICALS_BIOTECHNOLOGY: 'Pharmaceuticals and Biotechnology',
  REAL_ESTATE: 'Real Estate, Construction',
  RETAIL: 'Retail',
  SPORTS: 'Sports',
  TELECOMMUNICATIONS: 'Telecommunications',
  TECHNOLOGY: 'Technology and IT services',
  TRANSPORT_LOGISTICS: 'Mobility, Transport and Logistics',
  INTERNET: 'Internet',
  E_COMMERCE: 'E-commerce',
  FOOD_BEVERAGE: 'Food & Beverage',
  MOBILITY: 'Mobility',
}

export const INDUSTRY_OPTIONS_EXTENDED = {
  // Old industries for compability, but they are not shown in the Sign up form anymore
  ...INDUSTRY_OPTIONS,

  // New industries
  // Agriculture & Forestry/Wildlife
  AGRICULTURE_FORESTRY: 'Agriculture & Forestry/Wildlife',
  EXTERMINATION_PEST_CONTROL: 'Extermination/Pest Control',
  FARMING_ANIMAL_PRODUCTION: 'Farming(Animal Production)',
  FARMING_CROP_PRODUCTION: 'Farming(Crop Production)',
  FISHING_HUNTING: 'Fishing/Hunting',
  LANDSCAPE_SERVICES: 'Landscape Services',
  LAWN_CARE_SERVICES: 'Lawn Care Services',
  OTHER_AGRICULTURE_FORESTRY: 'Other (Agriculture & Forestry/Wildlife)',

  // Business & Information
  BUSINESS_INFORMATION: 'Business & Information',
  CONSULTANT: 'Consultant',
  EMPLOYMENT_OFFICE: 'Employment Office',
  FUNDRAISERS: 'Fundraisers',
  GOING_OUT_OF_BUSINESS_SALES: 'Going out of Business Sales',
  MARKETING_ADVERTISING: 'Marketing/Advertising',
  NON_PROFIT_ORGANIZATION: 'Non Profit Organization',
  NOTARY_PUBLIC: 'Notary Public',
  ONLINE_BUSINESS: 'Online Business',
  PUBLISHING_SERVICES: 'Publishing Services',
  RECORD_BUSINESS: 'Record Business',
  RETAIL_SALES: 'Retail Sales',
  TECHNOLOGY: 'Technology Services',
  TELEMARKETING: 'Telemarketing',
  TRAVEL_AGENCY: 'Travel Agency',
  VIDEO_PRODUCTION: 'Video Production',
  OTHER_BUSINESS_INFORMATION: 'Other (Business & Information)',

  // Construction/Utilities/Contracting
  CONSTRUCTION_UTILITIES_CONTRACTING: 'Construction/Utilities/Contracting',
  AC_HEATING: 'AC & Heating',
  ARCHITECT: 'Architect',
  BUILDING_CONSTRUCTION: 'Building Construction',
  BUILDING_INSPECTION: 'Building Inspection',
  CONCRETE_MANUFACTURING: 'Concrete Manufacturing',
  CONTRACTOR: 'Contractor',
  ENGINEERING_DRAFTING: 'Engineering/Drafting',
  EQUIPMENT_RENTAL: 'Equipment Rental',
  PLUMBING: 'Plumbing',
  REMODELING: 'Remodeling',
  REPAIR_MAINTENANCE: 'Repair/Maintenance',
  OTHER_CONSTRUCTION_UTILITIES_CONTRACTING:
    'Other (Construction/Utilities/Contracting)',

  // Education
  EDUCATION: 'Education',
  CHILD_CARE_SERVICES: 'Child Care Services',
  COLLEGE_UNIVERSITIES: 'College/Universities',
  COSMETOLOGY_SCHOOL: 'Cosmetology School',
  ELEMENTARY_SECONDARY_EDUCATION: 'Elementary & Secondary Education',
  GED_CERTIFICATION: 'GED Certification',
  PRIVATE_SCHOOL: 'Private School',
  REAL_ESTATE_SCHOOL: 'Real Estate School',
  TECHNICAL_SCHOOL: 'Technical School',
  TRADE_SCHOOL: 'Trade School',
  TUTORING_SERVICES: 'Tutoring Services',
  VOCATIONAL_SCHOOL: 'Vocational School',
  OTHER_EDUCATION: 'Other (Education)',

  // Finance & Insurance
  FINANCE: 'Finance & Insurance',
  ACCOUNTANT: 'Accountant',
  AUDITING: 'Auditing',
  BANK_CREDIT_UNION: 'Bank/Credit Union',
  BOOKKEEPING: 'Bookkeeping',
  CASH_ADVANCES: 'Cash Advances',
  COLLECTION_AGENCY: 'Collection Agency',
  INSURANCE: 'Insurance',
  INVESTOR: 'Investor',
  PAWN_BROKERS: 'Pawn Brokers',
  TAX_PREPARATION: 'Tax Preparation',
  OTHER_FINANCE_INSURANCE: 'Other (Finance & Insurance)',

  // Food and Hospitality
  HOTELS_RESTAURANTS_CAFES: 'Food & Hospitality',
  ALCOHOL_TOBACCO_SALES: 'Alcohol/Tobacco Sales',
  ALCOHOLIC_BEVERAGE_MANUFACTURING: 'Alcoholic Beverage Manufacturing',
  BAKERY: 'Bakery',
  CATERER: 'Caterer',
  FOOD_BEVERAGE: 'Food & Beverage',
  FOOD_BEVERAGE_MANUFACTURING: 'Food/Beverage Manufacturing',
  GROCERY_CONVENIENCE_STORE_GAS_STATION:
    'Grocery/Convenience Store(Gas Station)',
  GROCERY_CONVENIENCE_STORE_NO_GAS_STATION:
    'Grocery/Convenience Store(No Gas Station)',
  HOTELS_MOTELS_CASINO: 'Hotels/Motels(Casino)',
  HOTELS_MOTELS_NO_CASINO: 'Hotels/Motels(No Casino)',
  MOBILE_FOOD_SERVICES: 'Mobile Food Services',
  RESTAURANT_BAR: 'Restaurant/Bar',
  SPECIALTY_FOOD_FRUIT_VEGETABLES: 'Specialty Food(Fruit/Vegetables)',
  SPECIALTY_FOOD_MEAT: 'Specialty Food(Meat)',
  SPECIALTY_FOOD_SEAFOOD: 'Specialty Food(Seafood)',
  TOBACCO_PRODUCT_MANUFACTURING: 'Tobacco Product Manufacturing',
  TRUCK_STOP: 'Truck Stop',
  VENDING_MACHINE: 'Vending Machine',
  OTHER_FOOD_HOSPITALITY: 'Other (Food & Hospitality)',

  // Gaming
  GAMING: 'Gaming',
  AUCTIONEER: 'Auctioneer',
  BOXING_WRESTLING: 'Boxing/Wrestling',
  CASINO_VIDEO_GAMING: 'Casino/Video Gaming',
  RACETRACK: 'Racetrack',
  SPORTS_AGENT: 'Sports Agent',
  OTHER_GAMING: 'Other (Gaming)',

  // Health Services
  HEALTH: 'Health Services',
  ACUPUNCTURIST: 'Acupuncturist',
  ATHLETIC_TRAINER: 'Athletic Trainer',
  CHILD_YOUTH_SERVICES: 'Child/Youth Services',
  CHIROPRACTIC_OFFICE: 'Chiropractic Office',
  DENTISTRY: 'Dentistry',
  ELECTROLYSIS: 'Electrolysis',
  EMBALMER: 'Embalmer',
  EMERGENCY_MEDICAL_SERVICES: 'Emergency Medical Services',
  EMERGENCY_MEDICAL_TRANSPORTATION: 'Emergency Medical Transportation',
  HEARING_AID_DEALERS: 'Hearing Aid Dealers',
  HOME_HEALTH_SERVICES: 'Home Health Services',
  HOSPITAL: 'Hospital',
  MASSAGE_THERAPY: 'Massage Therapy',
  MEDICAL_OFFICE: 'Medical Office',
  MENTAL_HEALTH_SERVICES: 'Mental Health Services',
  NON_EMERGENCY_MEDICAL_TRANSPORTATION: 'Non Emergency Medical Transportation',
  OPTOMETRY: 'Optometry',
  PHARMACY: 'Pharmacy',
  PHYSICAL_THERAPY: 'Physical Therapy',
  PHYSICIANS_OFFICE: 'Physicians Office',
  RADIOLOGY: 'Radiology',
  RESIDENTIAL_CARE_FACILITY: 'Residential Care Facility',
  SPEECH_OCCUPATIONAL_THERAPY: 'Speech/Occupational Therapy',
  SUBSTANCE_ABUSE_SERVICES: 'Substance Abuse Services',
  VETERINARY_MEDICINE: 'Veterinary Medicine',
  VOCATIONAL_REHABILITATION: 'Vocational Rehabilitation',
  WHOLESALE_DRUG_DISTRIBUTION: 'Wholesale Drug Distribution',
  OTHER_HEALTH_SERVICES: 'Other (Health Services)',

  // Motor Vehicle
  AUTOMOTIVE: 'Motor Vehicle',
  AUTOMOTIVE_PART_SALES: 'Automotive Part Sales',
  CAR_WASH_DETAILING: 'Car Wash/Detailing',
  MOTOR_VEHICLE_RENTAL: 'Motor Vehicle Rental',
  MOTOR_VEHICLE_REPAIR: 'Motor Vehicle Repair',
  NEW_MOTOR_VEHICLE_SALES: 'New Motor Vehicle Sales',
  RECREATIONAL_VEHICLE_SALES: 'Recreational Vehicle Sales',
  USED_MOTOR_VEHICLE_SALES: 'Used Motor Vehicle Sales',
  OTHER_MOTOR_VEHICLE: 'Other (Motor Vehicle)',

  // Natural Resources/Environmental
  NATURAL_RESOURCES: 'Natural Resources/Environmental',
  CONSERVATION_ORGANIZATION: 'Conservation Organizations',
  ENVIRONMENTAL_HEALTH: 'Environmental Health',
  LAND_SURVEYING: 'Land Surveying',
  OIL_GAS_DISTRIBUTION: 'Oil & Gas Distribution',
  OIL_GAS_EXTRACTION: 'Oil & Gas Extraction/Production',
  PIPELINE: 'Pipeline',
  WATER_WELL_DRILLING: 'Water Well Drilling',
  OTHER_NATURAL_RESOURCES: 'Other (Natural Resources/Environmental)',

  // Personal Services
  PERSONAL_SERVICES: 'Personal Services',
  ANIMAL_BOARDING: 'Animal Boarding',
  BARBER_SHOP: 'Barber Shop',
  BEAUTY_SALON: 'Beauty Salon',
  CEMETERY: 'Cemetery',
  DIET_CENTER: 'Diet Center',
  DRY_CLEANING_LAUNDRY: 'Dry Cleaning/Laundry',
  ENTERTAINMENT_PARTY_RENTALS: 'Entertainment/Party Rentals',
  EVENT_PLANNING: 'Event Planning',
  FITNESS_CENTER: 'Fitness Center',
  FLORIST: 'Florist',
  FUNERAL_DIRECTOR: 'Funeral Director',
  JANITORIAL_CLEANING_SERVICES: 'Janitorial/Cleaning Services',
  MASSAGE_DAY_SPA: 'Massage/Day Spa',
  NAIL_SALON: 'Nail Salon',
  PERSONAL_ASSISTANT: 'Personal Assistant',
  PHOTOGRAPHY: 'Photography',
  TANNING_SALON: 'Tanning Salon',
  OTHER_PERSONAL_SERVICES: 'Other (Personal Services)',

  // Real Estate & Housing
  REAL_ESTATE: 'Real Estate & Housing',
  HOME_INSPECTION: 'Home Inspection',
  INTERIOR_DESIGN: 'Interior Design',
  MANUFACTURED_HOUSING: 'Manufactured Housing',
  MORTGAGE_COMPANY: 'Mortgage Company',
  PROPERTY_MANAGEMENT: 'Property Management',
  REAL_ESTATE_BROKER_AGENT: 'Real Estate Broker/Agent',
  WAREHOUSE_STORAGE: 'Warehouse/Storage',
  OTHER_REAL_ESTATE_HOUSING: 'Other (Real Estate & Housing)',

  // Safety / Security & Legal
  SAFETY_SECURITY_LEGAL: 'Safety/Security & Legal',
  ATTORNEY: 'Attorney',
  BAIL_BONDS: 'Bail Bonds',
  COURT_REPORTER: 'Court Reporter',
  DRUG_SCREENING: 'Drug Screening',
  LOCKSMITH: 'Locksmith',
  PRIVATE_INVESTIGATOR: 'Private Investigator',
  SECURITY_GUARD: 'Security Guard',
  SECURITY_SYSTEM_SERVICES: 'Security System Services',
  OTHER_SAFETY_SECURITY_LEGAL: 'Other (Safety/Security & Legal)',

  // Transportation
  TRANSPORT_LOGISTICS: 'Transportation',
  AIR_TRANSPORTATION: 'Air Transportation',
  BOAT_SERVICES: 'Boat Services',
  LIMOUSINE_SERVICES: 'Limousine Services',
  MOBILITY: 'Mobility',
  TAXI_SERVICES: 'Taxi Services',
  TOWING: 'Towing',
  TRUCK_TRANSPORTATION: 'Truck Transportation(Fuel)',
  TRUCK_TRANSPORTATION_NON_FUEL: 'Truck Transportation(Non Fuel)',
  OTHER_TRANSPORTATION: 'Other (Transportation)',

  // Other
  OTHER: 'Other',
  OTHER_BUSINESS_TYPE_NOT_LISTED: 'Other(Business Type Not Listed)',
}

export const INDUSTRY_GROUPING_MAP = {
  AGRICULTURE_FORESTRY: [
    'EXTERMINATION_PEST_CONTROL',
    'FARMING_ANIMAL_PRODUCTION',
    'FARMING_CROP_PRODUCTION',
    'FISHING_HUNTING',
    'LANDSCAPE_SERVICES',
    'LAWN_CARE_SERVICES',
    'OTHER_AGRICULTURE_FORESTRY',
  ],
  BUSINESS_INFORMATION: [
    'CONSULTANT',
    'EMPLOYMENT_OFFICE',
    'FUNDRAISERS',
    'GOING_OUT_OF_BUSINESS_SALES',
    'MARKETING_ADVERTISING',
    'NON_PROFIT_ORGANIZATION',
    'NOTARY_PUBLIC',
    'ONLINE_BUSINESS',
    'OTHER_BUSINESS_INFORMATION',
    'PUBLISHING_SERVICES',
    'RECORD_BUSINESS',
    'RETAIL_SALES',
    'TECHNOLOGY',
    'TELEMARKETING',
    'TRAVEL_AGENCY',
    'VIDEO_PRODUCTION',
  ],
  CONSTRUCTION_UTILITIES_CONTRACTING: [
    'AC_HEATING',
    'ARCHITECT',
    'BUILDING_CONSTRUCTION',
    'BUILDING_INSPECTION',
    'CONCRETE_MANUFACTURING',
    'CONTRACTOR',
    'ENGINEERING_DRAFTING',
    'EQUIPMENT_RENTAL',
    'OTHER_CONSTRUCTION_UTILITIES_CONTRACTING',
    'PLUMBING',
    'REMODELING',
    'REPAIR_MAINTENANCE',
  ],
  EDUCATION: [
    'CHILD_CARE_SERVICES',
    'COLLEGE_UNIVERSITIES',
    'COSMETOLOGY_SCHOOL',
    'ELEMENTARY_SECONDARY_EDUCATION',
    'GED_CERTIFICATION',
    'OTHER_EDUCATION',
    'PRIVATE_SCHOOL',
    'REAL_ESTATE_SCHOOL',
    'TECHNICAL_SCHOOL',
    'TRADE_SCHOOL',
    'TUTORING_SERVICES',
    'VOCATIONAL_SCHOOL',
  ],
  FINANCE: [
    'ACCOUNTANT',
    'AUDITING',
    'BANK_CREDIT_UNION',
    'BOOKKEEPING',
    'CASH_ADVANCES',
    'COLLECTION_AGENCY',
    'INSURANCE',
    'INVESTOR',
    'OTHER_FINANCE_INSURANCE',
    'PAWN_BROKERS',
    'TAX_PREPARATION',
  ],
  HOTELS_RESTAURANTS_CAFES: [
    'ALCOHOL_TOBACCO_SALES',
    'ALCOHOLIC_BEVERAGE_MANUFACTURING',
    'BAKERY',
    'CATERER',
    'FOOD_BEVERAGE',
    'FOOD_BEVERAGE_MANUFACTURING',
    'GROCERY_CONVENIENCE_STORE_GAS_STATION',
    'GROCERY_CONVENIENCE_STORE_NO_GAS_STATION',
    'HOTELS_MOTELS_CASINO',
    'HOTELS_MOTELS_NO_CASINO',
    'MOBILE_FOOD_SERVICES',
    'OTHER_FOOD_HOSPITALITY',
    'RESTAURANT_BAR',
    'SPECIALTY_FOOD_FRUIT_VEGETABLES',
    'SPECIALTY_FOOD_MEAT',
    'SPECIALTY_FOOD_SEAFOOD',
    'TOBACCO_PRODUCT_MANUFACTURING',
    'TRUCK_STOP',
    'VENDING_MACHINE',
  ],
  GAMING: [
    'AUCTIONEER',
    'BOXING_WRESTLING',
    'CASINO_VIDEO_GAMING',
    'OTHER_GAMING',
    'RACETRACK',
    'SPORTS_AGENT',
  ],
  HEALTH: [
    'ACUPUNCTURIST',
    'ATHLETIC_TRAINER',
    'CHILD_YOUTH_SERVICES',
    'CHIROPRACTIC_OFFICE',
    'DENTISTRY',
    'ELECTROLYSIS',
    'EMBALMER',
    'EMERGENCY_MEDICAL_SERVICES',
    'EMERGENCY_MEDICAL_TRANSPORTATION',
    'HEARING_AID_DEALERS',
    'HOME_HEALTH_SERVICES',
    'HOSPITAL',
    'MASSAGE_THERAPY',
    'MEDICAL_OFFICE',
    'MENTAL_HEALTH_SERVICES',
    'NON_EMERGENCY_MEDICAL_TRANSPORTATION',
    'OPTOMETRY',
    'OTHER_HEALTH_SERVICES',
    'PHARMACY',
    'PHYSICAL_THERAPY',
    'PHYSICIANS_OFFICE',
    'RADIOLOGY',
    'RESIDENTIAL_CARE_FACILITY',
    'SPEECH_OCCUPATIONAL_THERAPY',
    'SUBSTANCE_ABUSE_SERVICES',
    'VETERINARY_MEDICINE',
    'VOCATIONAL_REHABILITATION',
    'WHOLESALE_DRUG_DISTRIBUTION',
  ],
  AUTOMOTIVE: [
    'AUTOMOTIVE_PART_SALES',
    'CAR_WASH_DETAILING',
    'MOTOR_VEHICLE_RENTAL',
    'MOTOR_VEHICLE_REPAIR',
    'NEW_MOTOR_VEHICLE_SALES',
    'OTHER_MOTOR_VEHICLE',
    'RECREATIONAL_VEHICLE_SALES',
    'USED_MOTOR_VEHICLE_SALES',
  ],
  NATURAL_RESOURCES: [
    'CONSERVATION_ORGANIZATION',
    'ENVIRONMENTAL_HEALTH',
    'LAND_SURVEYING',
    'OIL_GAS_DISTRIBUTION',
    'OIL_GAS_EXTRACTION',
    'OTHER_NATURAL_RESOURCES',
    'PIPELINE',
    'WATER_WELL_DRILLING',
  ],
  OTHER: ['OTHER_BUSINESS_TYPE_NOT_LISTED'],
  PERSONAL_SERVICES: [
    'ANIMAL_BOARDING',
    'BARBER_SHOP',
    'BEAUTY_SALON',
    'CEMETERY',
    'DIET_CENTER',
    'DRY_CLEANING_LAUNDRY',
    'ENTERTAINMENT_PARTY_RENTALS',
    'EVENT_PLANNING',
    'FITNESS_CENTER',
    'FLORIST',
    'FUNERAL_DIRECTOR',
    'JANITORIAL_CLEANING_SERVICES',
    'MASSAGE_DAY_SPA',
    'NAIL_SALON',
    'OTHER_PERSONAL_SERVICES',
    'PERSONAL_ASSISTANT',
    'PHOTOGRAPHY',
    'TANNING_SALON',
  ],
  REAL_ESTATE: [
    'HOME_INSPECTION',
    'INTERIOR_DESIGN',
    'MANUFACTURED_HOUSING',
    'MORTGAGE_COMPANY',
    'OTHER_REAL_ESTATE_HOUSING',
    'PROPERTY_MANAGEMENT',
    'REAL_ESTATE_BROKER_AGENT',
    'WAREHOUSE_STORAGE',
  ],
  SAFETY_SECURITY_LEGAL: [
    'ATTORNEY',
    'BAIL_BONDS',
    'COURT_REPORTER',
    'DRUG_SCREENING',
    'LOCKSMITH',
    'OTHER_SAFETY_SECURITY_LEGAL',
    'PRIVATE_INVESTIGATOR',
    'SECURITY_GUARD',
    'SECURITY_SYSTEM_SERVICES',
  ],
  TRANSPORT_LOGISTICS: [
    'AIR_TRANSPORTATION',
    'BOAT_SERVICES',
    'LIMOUSINE_SERVICES',
    'MOBILITY',
    'OTHER_TRANSPORTATION',
    'TAXI_SERVICES',
    'TOWING',
    'TRUCK_TRANSPORTATION',
    'TRUCK_TRANSPORTATION_NON_FUEL',
  ],
}

export const PAYROLL_PROVIDER_TYPES = {
  NL_NMBRS: 'NL_NMBRS',
  NL_TENTOO: 'NL_TENTOO',
}

export const NMBRS_COUNTRY_TO_CODE = {
  'Afghanistan': 300,
  'Albania': 50,
  'Algeria': 100,
  'United States': 223,
  'Andorra': 51,
  'Angola': 101,
  'Antigua and Barbuda': 421,
  'Argentina': 250,
  'Armenia': 40,
  'Australia': 400,
  'Austria': 71,
  'Azerbaijan': 39,
  'Bahamas': 200,
  'Bahrain': 301,
  'Bangladesh': 345,
  'Barbados': 251,
  'Belarus': 38,
  'Belgium': 52,
  'Belize': 202,
  'Benin': 111,
  'Bhutan': 302,
  'Bolivia': 252,
  'Bosnia and Herzegovina': 29,
  'Botswana': 105,
  'Brazil': 253,
  'United Kingdom': 83,
  'Brunei': 304,
  'Bulgaria': 53,
  'Burkina Faso': 106,
  'Burundi': 104,
  'Cambodia': 305,
  'Cameroon': 122,
  'Canada': 204,
  'Cape Verde': 121,
  'Central African Republic': 108,
  'Chad': 154,
  'Chile': 254,
  'China': 307,
  'Germany': 55,
  'Colombia': 255,
  'Comoros': 109,
  'Congo (Republic)': 110,
  'Costa Rica': 205,
  'Croatia': 43,
  'Cuba': 206,
  'Cyprus': 308,
  'Czech Republic': 28,
  'Denmark': 54,
  'Djibouti': 115,
  'Dominica': 448,
  'Dominican Republic': 207,
  'Netherlands': 1,
  'East Timor': 452,
  'Ecuador': 256,
  'Egypt': 112,
  'Equatorial Guinea': 113,
  'Eritrea': 84,
  'Estonia': 45,
  'Ethiopia': 114,
  'Fiji': 425,
  'Philippines': 309,
  'Finland': 56,
  'France': 57,
  'Gabon': 116,
  'Gambia': 117,
  'Georgia': 30,
  'Ghana': 118,
  'Greece': 59,
  'Grenada': 267,
  'Guatemala': 211,
  'Guinea-Bissau': 139,
  'Guinea': 119,
  'Guyana': 259,
  'Haiti': 212,
  'Honduras': 213,
  'Hungary': 61,
  'Iceland': 63,
  'India': 312,
  'Indonesia': 313,
  'Iran': 315,
  'Iraq': 314,
  'Ireland': 62,
  'Israel': 316,
  'Italy': 64,
  'Ivory Coast': 120,
  'Jamaica': 214,
  'Japan': 317,
  'Jordan': 319,
  'Kazakhstan': 37,
  'Kenya': 123,
  'Kiribati': 445,
  'Kosovo': 87,
  'Kuwait': 320,
  'Kyrgyzstan': 35,
  'Laos': 321,
  'Latvia': 44,
  'Lebanon': 322,
  'Lesotho': 125,
  'Liberia': 126,
  'Libya': 127,
  'Liechtenstein': 66,
  'Lithuania': 46,
  'Luxembourg': 67,
  'North Macedonia': 86,
  'Madagascar': 128,
  'Malawi': 129,
  'Malaysia': 325,
  'Maldives': 324,
  'Mali': 130,
  'Malta': 68,
  'Marshall Islands': 47,
  'Mauritania': 132,
  'Mauritius': 133,
  'Mexico': 216,
  'Moldova': 36,
  'Monaco': 69,
  'Mongolia': 326,
  'Montenegro': 455,
  'Morocco': 131,
  'Mozambique': 134,
  'Myanmar': 48,
  'Namibia': 49,
  'Nauru': 431,
  'Nepal': 328,
  'New Zealand': 402,
  'Nicaragua': 218,
  'Nigeria': 137,
  'Niger': 136,
  'North Korea': 329,
  'Norway': 70,
  'Oman': 327,
  'Pakistan': 331,
  'Panama': 219,
  'Papua New Guinea': 401,
  'Paraguay': 261,
  'Peru': 262,
  'Poland': 72,
  'Portugal': 73,
  'Qatar': 333,
  'Romania': 74,
  'Russia': 41,
  'Rwanda': 143,
  'Saint Kitts and Nevis': 268,
  'Saint Lucia': 447,
  'Saint Vincent and the Grenadines': 449,
  'El Salvador': 208,
  'Samoa': 404,
  'San Marino': 76,
  'Sao Tome and Principe': 144,
  'Saudi Arabia': 334,
  'Senegal': 145,
  'Serbia': 454,
  'Seychelles': 444,
  'Sierra Leone': 147,
  'Singapore': 335,
  'Slovakia': 27,
  'Slovenia': 42,
  'Solomon Islands': 442,
  'Somalia': 149,
  'South Africa': 140,
  'South Korea': 341,
  'Spain': 77,
  'Sri Lanka': 306,
  'Stateless': 499,
  'Sudan': 148,
  'Suriname': 263,
  'Eswatini': 135,
  'Sweden': 80,
  'Switzerland': 81,
  'Syria': 336,
  'Taiwan': 310,
  'Tajikistan': 32,
  'Tanzania': 151,
  'Thailand': 337,
  'Togo': 152,
  'Tonga': 430,
  'Trinidad and Tobago': 222,
  'Tunisia': 155,
  'Turkey': 339,
  'Turkmenistan': 31,
  'Tuvalu': 446,
  'Uganda': 138,
  'Ukraine': 34,
  'United Arab Emirates': 338,
  'Unknown': 0,
  'Uruguay': 264,
  'Uzbekistan': 33,
  'Vanuatu': 424,
  'Vatican City': 79,
  'Venezuela': 265,
  'Vietnam': 342,
  'Yemen': 58,
  'Zaire': 451,
  'Zambia': 156,
  'Zimbabwe': 142,
}

export const CONTRACT_TYPES = {
  GERMANY_WORKING_STUDENT: 1,
  GERMANY_PART_TIME: 2,
  GERMANY_SHORT_TERM: 3,
  GERMANY_MARGINAL_PART_TIME: 4,
}

export const CONTRACT_TYPES_ENUM = {
  [CONTRACT_TYPES.GERMANY_WORKING_STUDENT]: 'GERMANY_WORKING_STUDENT',
  [CONTRACT_TYPES.GERMANY_PART_TIME]: 'GERMANY_PART_TIME',
  [CONTRACT_TYPES.GERMANY_SHORT_TERM]: 'GERMANY_SHORT_TERM',
  [CONTRACT_TYPES.GERMANY_MARGINAL_PART_TIME]: 'GERMANY_MARGINAL_PART_TIME',
}

export const CONTRACT_TYPE_TO_NAME_MAP = {
  GERMANY_WORKING_STUDENT: 'Working Student (Werkstudent)',
  GERMANY_PART_TIME: 'Part-Time employment (Teilzeit)',
  GERMANY_SHORT_TERM: 'Short-term employment (70 workdays)',
  GERMANY_MARGINAL_PART_TIME: 'Marginal part-time employment (Minijob)',
}

export const GERMANY_CONTRACT_STATUSES = {
  STATUS_ACTIVE: 'ACTIVE',
  STATUS_EXPIRED: 'EXPIRED',
  STATUS_SIGNED: 'SIGNED',
  STATUS_EXPIRING_SOON: 'EXPIRING_SOON',
  STATUS_TERMINATED: 'TERMINATED',
}

export const CONTRACT_TYPES_STRING = {
  WORKING_STUDENT: 'GERMANY_WORKING_STUDENT',
  PART_TIME: 'GERMANY_PART_TIME',
  SHORT_TERM: 'GERMANY_SHORT_TERM',
  MARGINAL_PART_TIME: 'GERMANY_MARGINAL_PART_TIME',
  GPS: 'GERMANY_GPS',
}

export const GERMANY_CONTRACT_ADDENDUM_TYPES = {
  CHANGE_AMOUNT_HOURS: 'GERMANY_ADDENDUM_CHANGE_HOURS',
  CONTRACT_EXTENSION: 'GERMANY_ADDENDUM_EXTENSION',
  IMMEDIATE_RESIGNATION: 'GERMANY_ADDENDUM_IMMEDIATE_RESIGNATION',
  FUTURE_RESIGNATION: 'GERMANY_ADDENDUM_FUTURE_RESIGNATION',
  TERMINATION_DOESNT_SHOW_UP: 'GERMANY_ADDENDUM_TERMINATION_NOT_SHOW_UP',
  TERMINATION_DOESNT_SEND_LETTER: 'GERMANY_ADDENDUM_TERMINATION_LETTER',
  TERMINATION_LESS_THAN_6_MONTH: 'GERMANY_ADDENDUM_TERMINATION_WITHIN_6_MONTHS',
  TERMINATION_MORE_THAN_6_MONTH: 'GERMANY_ADDENDUM_TERMINATION_MORE_6_MONTHS',
}

export const ADDENDUM_NAMES_MAP = {
  [GERMANY_CONTRACT_ADDENDUM_TYPES.CHANGE_AMOUNT_HOURS]:
    'Change of amount of working hours',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.CONTRACT_EXTENSION]: 'Contract Extension',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.IMMEDIATE_RESIGNATION]:
    'Immediate Resignation',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.FUTURE_RESIGNATION]:
    'Future resignation (future date)',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SHOW_UP]: `Promofy Immediate Termination - Fristlose Kuendigung (Employee doesn't show up for work)`,
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_DOESNT_SEND_LETTER]: `Promofy Immediate termination - Fristlose Kuendigung (Employee doesn't send resignation letter)`,
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_LESS_THAN_6_MONTH]:
    'Termination (employee within 6 month probation period)',
  [GERMANY_CONTRACT_ADDENDUM_TYPES.TERMINATION_MORE_THAN_6_MONTH]:
    'Termination (employee employed more than 6 months)',
}

export const TEMPLATE_DOCUMENTS_TYPES = {
  NL_NMBRS: 'NL_NMBRS_6_MONTH_CONTRACT',
  NL_TENTOO: 'NL_TENTOO_6_MONTH_CONTRACT',
}

export const COUNTRY_CODES = {
  AUSTRALIA: 'AU',
  FRANCE: 'FR',
  NETHERLANDS: 'NL',
  NEW_ZEALAND: 'NZ',
  UNITED_KINGDOM: 'UK',
  BELGIUM: 'BE',
  UNITED_STATES: 'US',
  SWITZERLAND: 'CH',
  CANADA: 'CA',
  MEXICO: 'MX',
  GERMANY: 'DE',
  SPAIN: 'ES',
  ITALY: 'IT',
  LUXEMBOURG: 'LU',
  PORTUGAL: 'PT',
  POLAND: 'PL',
  ARGENTINA: 'AR',
  BRAZIL: 'BR',
  IRELAND: 'IE',
  AZEROTH: 'AZ',
}

export const CONTRACTOR_TYPE = {
  EMPLOYEE: 'EMPLOYEE',
  COMPANY_0_WT: 'COMPANY_0_WT',
  COMPANY_1_WT: 'COMPANY_1_WT',
  COMPANY_7_WT: 'COMPANY_7_WT',
  COMPANY_15_WT: 'COMPANY_15_WT',
  INTERNAL_BA: 'INTERNAL_BA',
}

export const CONTRACTOR_TYPE_DE = {
  EMPLOYEE_INTERNAL: 'EMPLOYEE_INTERNAL',
  EMPLOYEE_EXTERNAL: 'EMPLOYEE_EXTERNAL',
}

export const WITHHOLDING_VALUES_BY_CONTRACTOR_TYPE = {
  [CONTRACTOR_TYPE.EMPLOYEE]: 0,
  [CONTRACTOR_TYPE.COMPANY_0_WT]: 0,
  [CONTRACTOR_TYPE.COMPANY_1_WT]: 1,
  [CONTRACTOR_TYPE.COMPANY_7_WT]: 7,
  [CONTRACTOR_TYPE.COMPANY_15_WT]: 15,
  [CONTRACTOR_TYPE.INTERNAL_BA]: 0,
}

export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED = 1
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED = 2
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED = 3
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED = 4

export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM = 'REQUESTED'
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM = 'APPROVED'
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM = 'REJECTED'
export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED_ENUM = 'CANCELLED'

export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_ENUM_TO_TYPES_MAP = {
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED,
}

export const PERSONAL_DATA_CHANGE_REQUEST_STATUS_TYPES_TO_ENUM_MAP = {
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM,
  [PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED]: PERSONAL_DATA_CHANGE_REQUEST_STATUS_CANCELLED_ENUM,
}

export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT = 1
export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL = 2
export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT = 3

export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM = 'DOCUMENT'
export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT_ENUM = 'CONTRACT'
export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL_ENUM = 'PAYROLL'

export const PERSONAL_DATA_CHANGE_REQUEST_TYPE_ENUM_TO_TYPES_MAP = {
  [PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT,
  [PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT,
  [PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL_ENUM]: PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL,
}

export const PTO_REQUEST_TYPE_TIME_OFF = 1

export const PTO_REQUEST_TYPE_TIME_OFF_ENUM = 'TIME_OFF'

export const PTO_REQUEST_PAID_TYPE_OF_TIME_OFF_ENUM = 'PAID'

export const PTO_REQUEST_UNPAID_TYPE_OF_TIME_OFF_ENUM = 'UNPAID'

export const PTO_REQUEST_TYPES_ENUM_MAP = {
  [PTO_REQUEST_TYPE_TIME_OFF]: PTO_REQUEST_TYPE_TIME_OFF_ENUM,
}

export const PTO_REQUEST_TYPES_ENUM_TO_TYPE_MAP = {
  [PTO_REQUEST_TYPE_TIME_OFF_ENUM]: PTO_REQUEST_TYPE_TIME_OFF,
}

export const PTO_REQUEST_STATUS_REQUESTED = 1
export const PTO_REQUEST_STATUS_APPROVED = 2
export const PTO_REQUEST_STATUS_REJECTED = 3

export const PTO_REQUEST_STATUS_REQUESTED_ENUM = 'REQUESTED'
export const PTO_REQUEST_STATUS_APPROVED_ENUM = 'APPROVED'
export const PTO_REQUEST_STATUS_REJECTED_ENUM = 'REJECTED'
export const PTO_REQUEST_STATUS_EXPIRED_ENUM = 'EXPIRED'

export const PTO_REQUEST_STATUS_TO_ENUM_MAP = {
  [PTO_REQUEST_STATUS_REQUESTED]: PTO_REQUEST_STATUS_REQUESTED_ENUM,
  [PTO_REQUEST_STATUS_APPROVED]: PTO_REQUEST_STATUS_APPROVED_ENUM,
  [PTO_REQUEST_STATUS_REJECTED]: PTO_REQUEST_STATUS_REJECTED_ENUM,
}

export const PTO_REQUEST_STATUS_ENUM_TO_TYPES_MAP = {
  [PTO_REQUEST_STATUS_REQUESTED_ENUM]: PTO_REQUEST_STATUS_REQUESTED,
  [PTO_REQUEST_STATUS_APPROVED_ENUM]: PTO_REQUEST_STATUS_APPROVED,
  [PTO_REQUEST_STATUS_REJECTED_ENUM]: PTO_REQUEST_STATUS_REJECTED,
}

export const PTO_REQUEST_TYPE_ENUM_TO_READABLE = {
  [PTO_REQUEST_TYPE_TIME_OFF_ENUM]: 'Time off',
}

export const BA_CATEGORY_OPTIONS_TYPE = {
  STUDENT_LESS_26: 'STUDENT_LESS_26',
  NOT_STUDENT_LESS_26: 'NOT_STUDENT_LESS_26',
  NOT_STUDENT_MORE_26: 'NOT_STUDENT_MORE_26',
}

export const FILTERS_OPERATORS = {
  ALL: 'ALL',
  LESS_EQUAL: 'LESS_EQUAL',
  GREATER_EQUAL: 'GREATER_EQUAL',
  BETWEEN: 'BETWEEN',
}

export const LOCATION_EVENT_TYPES = {
  FESTIVAL_FAIR: 1,
  CONCERT_MUSIC_EVENT: 2,
  SPORTS_EVENT: 3,
  RELIGIOUS_GATHERING: 4,
  TRADE_SHOW_EXPO: 5,
  CONFERENCE_SEMINAR: 6,
  NETWORKING_EVENT: 7,
  JOB_CAREER_FAIR: 8,
  WEDDING: 9,
  PARTY: 10,
  SCHOOL_COLLEGE_EVENT: 11,
  COMMUNITY_GATHERING: 12,
  POLITICAL_PUBLIC_RALLY: 13,
  OTHER: 0,
}

export const LOCATION_EVENT_TYPES_ENUM = {
  [LOCATION_EVENT_TYPES.FESTIVAL_FAIR]: 'Festival / Fair',
  [LOCATION_EVENT_TYPES.CONCERT_MUSIC_EVENT]: 'Concert / Music Event',
  [LOCATION_EVENT_TYPES.SPORTS_EVENT]: 'Sports Event',
  [LOCATION_EVENT_TYPES.RELIGIOUS_GATHERING]: 'Religious Gathering',
  [LOCATION_EVENT_TYPES.TRADE_SHOW_EXPO]: 'Trade Show / Expo',
  [LOCATION_EVENT_TYPES.CONFERENCE_SEMINAR]: 'Conference / Seminar',
  [LOCATION_EVENT_TYPES.NETWORKING_EVENT]: 'Networking Event',
  [LOCATION_EVENT_TYPES.JOB_CAREER_FAIR]: 'Job / Career Fair',
  [LOCATION_EVENT_TYPES.WEDDING]: 'Wedding',
  [LOCATION_EVENT_TYPES.PARTY]: 'Party (Birthday, Graduation, etc.)',
  [LOCATION_EVENT_TYPES.SCHOOL_COLLEGE_EVENT]: 'School / College Event',
  [LOCATION_EVENT_TYPES.COMMUNITY_GATHERING]: 'Community Gathering',
  [LOCATION_EVENT_TYPES.POLITICAL_PUBLIC_RALLY]: 'Political / Public Rally',
  [LOCATION_EVENT_TYPES.OTHER]: 'Other',
}

export const LOCATION_SCHEDULE_TYPES_ENUM = {
  WEEKLY_HOURS: 'WEEKLY_HOURS',
  DAILY_HOURS: 'DAILY_HOURS',
  TIME_SLOTS: 'TIME_SLOTS',
  EVENT: 'EVENT',
}

export const CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES = {
  B2C: 'B2C',
  B2B: 'B2B',
}

export const INDUSTRY_GROUPS_OPTIONS_V2 = {
  ACCOUNTING: 'Accounting',
  AIRLINES_AVIATION: 'Airlines/Aviation',
  ALTERNATIVE_DISPUTE_RESOLUTION: 'Alternative Dispute Resolution',
  ALTERNATIVE_MEDICINE: 'Alternative Medicine',
  ANIMATION: 'Animation',
  APPAREL_AND_FASHION: 'Apparel & Fashion',
  ARCHITECTURE_AND_PLANNING: 'Architecture & Planning',
  ARTS_AND_CRAFTS: 'Arts and Crafts',
  AUTOMOTIVE: 'Automotive',
  AVIATION_AND_AEROSPACE: 'Aviation & Aerospace',
  BANKING: 'Banking',
  BIOTECHNOLOGY: 'Biotechnology',
  BROADCAST_MEDIA: 'Broadcast Media',
  BUILDING_MATERIALS: 'Building Materials',
  BUSINESS_SUPPLIES_AND_EQUIPMENT: 'Business Supplies and Equipment',
  CAPITAL_MARKETS: 'Capital Markets',
  CHEMICALS: 'Chemicals',
  CIVIC_AND_SOCIAL_ORGANIZATION: 'Civic & Social Organization',
  CIVIL_ENGINEERING: 'Civil Engineering',
  COMMERCIAL_REAL_ESTATE: 'Commercial Real Estate',
  COMPUTER_AND_NETWORK_SECURITY: 'Computer & Network Security',
  COMPUTER_GAMES: 'Computer Games',
  COMPUTER_HARDWARE: 'Computer Hardware',
  COMPUTER_NETWORKING: 'Computer Networking',
  COMPUTER_SOFTWARE: 'Computer Software',
  INTERNET: 'Internet',
  CONSTRUCTION: 'Construction',
  CONSUMER_ELECTRONICS: 'Consumer Electronics',
  CONSUMER_GOODS: 'Consumer Goods',
  CONSUMER_SERVICES: 'Consumer Services',
  COSMETICS: 'Cosmetics',
  DEFENSE_AND_SPACE: 'Defense & Space',
  DESIGN: 'Design',
  E_COMMERCE: 'E-Commerce',
  EDUCATION_MANAGEMENT: 'Education Management',
  E_LEARNING: 'E-Learning',
  ELECTRICAL_ELECTRONIC_MANUFACTURING: 'Electrical/Electronic Manufacturing',
  ENTERTAINMENT: 'Entertainment',
  ENVIRONMENTAL_SERVICES: 'Environmental Services',
  EVENTS_SERVICES: 'Events Services',
  EXECUTIVE_OFFICE: 'Executive Office',
  FACILITIES_SERVICES: 'Facilities Services',
  FARMING: 'Farming',
  FINANCIAL_SERVICES: 'Financial Services',
  FINE_ART: 'Fine Art',
  FISHERY: 'Fishery',
  FOOD_AND_BEVERAGES: 'Food & Beverages',
  FUND_RAISING: 'Fund-Raising',
  FURNITURE: 'Furniture',
  GAMBLING_AND_CASINOS: 'Gambling & Casinos',
  GLASS_CERAMICS_AND_CONCRETE: 'Glass, Ceramics & Concrete',
  GOVERNMENT_ADMINISTRATION: 'Government Administration',
  GOVERNMENT_RELATIONS: 'Government Relations',
  GRAPHIC_DESIGN: 'Graphic Design',
  HEALTH_WELLNESS_AND_FITNESS: 'Health, Wellness and Fitness',
  HIGHER_EDUCATION: 'Higher Education',
  HOSPITAL_AND_HEALTH_CARE: 'Hospital & Health Care',
  HOSPITALITY: 'Hospitality',
  HUMAN_RESOURCES: 'Human Resources',
  IMPORT_AND_EXPORT: 'Import and Export',
  INDIVIDUAL_AND_FAMILY_SERVICES: 'Individual & Family Services',
  INDUSTRIAL_AUTOMATION: 'Industrial Automation',
  INFORMATION_SERVICES: 'Information Services',
  INFORMATION_TECHNOLOGY_AND_SERVICES: 'Information Technology and Services',
  INSURANCE: 'Insurance',
  INTERNATIONAL_AFFAIRS: 'International Affairs',
  INTERNATIONAL_TRADE_AND_DEVELOPMENT: 'International Trade and Development',
  INVESTMENT_BANKING: 'Investment Banking',
  INVESTMENT_MANAGEMENT: 'Investment Management',
  JUDICIARY: 'Judiciary',
  LAW_ENFORCEMENT: 'Law Enforcement',
  LAW_PRACTICE: 'Law Practice',
  LEGAL_SERVICES: 'Legal Services',
  LEGISLATIVE_OFFICE: 'Legislative Office',
  LEISURE_TRAVEL_AND_TOURISM: 'Leisure, Travel & Tourism',
  LIBRARIES: 'Libraries',
  LOGISTICS_AND_SUPPLY_CHAIN: 'Logistics and Supply Chain',
  LUXURY_GOODS_AND_JEWELRY: 'Luxury Goods & Jewelry',
  MACHINERY: 'Machinery',
  MANAGEMENT_CONSULTING: 'Management Consulting',
  MARITIME: 'Maritime',
  MARKET_RESEARCH: 'Market Research',
  MARKETING_AND_ADVERTISING: 'Marketing and Advertising',
  MECHANICAL_OR_INDUSTRIAL_ENGINEERING: 'Mechanical or Industrial Engineering',
  MEDIA_PRODUCTION: 'Media Production',
  MEDICAL_DEVICES: 'Medical Devices',
  MEDICAL_PRACTICE: 'Medical Practice',
  MENTAL_HEALTH_CARE: 'Mental Health Care',
  MILITARY: 'Military',
  MINING_AND_METALS: 'Mining & Metals',
  MOBILITY: 'Mobility',
  MOTION_PICTURES_AND_FILM: 'Motion Pictures and Film',
  MUSEUMS_AND_INSTITUTIONS: 'Museums and Institutions',
  MUSIC: 'Music',
  NANOTECHNOLOGY: 'Nanotechnology',
  NEWSPAPERS: 'Newspapers',
  NONPROFIT_ORGANIZATION_MANAGEMENT: 'Nonprofit Organization Management',
  OIL_AND_ENERGY: 'Oil & Energy',
  ONLINE_MEDIA: 'Online Media',
  OUTSOURCING_OFFSHORING: 'Outsourcing/Offshoring',
  PACKAGE_FREIGHT_DELIVERY: 'Package/Freight Delivery',
  PACKAGING_AND_CONTAINERS: 'Packaging and Containers',
  PAPER_AND_FOREST_PRODUCTS: 'Paper & Forest Products',
  PERFORMING_ARTS: 'Performing Arts',
  PHARMACEUTICALS: 'Pharmaceuticals',
  PHILANTHROPY: 'Philanthropy',
  PHOTOGRAPHY: 'Photography',
  PLASTICS: 'Plastics',
  POLITICAL_ORGANIZATION: 'Political Organization',
  PRIMARY_SECONDARY_EDUCATION: 'Primary/Secondary Education',
  PRINTING: 'Printing',
  PROFESSIONAL_TRAINING_AND_COACHING: 'Professional Training & Coaching',
  PROGRAM_DEVELOPMENT: 'Program Development',
  PUBLIC_POLICY: 'Public Policy',
  PUBLIC_RELATIONS_AND_COMMUNICATIONS: 'Public Relations and Communications',
  PUBLIC_SAFETY: 'Public Safety',
  PUBLISHING: 'Publishing',
  RAILROAD_MANUFACTURE: 'Railroad Manufacture',
  RANCHING: 'Ranching',
  REAL_ESTATE: 'Real Estate',
  RECREATIONAL_FACILITIES_AND_SERVICES: 'Recreational Facilities and Services',
  RELIGIOUS_INSTITUTIONS: 'Religious Institutions',
  RENEWABLES_AND_ENVIRONMENT: 'Renewables & Environment',
  RESEARCH: 'Research',
  RETAIL: 'Retail',
  SECURITY_AND_INVESTIGATIONS: 'Security and Investigations',
  SEMICONDUCTORS: 'Semiconductors',
  SHIPBUILDING: 'Shipbuilding',
  SPORTING_GOODS: 'Sporting Goods',
  SPORTS: 'Sports',
  STAFFING_AND_RECRUITING: 'Staffing and Recruiting',
  SUPERMARKETS: 'Supermarkets',
  TELECOMMUNICATIONS: 'Telecommunications',
  TEXTILES: 'Textiles',
  THINK_TANKS: 'Think Tanks',
  TOBACCO: 'Tobacco',
  TRANSLATION_AND_LOCALIZATION: 'Translation and Localization',
  TRANSPORTATION_TRUCKING_RAILROAD: 'Transportation/Trucking/Railroad',
  UTILITIES: 'Utilities',
  VENTURE_CAPITAL_AND_PRIVATE_EQUITY: 'Venture Capital & Private Equity',
  VETERINARY: 'Veterinary',
  WAREHOUSING: 'Warehousing',
  WHOLESALE: 'Wholesale',
  WINE_AND_SPIRITS: 'Wine and Spirits',
  WIRELESS: 'Wireless',
  WRITING_AND_EDITING: 'Writing and Editing',
}

export const INDUSTRY_GROUPS_OPTIONS_TYPES_V2 = {
  'Accounting': 'ACCOUNTING',
  'Airlines/Aviation': 'AIRLINES_AVIATION',
  'Alternative Dispute Resolution': 'ALTERNATIVE_DISPUTE_RESOLUTION',
  'Alternative Medicine': 'ALTERNATIVE_MEDICINE',
  'Animation': 'ANIMATION',
  'Apparel & Fashion': 'APPAREL_AND_FASHION',
  'Architecture & Planning': 'ARCHITECTURE_AND_PLANNING',
  'Arts and Crafts': 'ARTS_AND_CRAFTS',
  'Automotive': 'AUTOMOTIVE',
  'Aviation & Aerospace': 'AVIATION_AND_AEROSPACE',
  'Banking': 'BANKING',
  'Biotechnology': 'BIOTECHNOLOGY',
  'Broadcast Media': 'BROADCAST_MEDIA',
  'Building Materials': 'BUILDING_MATERIALS',
  'Business Supplies and Equipment': 'BUSINESS_SUPPLIES_AND_EQUIPMENT',
  'Capital Markets': 'CAPITAL_MARKETS',
  'Chemicals': 'CHEMICALS',
  'Civic & Social Organization': 'CIVIC_AND_SOCIAL_ORGANIZATION',
  'Civil Engineering': 'CIVIL_ENGINEERING',
  'Commercial Real Estate': 'COMMERCIAL_REAL_ESTATE',
  'Computer & Network Security': 'COMPUTER_AND_NETWORK_SECURITY',
  'Computer Games': 'COMPUTER_GAMES',
  'Computer Hardware': 'COMPUTER_HARDWARE',
  'Computer Networking': 'COMPUTER_NETWORKING',
  'Computer Software': 'COMPUTER_SOFTWARE',
  'Internet': 'INTERNET',
  'Construction': 'CONSTRUCTION',
  'Consumer Electronics': 'CONSUMER_ELECTRONICS',
  'Consumer Goods': 'CONSUMER_GOODS',
  'Consumer Services': 'CONSUMER_SERVICES',
  'Cosmetics': 'COSMETICS',
  'Defense & Space': 'DEFENSE_AND_SPACE',
  'Design': 'DESIGN',
  'E-Commerce': 'E_COMMERCE',
  'Education Management': 'EDUCATION_MANAGEMENT',
  'E-Learning': 'E_LEARNING',
  'Electrical/Electronic Manufacturing': 'ELECTRICAL_ELECTRONIC_MANUFACTURING',
  'Entertainment': 'ENTERTAINMENT',
  'Environmental Services': 'ENVIRONMENTAL_SERVICES',
  'Events Services': 'EVENTS_SERVICES',
  'Executive Office': 'EXECUTIVE_OFFICE',
  'Facilities Services': 'FACILITIES_SERVICES',
  'Farming': 'FARMING',
  'Financial Services': 'FINANCIAL_SERVICES',
  'Fine Art': 'FINE_ART',
  'Fishery': 'FISHERY',
  'Food & Beverages': 'FOOD_AND_BEVERAGES',
  'Fund-Raising': 'FUND_RAISING',
  'Furniture': 'FURNITURE',
  'Gambling & Casinos': 'GAMBLING_AND_CASINOS',
  'Glass, Ceramics & Concrete': 'GLASS_CERAMICS_AND_CONCRETE',
  'Government Administration': 'GOVERNMENT_ADMINISTRATION',
  'Government Relations': 'GOVERNMENT_RELATIONS',
  'Graphic Design': 'GRAPHIC_DESIGN',
  'Health, Wellness and Fitness': 'HEALTH_WELLNESS_AND_FITNESS',
  'Higher Education': 'HIGHER_EDUCATION',
  'Hospital & Health Care': 'HOSPITAL_AND_HEALTH_CARE',
  'Hospitality': 'HOSPITALITY',
  'Human Resources': 'HUMAN_RESOURCES',
  'Import and Export': 'IMPORT_AND_EXPORT',
  'Individual & Family Services': 'INDIVIDUAL_AND_FAMILY_SERVICES',
  'Industrial Automation': 'INDUSTRIAL_AUTOMATION',
  'Information Services': 'INFORMATION_SERVICES',
  'Information Technology and Services': 'INFORMATION_TECHNOLOGY_AND_SERVICES',
  'Insurance': 'INSURANCE',
  'International Affairs': 'INTERNATIONAL_AFFAIRS',
  'International Trade and Development': 'INTERNATIONAL_TRADE_AND_DEVELOPMENT',
  'Investment Banking': 'INVESTMENT_BANKING',
  'Investment Management': 'INVESTMENT_MANAGEMENT',
  'Judiciary': 'JUDICIARY',
  'Law Enforcement': 'LAW_ENFORCEMENT',
  'Law Practice': 'LAW_PRACTICE',
  'Legal Services': 'LEGAL_SERVICES',
  'Legislative Office': 'LEGISLATIVE_OFFICE',
  'Leisure, Travel & Tourism': 'LEISURE_TRAVEL_AND_TOURISM',
  'Libraries': 'LIBRARIES',
  'Logistics and Supply Chain': 'LOGISTICS_AND_SUPPLY_CHAIN',
  'Luxury Goods & Jewelry': 'LUXURY_GOODS_AND_JEWELRY',
  'Machinery': 'MACHINERY',
  'Management Consulting': 'MANAGEMENT_CONSULTING',
  'Maritime': 'MARITIME',
  'Market Research': 'MARKET_RESEARCH',
  'Marketing and Advertising': 'MARKETING_AND_ADVERTISING',
  'Mechanical or Industrial Engineering':
    'MECHANICAL_OR_INDUSTRIAL_ENGINEERING',
  'Media Production': 'MEDIA_PRODUCTION',
  'Medical Devices': 'MEDICAL_DEVICES',
  'Medical Practice': 'MEDICAL_PRACTICE',
  'Mental Health Care': 'MENTAL_HEALTH_CARE',
  'Military': 'MILITARY',
  'Mining & Metals': 'MINING_AND_METALS',
  'Mobility': 'MOBILITY',
  'Motion Pictures and Film': 'MOTION_PICTURES_AND_FILM',
  'Museums and Institutions': 'MUSEUMS_AND_INSTITUTIONS',
  'Music': 'MUSIC',
  'Nanotechnology': 'NANOTECHNOLOGY',
  'Newspapers': 'NEWSPAPERS',
  'Nonprofit Organization Management': 'NONPROFIT_ORGANIZATION_MANAGEMENT',
  'Oil & Energy': 'OIL_AND_ENERGY',
  'Online Media': 'ONLINE_MEDIA',
  'Outsourcing/Offshoring': 'OUTSOURCING_OFFSHORING',
  'Package/Freight Delivery': 'PACKAGE_FREIGHT_DELIVERY',
  'Packaging and Containers': 'PACKAGING_AND_CONTAINERS',
  'Paper & Forest Products': 'PAPER_AND_FOREST_PRODUCTS',
  'Performing Arts': 'PERFORMING_ARTS',
  'Pharmaceuticals': 'PHARMACEUTICALS',
  'Philanthropy': 'PHILANTHROPY',
  'Photography': 'PHOTOGRAPHY',
  'Plastics': 'PLASTICS',
  'Political Organization': 'POLITICAL_ORGANIZATION',
  'Primary/Secondary Education': 'PRIMARY_SECONDARY_EDUCATION',
  'Printing': 'PRINTING',
  'Professional Training & Coaching': 'PROFESSIONAL_TRAINING_AND_COACHING',
  'Program Development': 'PROGRAM_DEVELOPMENT',
  'Public Policy': 'PUBLIC_POLICY',
  'Public Relations and Communications': 'PUBLIC_RELATIONS_AND_COMMUNICATIONS',
  'Public Safety': 'PUBLIC_SAFETY',
  'Publishing': 'PUBLISHING',
  'Railroad Manufacture': 'RAILROAD_MANUFACTURE',
  'Ranching': 'RANCHING',
  'Real Estate': 'REAL_ESTATE',
  'Recreational Facilities and Services':
    'RECREATIONAL_FACILITIES_AND_SERVICES',
  'Religious Institutions': 'RELIGIOUS_INSTITUTIONS',
  'Renewables & Environment': 'RENEWABLES_AND_ENVIRONMENT',
  'Research': 'RESEARCH',
  'Retail': 'RETAIL',
  'Security and Investigations': 'SECURITY_AND_INVESTIGATIONS',
  'Semiconductors': 'SEMICONDUCTORS',
  'Shipbuilding': 'SHIPBUILDING',
  'Sporting Goods': 'SPORTING_GOODS',
  'Sports': 'SPORTS',
  'Staffing and Recruiting': 'STAFFING_AND_RECRUITING',
  'Supermarkets': 'SUPERMARKETS',
  'Telecommunications': 'TELECOMMUNICATIONS',
  'Textiles': 'TEXTILES',
  'Think Tanks': 'THINK_TANKS',
  'Tobacco': 'TOBACCO',
  'Translation and Localization': 'TRANSLATION_AND_LOCALIZATION',
  'Transportation/Trucking/Railroad': 'TRANSPORTATION_TRUCKING_RAILROAD',
  'Utilities': 'UTILITIES',
  'Venture Capital & Private Equity': 'VENTURE_CAPITAL_AND_PRIVATE_EQUITY',
  'Veterinary': 'VETERINARY',
  'Warehousing': 'WAREHOUSING',
  'Wholesale': 'WHOLESALE',
  'Wine and Spirits': 'WINE_AND_SPIRITS',
  'Wireless': 'WIRELESS',
  'Writing and Editing': 'WRITING_AND_EDITING',
}

export const INDUSTRY_OPTIONS_V2 = {
  ACCOUNTING_AND_AUDITING_ACTIVITIES: 'Accounting and auditing activities',
  TAX_CONSULTANCY: 'Tax consultancy',
  BOOKKEEPING_SERVICES: 'Bookkeeping services',
  PAYROLL_PROCESSING_SERVICES: 'Payroll processing services',
  PASSENGER_AIR_TRANSPORT: 'Passenger air transport',
  FREIGHT_AIR_TRANSPORT: 'Freight air transport',
  AIR_TRANSPORT_SUPPORT_SERVICES: 'Air transport support services',
  AIRPORT_OPERATIONS: 'Airport operations',
  LEGAL_AND_ARBITRATION_SERVICES: 'Legal and arbitration services',
  MEDIATION_SERVICES: 'Mediation services',
  OTHER_HEALTH_SERVICES: 'Other health services',
  WELLNESS_AND_PHYSICAL_THERAPY_SERVICES:
    'Wellness and physical therapy services',
  TRADITIONAL_AND_ALTERNATIVE_MEDICINE_SERVICES:
    'Traditional and alternative medicine services',
  MOTION_PICTURE_AND_VIDEO_PRODUCTION: 'Motion picture and video production',
  POST_PRODUCTION_SERVICES: 'Post-production services',
  ANIMATION_AND_VISUAL_EFFECTS_SERVICES:
    'Animation and visual effects services',
  TELEVISION_PROGRAMME_PRODUCTION: 'Television programme production',
  MANUFACTURE_OF_TEXTILES: 'Manufacture of textiles',
  MANUFACTURE_OF_WEARING_APPAREL: 'Manufacture of wearing apparel',
  MANUFACTURE_OF_LEATHER_AND_RELATED_PRODUCTS:
    'Manufacture of leather and related products',
  MANUFACTURE_OF_FOOTWEAR: 'Manufacture of footwear',
  WHOLESALE_OF_HOUSEHOLD_GOODS_INCL_TEXTILES_CLOTHING_FOOTWEAR:
    'Wholesale of household goods (incl. textiles, clothing, footwear)',
  RETAIL_SALE_OF_CLOTHING_FOOTWEAR_AND_LEATHER_GOODS:
    'Retail sale of clothing, footwear and leather goods',
  ARCHITECTURAL_SERVICES: 'Architectural services',
  URBAN_AND_LANDSCAPE_PLANNING: 'Urban and landscape planning',
  ENGINEERING_DESIGN_SERVICES: 'Engineering design services',
  TECHNICAL_CONSULTANCY_SERVICES: 'Technical consultancy services',
  CREATIVE_ARTS_ACTIVITIES: 'Creative arts activities',
  HANDICRAFT_AND_ARTISAN_PRODUCTS: 'Handicraft and artisan products',
  MANUFACTURE_OF_JEWELLERY_AND_RELATED_ARTICLES:
    'Manufacture of jewellery and related articles',
  MANUFACTURE_OF_CERAMIC_HOUSEHOLD_AND_ORNAMENTAL_ARTICLES:
    'Manufacture of ceramic household and ornamental articles',
  RETAIL_SALE_OF_ART_AND_CRAFT_GOODS: 'Retail sale of art and craft goods',
  MANUFACTURE_OF_MOTOR_VEHICLES: 'Manufacture of motor vehicles',
  MANUFACTURE_OF_PARTS_AND_ACCESSORIES_FOR_MOTOR_VEHICLES:
    'Manufacture of parts and accessories for motor vehicles',
  SALE_OF_MOTOR_VEHICLES: 'Sale of motor vehicles',
  MAINTENANCE_AND_REPAIR_OF_MOTOR_VEHICLES:
    'Maintenance and repair of motor vehicles',
  RETAIL_SALE_OF_AUTOMOTIVE_FUEL: 'Retail sale of automotive fuel',
  RENTING_AND_LEASING_OF_MOTOR_VEHICLES:
    'Renting and leasing of motor vehicles',
  MANUFACTURE_OF_AIR_AND_SPACECRAFT_AND_RELATED_MACHINERY:
    'Manufacture of air and spacecraft and related machinery',
  REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_SPACECRAFT:
    'Repair and maintenance of aircraft and spacecraft',
  SERVICE_ACTIVITIES_INCIDENTAL_TO_AIR_TRANSPORTATION:
    'Service activities incidental to air transportation',
  SPACE_RESEARCH_AND_TECHNOLOGY: 'Space research and technology',
  CENTRAL_BANKING: 'Central banking',
  OTHER_MONETARY_INTERMEDIATION: 'Other monetary intermediation',
  TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES:
    'Trusts, funds and similar financial entities',
  ACTIVITIES_OF_HOLDING_COMPANIES: 'Activities of holding companies',
  PAYMENT_SERVICES_AND_CREDIT_CARD_ISSUING:
    'Payment services and credit card issuing',
  BIOTECHNOLOGY_RESEARCH_AND_DEVELOPMENT:
    'Biotechnology research and development',
  PHARMACEUTICAL_MANUFACTURING: 'Pharmaceutical manufacturing',
  CLINICAL_RESEARCH_SERVICES: 'Clinical research services',
  RADIO_BROADCASTING: 'Radio broadcasting',
  TELEVISION_PROGRAMMING_AND_BROADCASTING:
    'Television programming and broadcasting',
  PROGRAMME_DISTRIBUTION_SERVICES: 'Programme distribution services',
  NEWS_AGENCY_ACTIVITIES: 'News agency activities',
  MANUFACTURE_OF_CEMENT_LIME_AND_PLASTER:
    'Manufacture of cement, lime and plaster',
  MANUFACTURE_OF_GLASS_AND_GLASS_PRODUCTS:
    'Manufacture of glass and glass products',
  MANUFACTURE_OF_CLAY_AND_CONCRETE_BUILDING_MATERIALS:
    'Manufacture of clay and concrete building materials',
  WHOLESALE_OF_CONSTRUCTION_MATERIALS: 'Wholesale of construction materials',
  WHOLESALE_OF_OFFICE_EQUIPMENT: 'Wholesale of office equipment',
  MANUFACTURE_OF_OFFICE_EQUIPMENT_NON_COMPUTER:
    'Manufacture of office equipment (non-computer)',
  RETAIL_SALE_OF_STATIONERY_AND_OFFICE_SUPPLIES:
    'Retail sale of stationery and office supplies',
  SECURITIES_AND_COMMODITIES_BROKERAGE: 'Securities and commodities brokerage',
  ADMINISTRATION_OF_FINANCIAL_MARKETS: 'Administration of financial markets',
  ACTIVITIES_AUXILIARY_TO_FINANCIAL_SERVICES:
    'Activities auxiliary to financial services',
  ASSET_AND_FUND_MANAGEMENT: 'Asset and fund management',
  MANUFACTURE_OF_BASIC_CHEMICALS: 'Manufacture of basic chemicals',
  MANUFACTURE_OF_FERTILIZERS_AND_AGROCHEMICALS:
    'Manufacture of fertilizers and agrochemicals',
  MANUFACTURE_OF_PLASTICS_AND_SYNTHETIC_RUBBER_IN_PRIMARY_FORMS:
    'Manufacture of plastics and synthetic rubber in primary forms',
  MANUFACTURE_OF_PAINTS_VARNISHES_AND_PRINTING_INK:
    'Manufacture of paints, varnishes and printing ink',
  MANUFACTURE_OF_SOAP_DETERGENTS_AND_PERSONAL_CARE_PRODUCTS:
    'Manufacture of soap, detergents and personal care products',
  MANUFACTURE_OF_OTHER_CHEMICAL_PRODUCTS:
    'Manufacture of other chemical products',
  MEMBERSHIP_ORGANIZATIONS: 'Membership organizations',
  SOCIAL_ADVOCACY_SERVICES: 'Social advocacy services',
  COMMUNITY_AND_NEIGHBORHOOD_ORGANIZATIONS:
    'Community and neighborhood organizations',
  ROAD_AND_RAILWAY_CONSTRUCTION: 'Road and railway construction',
  UTILITY_PROJECTS_CONSTRUCTION: 'Utility projects construction',
  OTHER_CIVIL_ENGINEERING_PROJECTS: 'Other civil engineering projects',
  REAL_ESTATE_ACTIVITIES_WITH_OWN_OR_LEASED_PROPERTY:
    'Real estate activities with own or leased property',
  REAL_ESTATE_ACTIVITIES_ON_A_FEE_OR_CONTRACT_BASIS:
    'Real estate activities on a fee or contract basis',
  DEVELOPMENT_OF_BUILDING_PROJECTS: 'Development of building projects',
  COMMERCIAL_PROPERTY_MANAGEMENT: 'Commercial property management',
  CYBERSECURITY_SERVICES: 'Cybersecurity services',
  COMPUTER_PROGRAMMING_AND_CONSULTANCY: 'Computer programming and consultancy',
  DATA_PROCESSING_AND_HOSTING: 'Data processing and hosting',
  IT_INFRASTRUCTURE_MANAGEMENT: 'IT infrastructure management',
  GAME_PUBLISHING: 'Game publishing',
  GAME_DEVELOPMENT: 'Game development',
  DIGITAL_DISTRIBUTION_PLATFORMS: 'Digital distribution platforms',
  COMPUTER_AND_PERIPHERALS_MANUFACTURING:
    'Computer and peripherals manufacturing',
  WHOLESALE_OF_COMPUTERS_PERIPHERALS_AND_SOFTWARE:
    'Wholesale of computers, peripherals and software',
  RETAIL_SALE_OF_COMPUTERS_AND_SOFTWARE:
    'Retail sale of computers and software',
  REPAIR_OF_COMPUTERS_AND_PERIPHERAL_EQUIPMENT:
    'Repair of computers and peripheral equipment',
  MANUFACTURE_OF_COMMUNICATION_EQUIPMENT:
    'Manufacture of communication equipment',
  WIRED_TELECOMMUNICATIONS_ACTIVITIES: 'Wired telecommunications activities',
  WIRELESS_TELECOMMUNICATIONS_ACTIVITIES:
    'Wireless telecommunications activities',
  COMPUTER_FACILITIES_MANAGEMENT_ACTIVITIES:
    'Computer facilities management activities',
  SOFTWARE_PUBLISHING: 'Software publishing',
  COMPUTER_PROGRAMMING_ACTIVITIES: 'Computer programming activities',
  COMPUTER_CONSULTANCY_ACTIVITIES: 'Computer consultancy activities',
  DATA_PROCESSING_HOSTING_AND_RELATED_ACTIVITIES:
    'Data processing, hosting and related activities',
  WEB_PORTALS: 'Web portals',
  ONLINE_PUBLISHING_AND_CONTENT_PLATFORMS:
    'Online publishing and content platforms',
  OTHER_INFORMATION_TECHNOLOGY_AND_COMPUTER_SERVICES:
    'Other information technology and computer services',
  RESIDENTIAL_BUILDING_CONSTRUCTION: 'Residential building construction',
  NON_RESIDENTIAL_BUILDING_CONSTRUCTION:
    'Non-residential building construction',
  CIVIL_ENGINEERING_PROJECTS: 'Civil engineering projects',
  ELECTRICAL_PLUMBING_AND_OTHER_INSTALLATION_SERVICES:
    'Electrical, plumbing and other installation services',
  BUILDING_COMPLETION_AND_FINISHING: 'Building completion and finishing',
  DEMOLITION_AND_SITE_PREPARATION: 'Demolition and site preparation',
  CONSUMER_ELECTRONICS_MANUFACTURING: 'Consumer electronics manufacturing',
  WHOLESALE_OF_ELECTRONIC_AND_TELECOM_EQUIPMENT:
    'Wholesale of electronic and telecom equipment',
  RETAIL_SALE_OF_AUDIO_AND_VIDEO_EQUIPMENT:
    'Retail sale of audio and video equipment',
  REPAIR_OF_CONSUMER_ELECTRONICS: 'Repair of consumer electronics',
  HOUSEHOLD_GOODS_MANUFACTURING: 'Household goods manufacturing',
  WHOLESALE_OF_HOUSEHOLD_GOODS: 'Wholesale of household goods',
  RETAIL_SALE_OF_HOUSEHOLD_GOODS: 'Retail sale of household goods',
  PERSONAL_CARE_SERVICES: 'Personal care services',
  TRAVEL_AGENCY_AND_TOUR_OPERATOR_ACTIVITIES:
    'Travel agency and tour operator activities',
  OTHER_RESERVATION_SERVICES: 'Other reservation services',
  FUNERAL_AND_RELATED_ACTIVITIES: 'Funeral and related activities',
  DRY_CLEANING_AND_LAUNDRY_SERVICES: 'Dry-cleaning and laundry services',
  MANUFACTURE_OF_PERFUMES_AND_TOILET_PREPARATIONS:
    'Manufacture of perfumes and toilet preparations',
  WHOLESALE_OF_PERFUMERY_AND_COSMETICS: 'Wholesale of perfumery and cosmetics',
  RETAIL_SALE_OF_COSMETIC_AND_TOILET_ARTICLES:
    'Retail sale of cosmetic and toilet articles',
  DEFENCE_ACTIVITIES: 'Defence activities',
  MANUFACTURE_OF_WEAPONS_AND_AMMUNITION:
    'Manufacture of weapons and ammunition',
  MANUFACTURE_OF_AIRCRAFT_AND_SPACECRAFT:
    'Manufacture of aircraft and spacecraft',
  SPACE_TECHNOLOGY_AND_SERVICES: 'Space technology and services',
  REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_DEFENCE_EQUIPMENT:
    'Repair and maintenance of aircraft and defence equipment',
  SPECIALISED_DESIGN_ACTIVITIES: 'Specialised design activities',
  ARCHITECTURAL_AND_ENGINEERING_DESIGN: 'Architectural and engineering design',
  ADVERTISING_AND_CREATIVE_CONSULTANCY: 'Advertising and creative consultancy',
  B2B: 'B2B',
  B2C: 'B2C',
  D2C: 'D2C',
  C2C_MARKETPLACES: 'C2C (marketplaces)',
  EDUCATIONAL_SUPPORT_ACTIVITIES: 'Educational support activities',
  EDUCATION_ADMINISTRATION_SERVICES: 'Education administration services',
  ONLINE_EDUCATION_PLATFORMS: 'Online education platforms',
  OTHER_EDUCATION_SERVICES: 'Other education services',
  MANUFACTURE_OF_ELECTRONIC_COMPONENTS: 'Manufacture of electronic components',
  MANUFACTURE_OF_ELECTRICAL_EQUIPMENT: 'Manufacture of electrical equipment',
  MANUFACTURE_OF_INSTRUMENTS_AND_MEASURING_DEVICES:
    'Manufacture of instruments and measuring devices',
  MANUFACTURE_OF_DOMESTIC_APPLIANCES: 'Manufacture of domestic appliances',
  PERFORMING_ARTS: 'Performing arts',
  OPERATION_OF_ARTS_FACILITIES: 'Operation of arts facilities',
  OTHER_AMUSEMENT_AND_RECREATION_ACTIVITIES:
    'Other amusement and recreation activities',
  SUPPORT_ACTIVITIES_TO_PERFORMING_ARTS:
    'Support activities to performing arts',
  COLLECTION_OF_NON_HAZARDOUS_WASTE: 'Collection of non-hazardous waste',
  TREATMENT_AND_DISPOSAL_OF_WASTE: 'Treatment and disposal of waste',
  MATERIALS_RECOVERY: 'Materials recovery',
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICES:
    'Remediation and other waste management services',
  ENVIRONMENTAL_CONSULTING_SERVICES: 'Environmental consulting services',
  CONVENTION_AND_TRADE_SHOW_ORGANIZERS: 'Convention and trade show organizers',
  EVENT_MANAGEMENT_SERVICES: 'Event management services',
  CATERING_SERVICES: 'Catering services',
  CORPORATE_HEADQUARTERS: 'Corporate headquarters',
  GENERAL_PUBLIC_ADMINISTRATION_ACTIVITIES:
    'General public administration activities',
  MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES:
    'Management of companies and enterprises',
  COMBINED_FACILITIES_SUPPORT_SERVICES: 'Combined facilities support services',
  CLEANING_SERVICES: 'Cleaning services',
  LANDSCAPE_CARE_AND_MAINTENANCE: 'Landscape care and maintenance',
  SECURITY_SYSTEMS_SERVICES: 'Security systems services',
  GROWING_OF_NON_PERENNIAL_CROPS: 'Growing of non-perennial crops',
  GROWING_OF_PERENNIAL_CROPS: 'Growing of perennial crops',
  ANIMAL_PRODUCTION: 'Animal production',
  MIXED_FARMING: 'Mixed farming',
  SUPPORT_ACTIVITIES_TO_AGRICULTURE: 'Support activities to agriculture',
  OTHER_FINANCIAL_SERVICE_ACTIVITIES: 'Other financial service activities',
  FINANCIAL_LEASING: 'Financial leasing',
  FUND_MANAGEMENT_ACTIVITIES: 'Fund management activities',
  PAYMENT_PROCESSING_SERVICES: 'Payment processing services',
  CONSUMER_LENDING: 'Consumer lending',
  BUSINESS_LENDING: 'Business lending',
  CONSUMER_AND_COMMERCIAL_BANKING: 'Consumer & commercial banking',
  CONSUMER_PAYMENTS: 'Consumer payments',
  CROWDFUNDING: 'Crowdfunding',
  CRYPTO: 'Crypto',
  INTERNATIONAL_MONEY_TRANSFER: 'International money transfer',
  PERSONAL_FINANCE: 'Personal finance',
  KIDS_FINANCE: 'Kids finance',
  SMBS: 'SMBs',
  POINT_OF_SALES: 'Point of Sales',
  CREATIVE_ARTS_AND_ENTERTAINMENT_ACTIVITIES:
    'Creative, arts and entertainment activities',
  MUSEUMS_AND_GALLERIES: 'Museums and galleries',
  RETAIL_SALE_OF_ART_WORKS_AND_ANTIQUES:
    'Retail sale of art works and antiques',
  FISHING: 'Fishing',
  AQUACULTURE: 'Aquaculture',
  PROCESSING_AND_PRESERVING_OF_FISH_AND_SEAFOOD:
    'Processing and preserving of fish and seafood',
  EVENT_CATERING_AND_OTHER_FOOD_SERVICE_ACTIVITIES:
    'Event catering and other food service activities',
  VERTICALISED_DIGITAL_SUPERMARKETS: 'Verticalised digital supermarkets',
  TECH_ENABLED_AND_ALTERNATIVE_OFFLINE_MODELS:
    'Tech-enabled & Alternative offline models',
  SUPERMARKETS: 'Supermarkets',
  RESTAURANT: 'Restaurant',
  PRODUCT_DISCOVERY_AND_CURATION: 'Product discovery & Curation',
  PET_FOOD: 'Pet food',
  PERSONAL_SHOPPERS: 'Personal shoppers',
  ONLINE_ENABLERS: 'Online enablers',
  NICHE_OR_LOCAL_OFFERING: 'Niche or local offering',
  MEALKITS_AND_PREPARED_MEALS: 'Mealkits & Prepared meals',
  INTEGRATED_DIGITAL_SUPERMARKETS: 'Integrated digital supermarkets',
  FOOD_AND_GROCERY_RESCUE: 'Food & Grocery rescue',
  FOOD_AND_GROCERY_DELIVERY: 'Food & Grocery delivery',
  DISTRIBUTORS_MARKETPLACE: 'Distributors marketplace',
  DELIVERY_SPECIALISTS: 'Delivery specialists',
  BROKERS: 'Brokers',
  BEVERAGES: 'Beverages',
  CHARITABLE_FUND_RAISING_ACTIVITIES: 'Charitable fund-raising activities',
  PUBLIC_RELATIONS_AND_COMMUNICATION_SERVICES:
    'Public relations and communication services',
  MANUFACTURE_OF_FURNITURE: 'Manufacture of furniture',
  WHOLESALE_OF_FURNITURE_AND_LIGHTING_EQUIPMENT:
    'Wholesale of furniture and lighting equipment',
  RETAIL_SALE_OF_FURNITURE: 'Retail sale of furniture',
  GAMBLING_AND_BETTING_ACTIVITIES: 'Gambling and betting activities',
  OPERATION_OF_SPORTS_FACILITIES: 'Operation of sports facilities',
  MANUFACTURE_OF_CERAMIC_PRODUCTS: 'Manufacture of ceramic products',
  MANUFACTURE_OF_ARTICLES_OF_CONCRETE_CEMENT_AND_PLASTER:
    'Manufacture of articles of concrete, cement and plaster',
  REGULATION_OF_HEALTH_EDUCATION_AND_CULTURAL_SERVICES:
    'Regulation of health, education and cultural services',
  PUBLIC_ORDER_AND_SAFETY_ACTIVITIES: 'Public order and safety activities',
  PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES:
    'Public relations and communication activities',
  LOBBYING_AND_PUBLIC_AFFAIRS_SERVICES: 'Lobbying and public affairs services',
  BUSINESS_AND_EMPLOYERS_MEMBERSHIP_ORGANIZATIONS:
    'Business and employers membership organizations',
  GRAPHIC_DESIGN_SERVICES: 'Graphic design services',
  ADVERTISING_SERVICES: 'Advertising services',
  OTHER_PROFESSIONAL_DESIGN_SERVICES: 'Other professional design services',
  FITNESS_CENTRES: 'Fitness centres',
  WELLNESS_SERVICES: 'Wellness services',
  OTHER_HUMAN_HEALTH_SERVICES: 'Other human health services',
  RECREATION_AND_SPORTS_ACTIVITIES: 'Recreation and sports activities',
  TERTIARY_EDUCATION: 'Tertiary education',
  RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_SOCIAL_SCIENCES:
    'Research and experimental development (social sciences)',
  HOSPITAL_ACTIVITIES: 'Hospital activities',
  MEDICAL_AND_DENTAL_PRACTICE_ACTIVITIES:
    'Medical and dental practice activities',
  OTHER_HUMAN_HEALTH_ACTIVITIES: 'Other human health activities',
  RESIDENTIAL_NURSING_CARE_ACTIVITIES: 'Residential nursing care activities',
  SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION:
    'Social work activities without accommodation',
  HOTELS_AND_SIMILAR_ACCOMMODATION: 'Hotels and similar accommodation',
  HOLIDAY_AND_SHORT_STAY_ACCOMMODATION: 'Holiday and short-stay accommodation',
  EMPLOYMENT_PLACEMENT_AGENCIES: 'Employment placement agencies',
  TEMPORARY_EMPLOYMENT_AGENCY_ACTIVITIES:
    'Temporary employment agency activities',
  HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_SERVICES:
    'Human resources provision and management services',
  MANAGEMENT_CONSULTANCY_ACTIVITIES: 'Management consultancy activities',
  WHOLESALE_ON_A_FEE_OR_CONTRACT_BASIS: 'Wholesale on a fee or contract basis',
  NON_SPECIALISED_WHOLESALE_TRADE: 'Non-specialised wholesale trade',
  FREIGHT_TRANSPORT_BY_ROAD: 'Freight transport by road',
  SEA_AND_COASTAL_FREIGHT_WATER_TRANSPORT:
    'Sea and coastal freight water transport',
  AIR_FREIGHT_TRANSPORT: 'Air freight transport',
  CUSTOMS_AGENCY_AND_FREIGHT_FORWARDING_SERVICES:
    'Customs agency and freight forwarding services',
  CHILD_DAY_CARE_ACTIVITIES: 'Child day-care activities',
  RESIDENTIAL_CARE_ACTIVITIES: 'Residential care activities',
  COUNSELING_SERVICES: 'Counseling services',
  MANUFACTURE_OF_INSTRUMENTS_AND_CONTROL_SYSTEMS:
    'Manufacture of instruments and control systems',
  INSTALLATION_OF_INDUSTRIAL_MACHINERY_AND_EQUIPMENT:
    'Installation of industrial machinery and equipment',
  ENGINEERING_DESIGN_AND_CONSULTING_SERVICES:
    'Engineering design and consulting services',
  INDUSTRIAL_PROCESS_AUTOMATION_SERVICES:
    'Industrial process automation services',
  OTHER_INFORMATION_SERVICE_ACTIVITIES: 'Other information service activities',
  COMPUTER_PROGRAMMING_CONSULTANCY_AND_RELATED_ACTIVITIES:
    'Computer programming, consultancy and related activities',
  IT_SUPPORT_AND_MANAGED_SERVICES: 'IT support and managed services',
  LIFE_INSURANCE: 'Life insurance',
  NON_LIFE_INSURANCE: 'Non-life insurance',
  REINSURANCE: 'Reinsurance',
  ACTIVITIES_AUXILIARY_TO_INSURANCE_AND_PENSION_FUNDING:
    'Activities auxiliary to insurance and pension funding',
  FOREIGN_AFFAIRS_ADMINISTRATION: 'Foreign affairs administration',
  ACTIVITIES_OF_INTERNATIONAL_ORGANIZATIONS:
    'Activities of international organizations',
  INTERNATIONAL_DEVELOPMENT_ACTIVITIES: 'International development activities',
  INTERNATIONAL_TRADE_SERVICES: 'International trade services',
  DEVELOPMENT_ORGANIZATIONS: 'Development organizations',
  INVESTMENT_BANKING: 'Investment banking',
  SECURITIES_TRADING: 'Securities trading',
  CORPORATE_FINANCE_ADVISORY: 'Corporate finance advisory',
  ASSET_MANAGEMENT: 'Asset management',
  PORTFOLIO_MANAGEMENT_SERVICES: 'Portfolio management services',
  ACTIVITIES_OF_TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES:
    'Activities of trusts, funds and similar financial entities',
  JUDICIAL_COURTS: 'Judicial courts',
  JUSTICE_ADMINISTRATION_SERVICES: 'Justice administration services',
  LEGAL_SUPPORT_SERVICES: 'Legal support services',
  POLICE_SERVICES: 'Police services',
  SECURITY_SERVICES: 'Security services',
  LEGAL_PRACTICE: 'Legal practice',
  NOTARIAL_SERVICES: 'Notarial services',
  ARBITRATION_AND_MEDIATION: 'Arbitration and mediation',
  INTELLECTUAL_PROPERTY_LEGAL_SERVICES: 'Intellectual property legal services',
  LEGAL_SERVICES: 'Legal services',
  PATENT_AND_COPYRIGHT_AGENCY_SERVICES: 'Patent and copyright agency services',
  LEGISLATIVE_ACTIVITIES: 'Legislative activities',
  GOVERNMENT_BODIES: 'Government bodies',
  PUBLIC_ADMINISTRATION_AND_DEFENCE: 'Public administration and defence',
  AMUSEMENT_AND_THEME_PARK_ACTIVITIES: 'Amusement and theme park activities',
  LIBRARY_AND_ARCHIVES_ACTIVITIES: 'Library and archives activities',
  CULTURAL_EDUCATION_SERVICES: 'Cultural education services',
  MUSEUM_ACTIVITIES_AND_OPERATION_OF_HISTORICAL_SITES:
    'Museum activities and operation of historical sites',
  FREIGHT_RAIL_TRANSPORT: 'Freight rail transport',
  INLAND_FREIGHT_WATER_TRANSPORT: 'Inland freight water transport',
  CARGO_HANDLING: 'Cargo handling',
  WAREHOUSING_AND_STORAGE: 'Warehousing and storage',
  OTHER_TRANSPORTATION_SUPPORT_ACTIVITIES:
    'Other transportation support activities',
  WHOLESALE_OF_JEWELLERY_AND_LUXURY_GOODS:
    'Wholesale of jewellery and luxury goods',
  RETAIL_SALE_OF_WATCHES_AND_JEWELLERY: 'Retail sale of watches and jewellery',
  MANUFACTURE_OF_GENERAL_PURPOSE_MACHINERY:
    'Manufacture of general-purpose machinery',
  MANUFACTURE_OF_SPECIAL_PURPOSE_MACHINERY:
    'Manufacture of special-purpose machinery',
  REPAIR_OF_MACHINERY_AND_EQUIPMENT: 'Repair of machinery and equipment',
  WHOLESALE_OF_MACHINERY_EQUIPMENT_AND_SUPPLIES:
    'Wholesale of machinery, equipment and supplies',
  BUSINESS_AND_MANAGEMENT_CONSULTANCY: 'Business and management consultancy',
  STRATEGY_CONSULTING: 'Strategy consulting',
  OPERATIONS_AND_PROCESS_IMPROVEMENT_CONSULTING:
    'Operations and process improvement consulting',
  SEA_AND_COASTAL_PASSENGER_WATER_TRANSPORT:
    'Sea and coastal passenger water transport',
  SERVICE_ACTIVITIES_INCIDENTAL_TO_WATER_TRANSPORTATION:
    'Service activities incidental to water transportation',
  PORT_AND_HARBOUR_OPERATIONS: 'Port and harbour operations',
  SHIPBUILDING_AND_REPAIR: 'Shipbuilding and repair',
  MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING:
    'Market research and public opinion polling',
  DATA_ANALYTICS_AND_CONSUMER_INSIGHTS_SERVICES:
    'Data analytics and consumer insights services',
  ADVERTISING_AGENCIES: 'Advertising agencies',
  MEDIA_REPRESENTATION: 'Media representation',
  DIGITAL_MARKETING_SERVICES: 'Digital marketing services',
  ENGINEERING_ACTIVITIES_AND_RELATED_TECHNICAL_CONSULTANCY:
    'Engineering activities and related technical consultancy',
  MOTION_PICTURE_VIDEO_AND_TELEVISION_PROGRAMME_PRODUCTION:
    'Motion picture, video and television programme production',
  SOUND_RECORDING_AND_MUSIC_PUBLISHING: 'Sound recording and music publishing',
  MANUFACTURE_OF_MEDICAL_AND_DENTAL_INSTRUMENTS_AND_SUPPLIES:
    'Manufacture of medical and dental instruments and supplies',
  WHOLESALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS:
    'Wholesale of pharmaceutical and medical goods',
  RETAIL_SALE_OF_MEDICAL_AND_ORTHOPAEDIC_GOODS:
    'Retail sale of medical and orthopaedic goods',
  REPAIR_OF_MEDICAL_EQUIPMENT: 'Repair of medical equipment',
  GENERAL_MEDICAL_PRACTICE_ACTIVITIES: 'General medical practice activities',
  SPECIALIST_MEDICAL_PRACTICE_ACTIVITIES:
    'Specialist medical practice activities',
  DIAGNOSTIC_IMAGING_SERVICES: 'Diagnostic imaging services',
  RESIDENTIAL_CARE_FOR_MENTAL_HEALTH_AND_SUBSTANCE_ABUSE:
    'Residential care for mental health and substance abuse',
  COUNSELING_AND_PSYCHOTHERAPY_SERVICES:
    'Counseling and psychotherapy services',
  SUPPORT_ACTIVITIES_FOR_DEFENCE_OPERATIONS:
    'Support activities for defence operations',
  MINING_OF_COAL_AND_LIGNITE: 'Mining of coal and lignite',
  EXTRACTION_OF_CRUDE_PETROLEUM_AND_NATURAL_GAS:
    'Extraction of crude petroleum and natural gas',
  MINING_OF_METAL_ORES: 'Mining of metal ores',
  OTHER_MINING_AND_QUARRYING: 'Other mining and quarrying',
  SUPPORT_ACTIVITIES_FOR_MINING: 'Support activities for mining',
  CASTING_OF_METALS: 'Casting of metals',
  FINANCE_AND_INSURANCE: 'Finance & Insurance',
  MAPPING_AND_NAVIGATION: 'Mapping & Navigation',
  MICRO_MOBILITY: 'Micro mobility',
  MOBILITY_SERVICES: 'Mobility services',
  PARKING_AND_SMART_CITY: 'Parking & Smart city',
  RIDE_SHARING: 'Ride sharing',
  VEHICLE_MARKEPLACE_AND_AFTERMARKET: 'Vehicle markeplace & Aftermarket',
  MOTION_PICTURE_PRODUCTION: 'Motion picture production',
  MOTION_PICTURE_DISTRIBUTION: 'Motion picture distribution',
  MOTION_PICTURE_PROJECTION: 'Motion picture projection',
  BOTANICAL_AND_ZOOLOGICAL_GARDENS_AND_NATURE_RESERVES:
    'Botanical and zoological gardens and nature reserves',
  MUSIC_PERFORMANCE_ACTIVITIES: 'Music performance activities',
  RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_NATURAL_SCIENCES_AND_ENGINEERING:
    'Research and experimental development on natural sciences and engineering',
  ADVANCED_MATERIALS_MANUFACTURING: 'Advanced materials manufacturing',
  PUBLISHING_OF_NEWSPAPERS_JOURNALS_AND_PERIODICALS:
    'Publishing of newspapers, journals and periodicals',
  PRINTING_ACTIVITIES: 'Printing activities',
  RETAIL_SALE_OF_NEWSPAPERS_AND_STATIONERY:
    'Retail sale of newspapers and stationery',
  ACTIVITIES_OF_OTHER_MEMBERSHIP_ORGANIZATIONS:
    'Activities of other membership organizations',
  EXTRACTION_OF_CRUDE_PETROLEUM: 'Extraction of crude petroleum',
  EXTRACTION_OF_NATURAL_GAS: 'Extraction of natural gas',
  SUPPORT_ACTIVITIES_FOR_PETROLEUM_AND_NATURAL_GAS_EXTRACTION:
    'Support activities for petroleum and natural gas extraction',
  MANUFACTURE_OF_REFINED_PETROLEUM_PRODUCTS:
    'Manufacture of refined petroleum products',
  ELECTRIC_POWER_GENERATION_TRANSMISSION_AND_DISTRIBUTION:
    'Electric power generation, transmission and distribution',
  TRADE_OF_GAS_THROUGH_MAINS: 'Trade of gas through mains',
  OTHER_INFORMATION_SERVICES: 'Other information services',
  ONLINE_PUBLISHING_OF_JOURNALS_AND_PERIODICALS:
    'Online publishing of journals and periodicals',
  DIGITAL_NEWS_AND_MEDIA_AGGREGATION: 'Digital news and media aggregation',
  BUSINESS_PROCESS_OUTSOURCING_SERVICES:
    'Business process outsourcing services',
  CALL_CENTRES_AND_TELEPHONE_BASED_SUPPORT_SERVICES:
    'Call centres and telephone-based support services',
  BACK_OFFICE_SUPPORT_AND_DATA_PROCESSING:
    'Back-office support and data processing',
  POSTAL_ACTIVITIES: 'Postal activities',
  COURIER_ACTIVITIES: 'Courier activities',
  MANUFACTURE_OF_PAPER_AND_PAPERBOARD_CONTAINERS:
    'Manufacture of paper and paperboard containers',
  MANUFACTURE_OF_PLASTIC_PACKING_GOODS: 'Manufacture of plastic packing goods',
  MANUFACTURE_OF_GLASS_CONTAINERS: 'Manufacture of glass containers',
  WHOLESALE_OF_PACKAGING_MATERIALS: 'Wholesale of packaging materials',
  MANUFACTURE_OF_PULP_PAPER_AND_PAPERBOARD:
    'Manufacture of pulp, paper and paperboard',
  MANUFACTURE_OF_CORRUGATED_PAPER_AND_CONTAINERS:
    'Manufacture of corrugated paper and containers',
  LOGGING: 'Logging',
  SAWMILLING_AND_PLANING_OF_WOOD: 'Sawmilling and planing of wood',
  WHOLESALE_OF_WOOD_AND_CONSTRUCTION_MATERIALS:
    'Wholesale of wood and construction materials',
  MANUFACTURE_OF_PHARMACEUTICALS_MEDICINAL_CHEMICAL_AND_BOTANICAL_PRODUCTS:
    'Manufacture of pharmaceuticals, medicinal chemical and botanical products',
  WHOLESALE_OF_PHARMACEUTICAL_GOODS: 'Wholesale of pharmaceutical goods',
  RETAIL_SALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS:
    'Retail sale of pharmaceutical and medical goods',
  BIOPHARMACEUTICAL_RESEARCH_AND_DEVELOPMENT:
    'Biopharmaceutical research and development',
  GRANT_MAKING_ACTIVITIES: 'Grant-making activities',
  PHOTOGRAPHIC_ACTIVITIES: 'Photographic activities',
  RETAIL_SALE_OF_PHOTOGRAPHIC_EQUIPMENT:
    'Retail sale of photographic equipment',
  IMAGING_AND_PHOTO_PROCESSING_SERVICES:
    'Imaging and photo processing services',
  MANUFACTURE_OF_PLASTICS_IN_PRIMARY_FORMS:
    'Manufacture of plastics in primary forms',
  MANUFACTURE_OF_PLASTIC_PRODUCTS: 'Manufacture of plastic products',
  WHOLESALE_OF_CHEMICAL_PRODUCTS: 'Wholesale of chemical products',
  RECYCLING_OF_PLASTIC_MATERIALS: 'Recycling of plastic materials',
  ACTIVITIES_OF_POLITICAL_ORGANIZATIONS:
    'Activities of political organizations',
  CIVIC_AND_SOCIAL_ORGANIZATIONS: 'Civic and social organizations',
  PRIMARY_EDUCATION: 'Primary education',
  SECONDARY_EDUCATION: 'Secondary education',
  PRINTING: 'Printing',
  SERVICE_ACTIVITIES_RELATED_TO_PRINTING:
    'Service activities related to printing',
  MANUFACTURE_OF_PRINTING_INK: 'Manufacture of printing ink',
  OTHER_EDUCATION_N_E_C: 'Other education n.e.c.',
  BUSINESS_AND_MANAGEMENT_TRAINING: 'Business and management training',
  COACHING_SERVICES: 'Coaching services',
  PUBLIC_ADMINISTRATION_AND_DEFENCE_POLICY_PLANNING:
    'Public administration and defence policy planning',
  POLICY_RESEARCH_SERVICES: 'Policy research services',
  CORPORATE_COMMUNICATIONS_SERVICES: 'Corporate communications services',
  FIRE_SERVICE_ACTIVITIES: 'Fire service activities',
  DISASTER_AND_EMERGENCY_RESPONSE_ACTIVITIES:
    'Disaster and emergency response activities',
  BOOK_PUBLISHING: 'Book publishing',
  OTHER_PUBLISHING_ACTIVITIES: 'Other publishing activities',
  MANUFACTURE_OF_RAILWAY_LOCOMOTIVES_AND_ROLLING_STOCK:
    'Manufacture of railway locomotives and rolling stock',
  REPAIR_OF_TRANSPORT_EQUIPMENT: 'Repair of transport equipment',
  WHOLESALE_OF_MACHINERY_AND_EQUIPMENT: 'Wholesale of machinery and equipment',
  SUPPORT_ACTIVITIES_FOR_ANIMAL_PRODUCTION:
    'Support activities for animal production',
  PROCESSING_OF_MEAT_AND_MEAT_PRODUCTS: 'Processing of meat and meat products',
  AGGREGATORS: 'Aggregators',
  MARKETPLACES: 'Marketplaces',
  NEW_WAY_OF_LIVING: 'New way of living',
  NO_AGENT_NEEDED: 'No agent needed',
  PROPERTY_AGENT_AND_AGENT_MATCHING: 'Property agent & Agent matching',
  PROPERTY_MANAGEMENT: 'Property management',
  PROPERTY_SEARCH: 'Property Search',
  SHORT_TERM_RENTALS: 'Short term rentals',
  TRADITIONAL_RE_AGENCIES: 'Traditional RE agencies',
  PARKS_AND_RECREATIONAL_ACTIVITIES: 'Parks and recreational activities',
  ACTIVITIES_OF_RELIGIOUS_ORGANIZATIONS:
    'Activities of religious organizations',
  RELIGIOUS_EDUCATION: 'Religious education',
  CHARITABLE_ACTIVITIES_BY_RELIGIOUS_ORGANIZATIONS:
    'Charitable activities by religious organizations',
  ELECTRIC_POWER_GENERATION_FROM_RENEWABLE_SOURCES:
    'Electric power generation from renewable sources',
  MANUFACTURE_OF_RENEWABLE_ENERGY_EQUIPMENT:
    'Manufacture of renewable energy equipment',
  ENVIRONMENTAL_CONSULTING_ACTIVITIES: 'Environmental consulting activities',
  WASTE_COLLECTION_AND_MATERIALS_RECOVERY:
    'Waste collection and materials recovery',
  RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_SOCIAL_SCIENCES_AND_HUMANITIES:
    'Research and experimental development on social sciences and humanities',
  RETAIL_SALE_IN_NON_SPECIALISED_STORES:
    'Retail sale in non-specialised stores',
  RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO:
    'Retail sale of food, beverages and tobacco',
  RETAIL_SALE_OF_OTHER_GOODS_IN_SPECIALISED_STORES:
    'Retail sale of other goods in specialised stores',
  RETAIL_SALE_VIA_STALLS_AND_MARKETS: 'Retail sale via stalls and markets',
  RETAIL_SALE_VIA_MAIL_ORDER_OR_INTERNET:
    'Retail sale via mail order or Internet',
  PRIVATE_SECURITY_ACTIVITIES: 'Private security activities',
  SECURITY_SYSTEMS_SERVICE_ACTIVITIES: 'Security systems service activities',
  INVESTIGATION_ACTIVITIES: 'Investigation activities',
  MANUFACTURE_OF_LOADED_ELECTRONIC_BOARDS:
    'Manufacture of loaded electronic boards',
  WHOLESALE_OF_ELECTRONIC_COMPONENTS: 'Wholesale of electronic components',
  RANDD_IN_MICROELECTRONICS: 'R&D in microelectronics',
  BUILDING_OF_SHIPS_AND_FLOATING_STRUCTURES:
    'Building of ships and floating structures',
  BUILDING_OF_PLEASURE_AND_SPORTING_BOATS:
    'Building of pleasure and sporting boats',
  REPAIR_AND_MAINTENANCE_OF_SHIPS_AND_BOATS:
    'Repair and maintenance of ships and boats',
  MANUFACTURE_OF_SPORTS_GOODS: 'Manufacture of sports goods',
  WHOLESALE_OF_SPORTING_GOODS: 'Wholesale of sporting goods',
  RETAIL_SALE_OF_SPORTING_EQUIPMENT: 'Retail sale of sporting equipment',
  SPORTS_CLUB_ACTIVITIES: 'Sports club activities',
  SPORTS_AND_RECREATION_INSTRUCTION: 'Sports and recreation instruction',
  OTHER_SPORTS_ACTIVITIES: 'Other sports activities',
  HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_OF_HUMAN_RESOURCES_FUNCTIONS:
    'Human resources provision and management of human resources functions',
  RETAIL_SALE_IN_NON_SPECIALISED_STORES_WITH_FOOD_BEVERAGES_OR_TOBACCO_PREDOMINATING:
    'Retail sale in non-specialised stores with food, beverages or tobacco predominating',
  RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO_IN_SPECIALISED_STORES:
    'Retail sale of food, beverages and tobacco in specialised stores',
  WHOLESALE_OF_FOOD_BEVERAGES_AND_TOBACCO:
    'Wholesale of food, beverages and tobacco',
  E_COMMERCE_OF_GROCERIES: 'E-commerce of groceries',
  SATELLITE_TELECOMMUNICATIONS_ACTIVITIES:
    'Satellite telecommunications activities',
  OTHER_TELECOMMUNICATIONS_ACTIVITIES: 'Other telecommunications activities',
  DATA_PROCESSING_AND_HOSTING_SERVICES: 'Data processing and hosting services',
  PREPARATION_AND_SPINNING_OF_TEXTILE_FIBRES:
    'Preparation and spinning of textile fibres',
  WEAVING_OF_TEXTILES: 'Weaving of textiles',
  FINISHING_OF_TEXTILES: 'Finishing of textiles',
  MANUFACTURE_OF_OTHER_TEXTILES: 'Manufacture of other textiles',
  MANUFACTURE_OF_CARPETS_AND_RUGS: 'Manufacture of carpets and rugs',
  POLICY_RESEARCH_INSTITUTES: 'Policy research institutes',
  PUBLIC_POLICY_ADVISORY_SERVICES: 'Public policy advisory services',
  MANUFACTURE_OF_TOBACCO_PRODUCTS: 'Manufacture of tobacco products',
  WHOLESALE_OF_TOBACCO_PRODUCTS: 'Wholesale of tobacco products',
  RETAIL_SALE_OF_TOBACCO_PRODUCTS: 'Retail sale of tobacco products',
  TRANSLATION_AND_INTERPRETATION_ACTIVITIES:
    'Translation and interpretation activities',
  LOCALIZATION_SERVICES: 'Localization services',
  PUBLISHING_SUPPORT_SERVICES: 'Publishing support services',
  PASSENGER_RAIL_TRANSPORT: 'Passenger rail transport',
  URBAN_AND_SUBURBAN_PASSENGER_LAND_TRANSPORT:
    'Urban and suburban passenger land transport',
  MANUFACTURE_OF_GAS_DISTRIBUTION_OF_GASEOUS_FUELS_THROUGH_MAINS:
    'Manufacture of gas; distribution of gaseous fuels through mains',
  STEAM_AND_AIR_CONDITIONING_SUPPLY: 'Steam and air conditioning supply',
  WATER_COLLECTION_TREATMENT_AND_SUPPLY:
    'Water collection, treatment and supply',
  SEWERAGE: 'Sewerage',
  WASTE_MANAGEMENT_AND_MATERIALS_RECOVERY:
    'Waste management and materials recovery',
  VENTURE_CAPITAL_ACTIVITIES: 'Venture capital activities',
  PRIVATE_EQUITY_ACTIVITIES: 'Private equity activities',
  VETERINARY_ACTIVITIES: 'Veterinary activities',
  MANUFACTURE_OF_VETERINARY_PHARMACEUTICAL_PRODUCTS:
    'Manufacture of veterinary pharmaceutical products',
  RETAIL_SALE_OF_PET_FOOD_AND_PET_SUPPLIES:
    'Retail sale of pet food and pet supplies',
  FULFILMENT_AND_DISTRIBUTION_SERVICES: 'Fulfilment and distribution services',
  WHOLESALE_OF_INFORMATION_AND_COMMUNICATIONS_EQUIPMENT:
    'Wholesale of information and communications equipment',
  MANUFACTURE_OF_WINES: 'Manufacture of wines',
  MANUFACTURE_OF_SPIRITS: 'Manufacture of spirits',
  WHOLESALE_OF_BEVERAGES: 'Wholesale of beverages',
  RETAIL_SALE_OF_BEVERAGES_IN_SPECIALISED_STORES:
    'Retail sale of beverages in specialised stores',
  TELECOMMUNICATIONS_INFRASTRUCTURE_OPERATION:
    'Telecommunications infrastructure operation',
  EDITORIAL_SERVICES: 'Editorial services',
  CONTENT_WRITING: 'Content writing',
  PUBLISHING_SERVICES: 'Publishing services',
}

export const INDUSTRY_OPTIONS_TYPES_V2 = {
  'Accounting and auditing activities': 'ACCOUNTING_AND_AUDITING_ACTIVITIES',
  'Tax consultancy': 'TAX_CONSULTANCY',
  'Bookkeeping services': 'BOOKKEEPING_SERVICES',
  'Payroll processing services': 'PAYROLL_PROCESSING_SERVICES',
  'Passenger air transport': 'PASSENGER_AIR_TRANSPORT',
  'Freight air transport': 'FREIGHT_AIR_TRANSPORT',
  'Air transport support services': 'AIR_TRANSPORT_SUPPORT_SERVICES',
  'Airport operations': 'AIRPORT_OPERATIONS',
  'Legal and arbitration services': 'LEGAL_AND_ARBITRATION_SERVICES',
  'Mediation services': 'MEDIATION_SERVICES',
  'Other health services': 'OTHER_HEALTH_SERVICES',
  'Wellness and physical therapy services':
    'WELLNESS_AND_PHYSICAL_THERAPY_SERVICES',
  'Traditional and alternative medicine services':
    'TRADITIONAL_AND_ALTERNATIVE_MEDICINE_SERVICES',
  'Motion picture and video production': 'MOTION_PICTURE_AND_VIDEO_PRODUCTION',
  'Post-production services': 'POST_PRODUCTION_SERVICES',
  'Animation and visual effects services':
    'ANIMATION_AND_VISUAL_EFFECTS_SERVICES',
  'Television programme production': 'TELEVISION_PROGRAMME_PRODUCTION',
  'Manufacture of textiles': 'MANUFACTURE_OF_TEXTILES',
  'Manufacture of wearing apparel': 'MANUFACTURE_OF_WEARING_APPAREL',
  'Manufacture of leather and related products':
    'MANUFACTURE_OF_LEATHER_AND_RELATED_PRODUCTS',
  'Manufacture of footwear': 'MANUFACTURE_OF_FOOTWEAR',
  'Wholesale of household goods (incl. textiles, clothing, footwear)':
    'WHOLESALE_OF_HOUSEHOLD_GOODS_INCL_TEXTILES_CLOTHING_FOOTWEAR',
  'Retail sale of clothing, footwear and leather goods':
    'RETAIL_SALE_OF_CLOTHING_FOOTWEAR_AND_LEATHER_GOODS',
  'Architectural services': 'ARCHITECTURAL_SERVICES',
  'Urban and landscape planning': 'URBAN_AND_LANDSCAPE_PLANNING',
  'Engineering design services': 'ENGINEERING_DESIGN_SERVICES',
  'Technical consultancy services': 'TECHNICAL_CONSULTANCY_SERVICES',
  'Creative arts activities': 'CREATIVE_ARTS_ACTIVITIES',
  'Handicraft and artisan products': 'HANDICRAFT_AND_ARTISAN_PRODUCTS',
  'Manufacture of jewellery and related articles':
    'MANUFACTURE_OF_JEWELLERY_AND_RELATED_ARTICLES',
  'Manufacture of ceramic household and ornamental articles':
    'MANUFACTURE_OF_CERAMIC_HOUSEHOLD_AND_ORNAMENTAL_ARTICLES',
  'Retail sale of art and craft goods': 'RETAIL_SALE_OF_ART_AND_CRAFT_GOODS',
  'Manufacture of motor vehicles': 'MANUFACTURE_OF_MOTOR_VEHICLES',
  'Manufacture of parts and accessories for motor vehicles':
    'MANUFACTURE_OF_PARTS_AND_ACCESSORIES_FOR_MOTOR_VEHICLES',
  'Sale of motor vehicles': 'SALE_OF_MOTOR_VEHICLES',
  'Maintenance and repair of motor vehicles':
    'MAINTENANCE_AND_REPAIR_OF_MOTOR_VEHICLES',
  'Retail sale of automotive fuel': 'RETAIL_SALE_OF_AUTOMOTIVE_FUEL',
  'Renting and leasing of motor vehicles':
    'RENTING_AND_LEASING_OF_MOTOR_VEHICLES',
  'Manufacture of air and spacecraft and related machinery':
    'MANUFACTURE_OF_AIR_AND_SPACECRAFT_AND_RELATED_MACHINERY',
  'Repair and maintenance of aircraft and spacecraft':
    'REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_SPACECRAFT',
  'Service activities incidental to air transportation':
    'SERVICE_ACTIVITIES_INCIDENTAL_TO_AIR_TRANSPORTATION',
  'Space research and technology': 'SPACE_RESEARCH_AND_TECHNOLOGY',
  'Central banking': 'CENTRAL_BANKING',
  'Other monetary intermediation': 'OTHER_MONETARY_INTERMEDIATION',
  'Trusts, funds and similar financial entities':
    'TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
  'Activities of holding companies': 'ACTIVITIES_OF_HOLDING_COMPANIES',
  'Payment services and credit card issuing':
    'PAYMENT_SERVICES_AND_CREDIT_CARD_ISSUING',
  'Biotechnology research and development':
    'BIOTECHNOLOGY_RESEARCH_AND_DEVELOPMENT',
  'Pharmaceutical manufacturing': 'PHARMACEUTICAL_MANUFACTURING',
  'Clinical research services': 'CLINICAL_RESEARCH_SERVICES',
  'Radio broadcasting': 'RADIO_BROADCASTING',
  'Television programming and broadcasting':
    'TELEVISION_PROGRAMMING_AND_BROADCASTING',
  'Programme distribution services': 'PROGRAMME_DISTRIBUTION_SERVICES',
  'News agency activities': 'NEWS_AGENCY_ACTIVITIES',
  'Manufacture of cement, lime and plaster':
    'MANUFACTURE_OF_CEMENT_LIME_AND_PLASTER',
  'Manufacture of glass and glass products':
    'MANUFACTURE_OF_GLASS_AND_GLASS_PRODUCTS',
  'Manufacture of clay and concrete building materials':
    'MANUFACTURE_OF_CLAY_AND_CONCRETE_BUILDING_MATERIALS',
  'Wholesale of construction materials': 'WHOLESALE_OF_CONSTRUCTION_MATERIALS',
  'Wholesale of office equipment': 'WHOLESALE_OF_OFFICE_EQUIPMENT',
  'Manufacture of office equipment (non-computer)':
    'MANUFACTURE_OF_OFFICE_EQUIPMENT_NON_COMPUTER',
  'Retail sale of stationery and office supplies':
    'RETAIL_SALE_OF_STATIONERY_AND_OFFICE_SUPPLIES',
  'Securities and commodities brokerage':
    'SECURITIES_AND_COMMODITIES_BROKERAGE',
  'Administration of financial markets': 'ADMINISTRATION_OF_FINANCIAL_MARKETS',
  'Activities auxiliary to financial services':
    'ACTIVITIES_AUXILIARY_TO_FINANCIAL_SERVICES',
  'Asset and fund management': 'ASSET_AND_FUND_MANAGEMENT',
  'Manufacture of basic chemicals': 'MANUFACTURE_OF_BASIC_CHEMICALS',
  'Manufacture of fertilizers and agrochemicals':
    'MANUFACTURE_OF_FERTILIZERS_AND_AGROCHEMICALS',
  'Manufacture of plastics and synthetic rubber in primary forms':
    'MANUFACTURE_OF_PLASTICS_AND_SYNTHETIC_RUBBER_IN_PRIMARY_FORMS',
  'Manufacture of paints, varnishes and printing ink':
    'MANUFACTURE_OF_PAINTS_VARNISHES_AND_PRINTING_INK',
  'Manufacture of soap, detergents and personal care products':
    'MANUFACTURE_OF_SOAP_DETERGENTS_AND_PERSONAL_CARE_PRODUCTS',
  'Manufacture of other chemical products':
    'MANUFACTURE_OF_OTHER_CHEMICAL_PRODUCTS',
  'Membership organizations': 'MEMBERSHIP_ORGANIZATIONS',
  'Social advocacy services': 'SOCIAL_ADVOCACY_SERVICES',
  'Community and neighborhood organizations':
    'COMMUNITY_AND_NEIGHBORHOOD_ORGANIZATIONS',
  'Road and railway construction': 'ROAD_AND_RAILWAY_CONSTRUCTION',
  'Utility projects construction': 'UTILITY_PROJECTS_CONSTRUCTION',
  'Other civil engineering projects': 'OTHER_CIVIL_ENGINEERING_PROJECTS',
  'Real estate activities with own or leased property':
    'REAL_ESTATE_ACTIVITIES_WITH_OWN_OR_LEASED_PROPERTY',
  'Real estate activities on a fee or contract basis':
    'REAL_ESTATE_ACTIVITIES_ON_A_FEE_OR_CONTRACT_BASIS',
  'Development of building projects': 'DEVELOPMENT_OF_BUILDING_PROJECTS',
  'Commercial property management': 'COMMERCIAL_PROPERTY_MANAGEMENT',
  'Cybersecurity services': 'CYBERSECURITY_SERVICES',
  'Computer programming and consultancy':
    'COMPUTER_PROGRAMMING_AND_CONSULTANCY',
  'Data processing and hosting': 'DATA_PROCESSING_AND_HOSTING',
  'IT infrastructure management': 'IT_INFRASTRUCTURE_MANAGEMENT',
  'Game publishing': 'GAME_PUBLISHING',
  'Game development': 'GAME_DEVELOPMENT',
  'Digital distribution platforms': 'DIGITAL_DISTRIBUTION_PLATFORMS',
  'Computer and peripherals manufacturing':
    'COMPUTER_AND_PERIPHERALS_MANUFACTURING',
  'Wholesale of computers, peripherals and software':
    'WHOLESALE_OF_COMPUTERS_PERIPHERALS_AND_SOFTWARE',
  'Retail sale of computers and software':
    'RETAIL_SALE_OF_COMPUTERS_AND_SOFTWARE',
  'Repair of computers and peripheral equipment':
    'REPAIR_OF_COMPUTERS_AND_PERIPHERAL_EQUIPMENT',
  'Manufacture of communication equipment':
    'MANUFACTURE_OF_COMMUNICATION_EQUIPMENT',
  'Wired telecommunications activities': 'WIRED_TELECOMMUNICATIONS_ACTIVITIES',
  'Wireless telecommunications activities':
    'WIRELESS_TELECOMMUNICATIONS_ACTIVITIES',
  'Computer facilities management activities':
    'COMPUTER_FACILITIES_MANAGEMENT_ACTIVITIES',
  'Software publishing': 'SOFTWARE_PUBLISHING',
  'Computer programming activities': 'COMPUTER_PROGRAMMING_ACTIVITIES',
  'Computer consultancy activities': 'COMPUTER_CONSULTANCY_ACTIVITIES',
  'Data processing, hosting and related activities':
    'DATA_PROCESSING_HOSTING_AND_RELATED_ACTIVITIES',
  'Web portals': 'WEB_PORTALS',
  'Online publishing and content platforms':
    'ONLINE_PUBLISHING_AND_CONTENT_PLATFORMS',
  'Other information technology and computer services':
    'OTHER_INFORMATION_TECHNOLOGY_AND_COMPUTER_SERVICES',
  'Residential building construction': 'RESIDENTIAL_BUILDING_CONSTRUCTION',
  'Non-residential building construction':
    'NON_RESIDENTIAL_BUILDING_CONSTRUCTION',
  'Civil engineering projects': 'CIVIL_ENGINEERING_PROJECTS',
  'Electrical, plumbing and other installation services':
    'ELECTRICAL_PLUMBING_AND_OTHER_INSTALLATION_SERVICES',
  'Building completion and finishing': 'BUILDING_COMPLETION_AND_FINISHING',
  'Demolition and site preparation': 'DEMOLITION_AND_SITE_PREPARATION',
  'Consumer electronics manufacturing': 'CONSUMER_ELECTRONICS_MANUFACTURING',
  'Wholesale of electronic and telecom equipment':
    'WHOLESALE_OF_ELECTRONIC_AND_TELECOM_EQUIPMENT',
  'Retail sale of audio and video equipment':
    'RETAIL_SALE_OF_AUDIO_AND_VIDEO_EQUIPMENT',
  'Repair of consumer electronics': 'REPAIR_OF_CONSUMER_ELECTRONICS',
  'Household goods manufacturing': 'HOUSEHOLD_GOODS_MANUFACTURING',
  'Wholesale of household goods': 'WHOLESALE_OF_HOUSEHOLD_GOODS',
  'Retail sale of household goods': 'RETAIL_SALE_OF_HOUSEHOLD_GOODS',
  'Personal care services': 'PERSONAL_CARE_SERVICES',
  'Travel agency and tour operator activities':
    'TRAVEL_AGENCY_AND_TOUR_OPERATOR_ACTIVITIES',
  'Other reservation services': 'OTHER_RESERVATION_SERVICES',
  'Funeral and related activities': 'FUNERAL_AND_RELATED_ACTIVITIES',
  'Dry-cleaning and laundry services': 'DRY_CLEANING_AND_LAUNDRY_SERVICES',
  'Manufacture of perfumes and toilet preparations':
    'MANUFACTURE_OF_PERFUMES_AND_TOILET_PREPARATIONS',
  'Wholesale of perfumery and cosmetics':
    'WHOLESALE_OF_PERFUMERY_AND_COSMETICS',
  'Retail sale of cosmetic and toilet articles':
    'RETAIL_SALE_OF_COSMETIC_AND_TOILET_ARTICLES',
  'Defence activities': 'DEFENCE_ACTIVITIES',
  'Manufacture of weapons and ammunition':
    'MANUFACTURE_OF_WEAPONS_AND_AMMUNITION',
  'Manufacture of aircraft and spacecraft':
    'MANUFACTURE_OF_AIRCRAFT_AND_SPACECRAFT',
  'Space technology and services': 'SPACE_TECHNOLOGY_AND_SERVICES',
  'Repair and maintenance of aircraft and defence equipment':
    'REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_DEFENCE_EQUIPMENT',
  'Specialised design activities': 'SPECIALISED_DESIGN_ACTIVITIES',
  'Architectural and engineering design':
    'ARCHITECTURAL_AND_ENGINEERING_DESIGN',
  'Advertising and creative consultancy':
    'ADVERTISING_AND_CREATIVE_CONSULTANCY',
  B2B: 'B2B',
  B2C: 'B2C',
  D2C: 'D2C',
  'C2C (marketplaces)': 'C2C_MARKETPLACES',
  'Educational support activities': 'EDUCATIONAL_SUPPORT_ACTIVITIES',
  'Education administration services': 'EDUCATION_ADMINISTRATION_SERVICES',
  'Online education platforms': 'ONLINE_EDUCATION_PLATFORMS',
  'Other education services': 'OTHER_EDUCATION_SERVICES',
  'Manufacture of electronic components':
    'MANUFACTURE_OF_ELECTRONIC_COMPONENTS',
  'Manufacture of electrical equipment': 'MANUFACTURE_OF_ELECTRICAL_EQUIPMENT',
  'Manufacture of instruments and measuring devices':
    'MANUFACTURE_OF_INSTRUMENTS_AND_MEASURING_DEVICES',
  'Manufacture of domestic appliances': 'MANUFACTURE_OF_DOMESTIC_APPLIANCES',
  'Performing arts': 'PERFORMING_ARTS',
  'Operation of arts facilities': 'OPERATION_OF_ARTS_FACILITIES',
  'Other amusement and recreation activities':
    'OTHER_AMUSEMENT_AND_RECREATION_ACTIVITIES',
  'Support activities to performing arts':
    'SUPPORT_ACTIVITIES_TO_PERFORMING_ARTS',
  'Collection of non-hazardous waste': 'COLLECTION_OF_NON_HAZARDOUS_WASTE',
  'Treatment and disposal of waste': 'TREATMENT_AND_DISPOSAL_OF_WASTE',
  'Materials recovery': 'MATERIALS_RECOVERY',
  'Remediation and other waste management services':
    'REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICES',
  'Environmental consulting services': 'ENVIRONMENTAL_CONSULTING_SERVICES',
  'Convention and trade show organizers':
    'CONVENTION_AND_TRADE_SHOW_ORGANIZERS',
  'Event management services': 'EVENT_MANAGEMENT_SERVICES',
  'Catering services': 'CATERING_SERVICES',
  'Corporate headquarters': 'CORPORATE_HEADQUARTERS',
  'General public administration activities':
    'GENERAL_PUBLIC_ADMINISTRATION_ACTIVITIES',
  'Management of companies and enterprises':
    'MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES',
  'Combined facilities support services':
    'COMBINED_FACILITIES_SUPPORT_SERVICES',
  'Cleaning services': 'CLEANING_SERVICES',
  'Landscape care and maintenance': 'LANDSCAPE_CARE_AND_MAINTENANCE',
  'Security systems services': 'SECURITY_SYSTEMS_SERVICES',
  'Growing of non-perennial crops': 'GROWING_OF_NON_PERENNIAL_CROPS',
  'Growing of perennial crops': 'GROWING_OF_PERENNIAL_CROPS',
  'Animal production': 'ANIMAL_PRODUCTION',
  'Mixed farming': 'MIXED_FARMING',
  'Support activities to agriculture': 'SUPPORT_ACTIVITIES_TO_AGRICULTURE',
  'Other financial service activities': 'OTHER_FINANCIAL_SERVICE_ACTIVITIES',
  'Financial leasing': 'FINANCIAL_LEASING',
  'Fund management activities': 'FUND_MANAGEMENT_ACTIVITIES',
  'Payment processing services': 'PAYMENT_PROCESSING_SERVICES',
  'Consumer lending': 'CONSUMER_LENDING',
  'Business lending': 'BUSINESS_LENDING',
  'Consumer & commercial banking': 'CONSUMER_AND_COMMERCIAL_BANKING',
  'Consumer payments': 'CONSUMER_PAYMENTS',
  'Crowdfunding': 'CROWDFUNDING',
  'Crypto': 'CRYPTO',
  'International money transfer': 'INTERNATIONAL_MONEY_TRANSFER',
  'Personal finance': 'PERSONAL_FINANCE',
  'Kids finance': 'KIDS_FINANCE',
  'SMBs': 'SMBS',
  'Point of Sales': 'POINT_OF_SALES',
  'Creative, arts and entertainment activities':
    'CREATIVE_ARTS_AND_ENTERTAINMENT_ACTIVITIES',
  'Museums and galleries': 'MUSEUMS_AND_GALLERIES',
  'Retail sale of art works and antiques':
    'RETAIL_SALE_OF_ART_WORKS_AND_ANTIQUES',
  'Fishing': 'FISHING',
  'Aquaculture': 'AQUACULTURE',
  'Processing and preserving of fish and seafood':
    'PROCESSING_AND_PRESERVING_OF_FISH_AND_SEAFOOD',
  'Event catering and other food service activities':
    'EVENT_CATERING_AND_OTHER_FOOD_SERVICE_ACTIVITIES',
  'Verticalised digital supermarkets': 'VERTICALISED_DIGITAL_SUPERMARKETS',
  'Tech-enabled & Alternative offline models':
    'TECH_ENABLED_AND_ALTERNATIVE_OFFLINE_MODELS',
  'Supermarkets': 'SUPERMARKETS',
  'Restaurant': 'RESTAURANT',
  'Product discovery & Curation': 'PRODUCT_DISCOVERY_AND_CURATION',
  'Pet food': 'PET_FOOD',
  'Personal shoppers': 'PERSONAL_SHOPPERS',
  'Online enablers': 'ONLINE_ENABLERS',
  'Niche or local offering': 'NICHE_OR_LOCAL_OFFERING',
  'Mealkits & Prepared meals': 'MEALKITS_AND_PREPARED_MEALS',
  'Integrated digital supermarkets': 'INTEGRATED_DIGITAL_SUPERMARKETS',
  'Food & Grocery rescue': 'FOOD_AND_GROCERY_RESCUE',
  'Food & Grocery delivery': 'FOOD_AND_GROCERY_DELIVERY',
  'Distributors marketplace': 'DISTRIBUTORS_MARKETPLACE',
  'Delivery specialists': 'DELIVERY_SPECIALISTS',
  'Brokers': 'BROKERS',
  'Beverages': 'BEVERAGES',
  'Charitable fund-raising activities': 'CHARITABLE_FUND_RAISING_ACTIVITIES',
  'Public relations and communication services':
    'PUBLIC_RELATIONS_AND_COMMUNICATION_SERVICES',
  'Manufacture of furniture': 'MANUFACTURE_OF_FURNITURE',
  'Wholesale of furniture and lighting equipment':
    'WHOLESALE_OF_FURNITURE_AND_LIGHTING_EQUIPMENT',
  'Retail sale of furniture': 'RETAIL_SALE_OF_FURNITURE',
  'Gambling and betting activities': 'GAMBLING_AND_BETTING_ACTIVITIES',
  'Operation of sports facilities': 'OPERATION_OF_SPORTS_FACILITIES',
  'Manufacture of ceramic products': 'MANUFACTURE_OF_CERAMIC_PRODUCTS',
  'Manufacture of articles of concrete, cement and plaster':
    'MANUFACTURE_OF_ARTICLES_OF_CONCRETE_CEMENT_AND_PLASTER',
  'Regulation of health, education and cultural services':
    'REGULATION_OF_HEALTH_EDUCATION_AND_CULTURAL_SERVICES',
  'Public order and safety activities': 'PUBLIC_ORDER_AND_SAFETY_ACTIVITIES',
  'Public relations and communication activities':
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
  'Lobbying and public affairs services':
    'LOBBYING_AND_PUBLIC_AFFAIRS_SERVICES',
  'Business and employers membership organizations':
    'BUSINESS_AND_EMPLOYERS_MEMBERSHIP_ORGANIZATIONS',
  'Graphic design services': 'GRAPHIC_DESIGN_SERVICES',
  'Advertising services': 'ADVERTISING_SERVICES',
  'Other professional design services': 'OTHER_PROFESSIONAL_DESIGN_SERVICES',
  'Fitness centres': 'FITNESS_CENTRES',
  'Wellness services': 'WELLNESS_SERVICES',
  'Other human health services': 'OTHER_HUMAN_HEALTH_SERVICES',
  'Recreation and sports activities': 'RECREATION_AND_SPORTS_ACTIVITIES',
  'Tertiary education': 'TERTIARY_EDUCATION',
  'Research and experimental development (social sciences)':
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_SOCIAL_SCIENCES',
  'Hospital activities': 'HOSPITAL_ACTIVITIES',
  'Medical and dental practice activities':
    'MEDICAL_AND_DENTAL_PRACTICE_ACTIVITIES',
  'Other human health activities': 'OTHER_HUMAN_HEALTH_ACTIVITIES',
  'Residential nursing care activities': 'RESIDENTIAL_NURSING_CARE_ACTIVITIES',
  'Social work activities without accommodation':
    'SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION',
  'Hotels and similar accommodation': 'HOTELS_AND_SIMILAR_ACCOMMODATION',
  'Holiday and short-stay accommodation':
    'HOLIDAY_AND_SHORT_STAY_ACCOMMODATION',
  'Employment placement agencies': 'EMPLOYMENT_PLACEMENT_AGENCIES',
  'Temporary employment agency activities':
    'TEMPORARY_EMPLOYMENT_AGENCY_ACTIVITIES',
  'Human resources provision and management services':
    'HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_SERVICES',
  'Management consultancy activities': 'MANAGEMENT_CONSULTANCY_ACTIVITIES',
  'Wholesale on a fee or contract basis':
    'WHOLESALE_ON_A_FEE_OR_CONTRACT_BASIS',
  'Non-specialised wholesale trade': 'NON_SPECIALISED_WHOLESALE_TRADE',
  'Freight transport by road': 'FREIGHT_TRANSPORT_BY_ROAD',
  'Sea and coastal freight water transport':
    'SEA_AND_COASTAL_FREIGHT_WATER_TRANSPORT',
  'Air freight transport': 'AIR_FREIGHT_TRANSPORT',
  'Customs agency and freight forwarding services':
    'CUSTOMS_AGENCY_AND_FREIGHT_FORWARDING_SERVICES',
  'Child day-care activities': 'CHILD_DAY_CARE_ACTIVITIES',
  'Residential care activities': 'RESIDENTIAL_CARE_ACTIVITIES',
  'Counseling services': 'COUNSELING_SERVICES',
  'Manufacture of instruments and control systems':
    'MANUFACTURE_OF_INSTRUMENTS_AND_CONTROL_SYSTEMS',
  'Installation of industrial machinery and equipment':
    'INSTALLATION_OF_INDUSTRIAL_MACHINERY_AND_EQUIPMENT',
  'Engineering design and consulting services':
    'ENGINEERING_DESIGN_AND_CONSULTING_SERVICES',
  'Industrial process automation services':
    'INDUSTRIAL_PROCESS_AUTOMATION_SERVICES',
  'Other information service activities':
    'OTHER_INFORMATION_SERVICE_ACTIVITIES',
  'Computer programming, consultancy and related activities':
    'COMPUTER_PROGRAMMING_CONSULTANCY_AND_RELATED_ACTIVITIES',
  'IT support and managed services': 'IT_SUPPORT_AND_MANAGED_SERVICES',
  'Life insurance': 'LIFE_INSURANCE',
  'Non-life insurance': 'NON_LIFE_INSURANCE',
  'Reinsurance': 'REINSURANCE',
  'Activities auxiliary to insurance and pension funding':
    'ACTIVITIES_AUXILIARY_TO_INSURANCE_AND_PENSION_FUNDING',
  'Foreign affairs administration': 'FOREIGN_AFFAIRS_ADMINISTRATION',
  'Activities of international organizations':
    'ACTIVITIES_OF_INTERNATIONAL_ORGANIZATIONS',
  'International development activities':
    'INTERNATIONAL_DEVELOPMENT_ACTIVITIES',
  'International trade services': 'INTERNATIONAL_TRADE_SERVICES',
  'Development organizations': 'DEVELOPMENT_ORGANIZATIONS',
  'Investment banking': 'INVESTMENT_BANKING',
  'Securities trading': 'SECURITIES_TRADING',
  'Corporate finance advisory': 'CORPORATE_FINANCE_ADVISORY',
  'Asset management': 'ASSET_MANAGEMENT',
  'Portfolio management services': 'PORTFOLIO_MANAGEMENT_SERVICES',
  'Activities of trusts, funds and similar financial entities':
    'ACTIVITIES_OF_TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
  'Judicial courts': 'JUDICIAL_COURTS',
  'Justice administration services': 'JUSTICE_ADMINISTRATION_SERVICES',
  'Legal support services': 'LEGAL_SUPPORT_SERVICES',
  'Police services': 'POLICE_SERVICES',
  'Security services': 'SECURITY_SERVICES',
  'Legal practice': 'LEGAL_PRACTICE',
  'Notarial services': 'NOTARIAL_SERVICES',
  'Arbitration and mediation': 'ARBITRATION_AND_MEDIATION',
  'Intellectual property legal services':
    'INTELLECTUAL_PROPERTY_LEGAL_SERVICES',
  'Legal services': 'LEGAL_SERVICES',
  'Patent and copyright agency services':
    'PATENT_AND_COPYRIGHT_AGENCY_SERVICES',
  'Legislative activities': 'LEGISLATIVE_ACTIVITIES',
  'Government bodies': 'GOVERNMENT_BODIES',
  'Public administration and defence': 'PUBLIC_ADMINISTRATION_AND_DEFENCE',
  'Amusement and theme park activities': 'AMUSEMENT_AND_THEME_PARK_ACTIVITIES',
  'Library and archives activities': 'LIBRARY_AND_ARCHIVES_ACTIVITIES',
  'Cultural education services': 'CULTURAL_EDUCATION_SERVICES',
  'Museum activities and operation of historical sites':
    'MUSEUM_ACTIVITIES_AND_OPERATION_OF_HISTORICAL_SITES',
  'Freight rail transport': 'FREIGHT_RAIL_TRANSPORT',
  'Inland freight water transport': 'INLAND_FREIGHT_WATER_TRANSPORT',
  'Cargo handling': 'CARGO_HANDLING',
  'Warehousing and storage': 'WAREHOUSING_AND_STORAGE',
  'Other transportation support activities':
    'OTHER_TRANSPORTATION_SUPPORT_ACTIVITIES',
  'Wholesale of jewellery and luxury goods':
    'WHOLESALE_OF_JEWELLERY_AND_LUXURY_GOODS',
  'Retail sale of watches and jewellery':
    'RETAIL_SALE_OF_WATCHES_AND_JEWELLERY',
  'Manufacture of general-purpose machinery':
    'MANUFACTURE_OF_GENERAL_PURPOSE_MACHINERY',
  'Manufacture of special-purpose machinery':
    'MANUFACTURE_OF_SPECIAL_PURPOSE_MACHINERY',
  'Repair of machinery and equipment': 'REPAIR_OF_MACHINERY_AND_EQUIPMENT',
  'Wholesale of machinery, equipment and supplies':
    'WHOLESALE_OF_MACHINERY_EQUIPMENT_AND_SUPPLIES',
  'Business and management consultancy': 'BUSINESS_AND_MANAGEMENT_CONSULTANCY',
  'Strategy consulting': 'STRATEGY_CONSULTING',
  'Operations and process improvement consulting':
    'OPERATIONS_AND_PROCESS_IMPROVEMENT_CONSULTING',
  'Sea and coastal passenger water transport':
    'SEA_AND_COASTAL_PASSENGER_WATER_TRANSPORT',
  'Service activities incidental to water transportation':
    'SERVICE_ACTIVITIES_INCIDENTAL_TO_WATER_TRANSPORTATION',
  'Port and harbour operations': 'PORT_AND_HARBOUR_OPERATIONS',
  'Shipbuilding and repair': 'SHIPBUILDING_AND_REPAIR',
  'Market research and public opinion polling':
    'MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING',
  'Data analytics and consumer insights services':
    'DATA_ANALYTICS_AND_CONSUMER_INSIGHTS_SERVICES',
  'Advertising agencies': 'ADVERTISING_AGENCIES',
  'Media representation': 'MEDIA_REPRESENTATION',
  'Digital marketing services': 'DIGITAL_MARKETING_SERVICES',
  'Engineering activities and related technical consultancy':
    'ENGINEERING_ACTIVITIES_AND_RELATED_TECHNICAL_CONSULTANCY',
  'Motion picture, video and television programme production':
    'MOTION_PICTURE_VIDEO_AND_TELEVISION_PROGRAMME_PRODUCTION',
  'Sound recording and music publishing':
    'SOUND_RECORDING_AND_MUSIC_PUBLISHING',
  'Manufacture of medical and dental instruments and supplies':
    'MANUFACTURE_OF_MEDICAL_AND_DENTAL_INSTRUMENTS_AND_SUPPLIES',
  'Wholesale of pharmaceutical and medical goods':
    'WHOLESALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS',
  'Retail sale of medical and orthopaedic goods':
    'RETAIL_SALE_OF_MEDICAL_AND_ORTHOPAEDIC_GOODS',
  'Repair of medical equipment': 'REPAIR_OF_MEDICAL_EQUIPMENT',
  'General medical practice activities': 'GENERAL_MEDICAL_PRACTICE_ACTIVITIES',
  'Specialist medical practice activities':
    'SPECIALIST_MEDICAL_PRACTICE_ACTIVITIES',
  'Diagnostic imaging services': 'DIAGNOSTIC_IMAGING_SERVICES',
  'Residential care for mental health and substance abuse':
    'RESIDENTIAL_CARE_FOR_MENTAL_HEALTH_AND_SUBSTANCE_ABUSE',
  'Counseling and psychotherapy services':
    'COUNSELING_AND_PSYCHOTHERAPY_SERVICES',
  'Support activities for defence operations':
    'SUPPORT_ACTIVITIES_FOR_DEFENCE_OPERATIONS',
  'Mining of coal and lignite': 'MINING_OF_COAL_AND_LIGNITE',
  'Extraction of crude petroleum and natural gas':
    'EXTRACTION_OF_CRUDE_PETROLEUM_AND_NATURAL_GAS',
  'Mining of metal ores': 'MINING_OF_METAL_ORES',
  'Other mining and quarrying': 'OTHER_MINING_AND_QUARRYING',
  'Support activities for mining': 'SUPPORT_ACTIVITIES_FOR_MINING',
  'Casting of metals': 'CASTING_OF_METALS',
  'Finance & Insurance': 'FINANCE_AND_INSURANCE',
  'Mapping & Navigation': 'MAPPING_AND_NAVIGATION',
  'Micro mobility': 'MICRO_MOBILITY',
  'Mobility services': 'MOBILITY_SERVICES',
  'Parking & Smart city': 'PARKING_AND_SMART_CITY',
  'Ride sharing': 'RIDE_SHARING',
  'Vehicle markeplace & Aftermarket': 'VEHICLE_MARKEPLACE_AND_AFTERMARKET',
  'Motion picture production': 'MOTION_PICTURE_PRODUCTION',
  'Motion picture distribution': 'MOTION_PICTURE_DISTRIBUTION',
  'Motion picture projection': 'MOTION_PICTURE_PROJECTION',
  'Botanical and zoological gardens and nature reserves':
    'BOTANICAL_AND_ZOOLOGICAL_GARDENS_AND_NATURE_RESERVES',
  'Music performance activities': 'MUSIC_PERFORMANCE_ACTIVITIES',
  'Research and experimental development on natural sciences and engineering':
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_NATURAL_SCIENCES_AND_ENGINEERING',
  'Advanced materials manufacturing': 'ADVANCED_MATERIALS_MANUFACTURING',
  'Publishing of newspapers, journals and periodicals':
    'PUBLISHING_OF_NEWSPAPERS_JOURNALS_AND_PERIODICALS',
  'Printing activities': 'PRINTING_ACTIVITIES',
  'Retail sale of newspapers and stationery':
    'RETAIL_SALE_OF_NEWSPAPERS_AND_STATIONERY',
  'Activities of other membership organizations':
    'ACTIVITIES_OF_OTHER_MEMBERSHIP_ORGANIZATIONS',
  'Extraction of crude petroleum': 'EXTRACTION_OF_CRUDE_PETROLEUM',
  'Extraction of natural gas': 'EXTRACTION_OF_NATURAL_GAS',
  'Support activities for petroleum and natural gas extraction':
    'SUPPORT_ACTIVITIES_FOR_PETROLEUM_AND_NATURAL_GAS_EXTRACTION',
  'Manufacture of refined petroleum products':
    'MANUFACTURE_OF_REFINED_PETROLEUM_PRODUCTS',
  'Electric power generation, transmission and distribution':
    'ELECTRIC_POWER_GENERATION_TRANSMISSION_AND_DISTRIBUTION',
  'Trade of gas through mains': 'TRADE_OF_GAS_THROUGH_MAINS',
  'Other information services': 'OTHER_INFORMATION_SERVICES',
  'Online publishing of journals and periodicals':
    'ONLINE_PUBLISHING_OF_JOURNALS_AND_PERIODICALS',
  'Digital news and media aggregation': 'DIGITAL_NEWS_AND_MEDIA_AGGREGATION',
  'Business process outsourcing services':
    'BUSINESS_PROCESS_OUTSOURCING_SERVICES',
  'Call centres and telephone-based support services':
    'CALL_CENTRES_AND_TELEPHONE_BASED_SUPPORT_SERVICES',
  'Back-office support and data processing':
    'BACK_OFFICE_SUPPORT_AND_DATA_PROCESSING',
  'Postal activities': 'POSTAL_ACTIVITIES',
  'Courier activities': 'COURIER_ACTIVITIES',
  'Manufacture of paper and paperboard containers':
    'MANUFACTURE_OF_PAPER_AND_PAPERBOARD_CONTAINERS',
  'Manufacture of plastic packing goods':
    'MANUFACTURE_OF_PLASTIC_PACKING_GOODS',
  'Manufacture of glass containers': 'MANUFACTURE_OF_GLASS_CONTAINERS',
  'Wholesale of packaging materials': 'WHOLESALE_OF_PACKAGING_MATERIALS',
  'Manufacture of pulp, paper and paperboard':
    'MANUFACTURE_OF_PULP_PAPER_AND_PAPERBOARD',
  'Manufacture of corrugated paper and containers':
    'MANUFACTURE_OF_CORRUGATED_PAPER_AND_CONTAINERS',
  'Logging': 'LOGGING',
  'Sawmilling and planing of wood': 'SAWMILLING_AND_PLANING_OF_WOOD',
  'Wholesale of wood and construction materials':
    'WHOLESALE_OF_WOOD_AND_CONSTRUCTION_MATERIALS',
  'Manufacture of pharmaceuticals, medicinal chemical and botanical products':
    'MANUFACTURE_OF_PHARMACEUTICALS_MEDICINAL_CHEMICAL_AND_BOTANICAL_PRODUCTS',
  'Wholesale of pharmaceutical goods': 'WHOLESALE_OF_PHARMACEUTICAL_GOODS',
  'Retail sale of pharmaceutical and medical goods':
    'RETAIL_SALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS',
  'Biopharmaceutical research and development':
    'BIOPHARMACEUTICAL_RESEARCH_AND_DEVELOPMENT',
  'Grant-making activities': 'GRANT_MAKING_ACTIVITIES',
  'Photographic activities': 'PHOTOGRAPHIC_ACTIVITIES',
  'Retail sale of photographic equipment':
    'RETAIL_SALE_OF_PHOTOGRAPHIC_EQUIPMENT',
  'Imaging and photo processing services':
    'IMAGING_AND_PHOTO_PROCESSING_SERVICES',
  'Manufacture of plastics in primary forms':
    'MANUFACTURE_OF_PLASTICS_IN_PRIMARY_FORMS',
  'Manufacture of plastic products': 'MANUFACTURE_OF_PLASTIC_PRODUCTS',
  'Wholesale of chemical products': 'WHOLESALE_OF_CHEMICAL_PRODUCTS',
  'Recycling of plastic materials': 'RECYCLING_OF_PLASTIC_MATERIALS',
  'Activities of political organizations':
    'ACTIVITIES_OF_POLITICAL_ORGANIZATIONS',
  'Civic and social organizations': 'CIVIC_AND_SOCIAL_ORGANIZATIONS',
  'Primary education': 'PRIMARY_EDUCATION',
  'Secondary education': 'SECONDARY_EDUCATION',
  'Printing': 'PRINTING',
  'Service activities related to printing':
    'SERVICE_ACTIVITIES_RELATED_TO_PRINTING',
  'Manufacture of printing ink': 'MANUFACTURE_OF_PRINTING_INK',
  'Other education n.e.c.': 'OTHER_EDUCATION_N_E_C',
  'Business and management training': 'BUSINESS_AND_MANAGEMENT_TRAINING',
  'Coaching services': 'COACHING_SERVICES',
  'Public administration and defence policy planning':
    'PUBLIC_ADMINISTRATION_AND_DEFENCE_POLICY_PLANNING',
  'Policy research services': 'POLICY_RESEARCH_SERVICES',
  'Corporate communications services': 'CORPORATE_COMMUNICATIONS_SERVICES',
  'Fire service activities': 'FIRE_SERVICE_ACTIVITIES',
  'Disaster and emergency response activities':
    'DISASTER_AND_EMERGENCY_RESPONSE_ACTIVITIES',
  'Book publishing': 'BOOK_PUBLISHING',
  'Other publishing activities': 'OTHER_PUBLISHING_ACTIVITIES',
  'Manufacture of railway locomotives and rolling stock':
    'MANUFACTURE_OF_RAILWAY_LOCOMOTIVES_AND_ROLLING_STOCK',
  'Repair of transport equipment': 'REPAIR_OF_TRANSPORT_EQUIPMENT',
  'Wholesale of machinery and equipment':
    'WHOLESALE_OF_MACHINERY_AND_EQUIPMENT',
  'Support activities for animal production':
    'SUPPORT_ACTIVITIES_FOR_ANIMAL_PRODUCTION',
  'Processing of meat and meat products':
    'PROCESSING_OF_MEAT_AND_MEAT_PRODUCTS',
  'Aggregators': 'AGGREGATORS',
  'Marketplaces': 'MARKETPLACES',
  'New way of living': 'NEW_WAY_OF_LIVING',
  'No agent needed': 'NO_AGENT_NEEDED',
  'Property agent & Agent matching': 'PROPERTY_AGENT_AND_AGENT_MATCHING',
  'Property management': 'PROPERTY_MANAGEMENT',
  'Property Search': 'PROPERTY_SEARCH',
  'Short term rentals': 'SHORT_TERM_RENTALS',
  'Traditional RE agencies': 'TRADITIONAL_RE_AGENCIES',
  'Parks and recreational activities': 'PARKS_AND_RECREATIONAL_ACTIVITIES',
  'Activities of religious organizations':
    'ACTIVITIES_OF_RELIGIOUS_ORGANIZATIONS',
  'Religious education': 'RELIGIOUS_EDUCATION',
  'Charitable activities by religious organizations':
    'CHARITABLE_ACTIVITIES_BY_RELIGIOUS_ORGANIZATIONS',
  'Electric power generation from renewable sources':
    'ELECTRIC_POWER_GENERATION_FROM_RENEWABLE_SOURCES',
  'Manufacture of renewable energy equipment':
    'MANUFACTURE_OF_RENEWABLE_ENERGY_EQUIPMENT',
  'Environmental consulting activities': 'ENVIRONMENTAL_CONSULTING_ACTIVITIES',
  'Waste collection and materials recovery':
    'WASTE_COLLECTION_AND_MATERIALS_RECOVERY',
  'Research and experimental development on social sciences and humanities':
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_SOCIAL_SCIENCES_AND_HUMANITIES',
  'Retail sale in non-specialised stores':
    'RETAIL_SALE_IN_NON_SPECIALISED_STORES',
  'Retail sale of food, beverages and tobacco':
    'RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO',
  'Retail sale of other goods in specialised stores':
    'RETAIL_SALE_OF_OTHER_GOODS_IN_SPECIALISED_STORES',
  'Retail sale via stalls and markets': 'RETAIL_SALE_VIA_STALLS_AND_MARKETS',
  'Retail sale via mail order or Internet':
    'RETAIL_SALE_VIA_MAIL_ORDER_OR_INTERNET',
  'Private security activities': 'PRIVATE_SECURITY_ACTIVITIES',
  'Security systems service activities': 'SECURITY_SYSTEMS_SERVICE_ACTIVITIES',
  'Investigation activities': 'INVESTIGATION_ACTIVITIES',
  'Manufacture of loaded electronic boards':
    'MANUFACTURE_OF_LOADED_ELECTRONIC_BOARDS',
  'Wholesale of electronic components': 'WHOLESALE_OF_ELECTRONIC_COMPONENTS',
  'R&D in microelectronics': 'RANDD_IN_MICROELECTRONICS',
  'Building of ships and floating structures':
    'BUILDING_OF_SHIPS_AND_FLOATING_STRUCTURES',
  'Building of pleasure and sporting boats':
    'BUILDING_OF_PLEASURE_AND_SPORTING_BOATS',
  'Repair and maintenance of ships and boats':
    'REPAIR_AND_MAINTENANCE_OF_SHIPS_AND_BOATS',
  'Manufacture of sports goods': 'MANUFACTURE_OF_SPORTS_GOODS',
  'Wholesale of sporting goods': 'WHOLESALE_OF_SPORTING_GOODS',
  'Retail sale of sporting equipment': 'RETAIL_SALE_OF_SPORTING_EQUIPMENT',
  'Sports club activities': 'SPORTS_CLUB_ACTIVITIES',
  'Sports and recreation instruction': 'SPORTS_AND_RECREATION_INSTRUCTION',
  'Other sports activities': 'OTHER_SPORTS_ACTIVITIES',
  'Human resources provision and management of human resources functions':
    'HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_OF_HUMAN_RESOURCES_FUNCTIONS',
  'Retail sale in non-specialised stores with food, beverages or tobacco predominating':
    'RETAIL_SALE_IN_NON_SPECIALISED_STORES_WITH_FOOD_BEVERAGES_OR_TOBACCO_PREDOMINATING',
  'Retail sale of food, beverages and tobacco in specialised stores':
    'RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO_IN_SPECIALISED_STORES',
  'Wholesale of food, beverages and tobacco':
    'WHOLESALE_OF_FOOD_BEVERAGES_AND_TOBACCO',
  'E-commerce of groceries': 'E_COMMERCE_OF_GROCERIES',
  'Satellite telecommunications activities':
    'SATELLITE_TELECOMMUNICATIONS_ACTIVITIES',
  'Other telecommunications activities': 'OTHER_TELECOMMUNICATIONS_ACTIVITIES',
  'Data processing and hosting services':
    'DATA_PROCESSING_AND_HOSTING_SERVICES',
  'Preparation and spinning of textile fibres':
    'PREPARATION_AND_SPINNING_OF_TEXTILE_FIBRES',
  'Weaving of textiles': 'WEAVING_OF_TEXTILES',
  'Finishing of textiles': 'FINISHING_OF_TEXTILES',
  'Manufacture of other textiles': 'MANUFACTURE_OF_OTHER_TEXTILES',
  'Manufacture of carpets and rugs': 'MANUFACTURE_OF_CARPETS_AND_RUGS',
  'Policy research institutes': 'POLICY_RESEARCH_INSTITUTES',
  'Public policy advisory services': 'PUBLIC_POLICY_ADVISORY_SERVICES',
  'Manufacture of tobacco products': 'MANUFACTURE_OF_TOBACCO_PRODUCTS',
  'Wholesale of tobacco products': 'WHOLESALE_OF_TOBACCO_PRODUCTS',
  'Retail sale of tobacco products': 'RETAIL_SALE_OF_TOBACCO_PRODUCTS',
  'Translation and interpretation activities':
    'TRANSLATION_AND_INTERPRETATION_ACTIVITIES',
  'Localization services': 'LOCALIZATION_SERVICES',
  'Publishing support services': 'PUBLISHING_SUPPORT_SERVICES',
  'Passenger rail transport': 'PASSENGER_RAIL_TRANSPORT',
  'Urban and suburban passenger land transport':
    'URBAN_AND_SUBURBAN_PASSENGER_LAND_TRANSPORT',
  'Manufacture of gas; distribution of gaseous fuels through mains':
    'MANUFACTURE_OF_GAS_DISTRIBUTION_OF_GASEOUS_FUELS_THROUGH_MAINS',
  'Steam and air conditioning supply': 'STEAM_AND_AIR_CONDITIONING_SUPPLY',
  'Water collection, treatment and supply':
    'WATER_COLLECTION_TREATMENT_AND_SUPPLY',
  'Sewerage': 'SEWERAGE',
  'Waste management and materials recovery':
    'WASTE_MANAGEMENT_AND_MATERIALS_RECOVERY',
  'Venture capital activities': 'VENTURE_CAPITAL_ACTIVITIES',
  'Private equity activities': 'PRIVATE_EQUITY_ACTIVITIES',
  'Veterinary activities': 'VETERINARY_ACTIVITIES',
  'Manufacture of veterinary pharmaceutical products':
    'MANUFACTURE_OF_VETERINARY_PHARMACEUTICAL_PRODUCTS',
  'Retail sale of pet food and pet supplies':
    'RETAIL_SALE_OF_PET_FOOD_AND_PET_SUPPLIES',
  'Fulfilment and distribution services':
    'FULFILMENT_AND_DISTRIBUTION_SERVICES',
  'Wholesale of information and communications equipment':
    'WHOLESALE_OF_INFORMATION_AND_COMMUNICATIONS_EQUIPMENT',
  'Manufacture of wines': 'MANUFACTURE_OF_WINES',
  'Manufacture of spirits': 'MANUFACTURE_OF_SPIRITS',
  'Wholesale of beverages': 'WHOLESALE_OF_BEVERAGES',
  'Retail sale of beverages in specialised stores':
    'RETAIL_SALE_OF_BEVERAGES_IN_SPECIALISED_STORES',
  'Telecommunications infrastructure operation':
    'TELECOMMUNICATIONS_INFRASTRUCTURE_OPERATION',
  'Editorial services': 'EDITORIAL_SERVICES',
  'Content writing': 'CONTENT_WRITING',
  'Publishing services': 'PUBLISHING_SERVICES',
}

export const INDUSTRY_GROUPS_V2 = {
  ACCOUNTING: [
    'ACCOUNTING_AND_AUDITING_ACTIVITIES',
    'TAX_CONSULTANCY',
    'BOOKKEEPING_SERVICES',
    'PAYROLL_PROCESSING_SERVICES',
  ],
  AIRLINES_AVIATION: [
    'PASSENGER_AIR_TRANSPORT',
    'FREIGHT_AIR_TRANSPORT',
    'AIR_TRANSPORT_SUPPORT_SERVICES',
    'AIRPORT_OPERATIONS',
  ],
  ALTERNATIVE_DISPUTE_RESOLUTION: [
    'LEGAL_AND_ARBITRATION_SERVICES',
    'MEDIATION_SERVICES',
  ],
  ALTERNATIVE_MEDICINE: [
    'OTHER_HEALTH_SERVICES',
    'WELLNESS_AND_PHYSICAL_THERAPY_SERVICES',
    'TRADITIONAL_AND_ALTERNATIVE_MEDICINE_SERVICES',
  ],
  ANIMATION: [
    'MOTION_PICTURE_AND_VIDEO_PRODUCTION',
    'POST_PRODUCTION_SERVICES',
    'ANIMATION_AND_VISUAL_EFFECTS_SERVICES',
    'TELEVISION_PROGRAMME_PRODUCTION',
  ],
  APPAREL_AND_FASHION: [
    'MANUFACTURE_OF_TEXTILES',
    'MANUFACTURE_OF_WEARING_APPAREL',
    'MANUFACTURE_OF_LEATHER_AND_RELATED_PRODUCTS',
    'MANUFACTURE_OF_FOOTWEAR',
    'WHOLESALE_OF_HOUSEHOLD_GOODS_INCL_TEXTILES_CLOTHING_FOOTWEAR',
    'RETAIL_SALE_OF_CLOTHING_FOOTWEAR_AND_LEATHER_GOODS',
  ],
  ARCHITECTURE_AND_PLANNING: [
    'ARCHITECTURAL_SERVICES',
    'URBAN_AND_LANDSCAPE_PLANNING',
    'ENGINEERING_DESIGN_SERVICES',
    'TECHNICAL_CONSULTANCY_SERVICES',
  ],
  ARTS_AND_CRAFTS: [
    'CREATIVE_ARTS_ACTIVITIES',
    'HANDICRAFT_AND_ARTISAN_PRODUCTS',
    'MANUFACTURE_OF_JEWELLERY_AND_RELATED_ARTICLES',
    'MANUFACTURE_OF_CERAMIC_HOUSEHOLD_AND_ORNAMENTAL_ARTICLES',
    'RETAIL_SALE_OF_ART_AND_CRAFT_GOODS',
  ],
  AUTOMOTIVE: [
    'MANUFACTURE_OF_MOTOR_VEHICLES',
    'MANUFACTURE_OF_PARTS_AND_ACCESSORIES_FOR_MOTOR_VEHICLES',
    'SALE_OF_MOTOR_VEHICLES',
    'MAINTENANCE_AND_REPAIR_OF_MOTOR_VEHICLES',
    'RETAIL_SALE_OF_AUTOMOTIVE_FUEL',
    'RENTING_AND_LEASING_OF_MOTOR_VEHICLES',
  ],
  AVIATION_AND_AEROSPACE: [
    'MANUFACTURE_OF_AIR_AND_SPACECRAFT_AND_RELATED_MACHINERY',
    'REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_SPACECRAFT',
    'SERVICE_ACTIVITIES_INCIDENTAL_TO_AIR_TRANSPORTATION',
    'SPACE_RESEARCH_AND_TECHNOLOGY',
  ],
  BANKING: [
    'CENTRAL_BANKING',
    'OTHER_MONETARY_INTERMEDIATION',
    'TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
    'ACTIVITIES_OF_HOLDING_COMPANIES',
    'PAYMENT_SERVICES_AND_CREDIT_CARD_ISSUING',
  ],
  BIOTECHNOLOGY: [
    'BIOTECHNOLOGY_RESEARCH_AND_DEVELOPMENT',
    'PHARMACEUTICAL_MANUFACTURING',
    'CLINICAL_RESEARCH_SERVICES',
  ],
  BROADCAST_MEDIA: [
    'RADIO_BROADCASTING',
    'TELEVISION_PROGRAMMING_AND_BROADCASTING',
    'PROGRAMME_DISTRIBUTION_SERVICES',
    'NEWS_AGENCY_ACTIVITIES',
  ],
  BUILDING_MATERIALS: [
    'MANUFACTURE_OF_CEMENT_LIME_AND_PLASTER',
    'MANUFACTURE_OF_GLASS_AND_GLASS_PRODUCTS',
    'MANUFACTURE_OF_CLAY_AND_CONCRETE_BUILDING_MATERIALS',
    'WHOLESALE_OF_CONSTRUCTION_MATERIALS',
  ],
  BUSINESS_SUPPLIES_AND_EQUIPMENT: [
    'WHOLESALE_OF_OFFICE_EQUIPMENT',
    'MANUFACTURE_OF_OFFICE_EQUIPMENT_NON_COMPUTER',
    'RETAIL_SALE_OF_STATIONERY_AND_OFFICE_SUPPLIES',
  ],
  CAPITAL_MARKETS: [
    'SECURITIES_AND_COMMODITIES_BROKERAGE',
    'ADMINISTRATION_OF_FINANCIAL_MARKETS',
    'ACTIVITIES_AUXILIARY_TO_FINANCIAL_SERVICES',
    'ASSET_AND_FUND_MANAGEMENT',
  ],
  CHEMICALS: [
    'MANUFACTURE_OF_BASIC_CHEMICALS',
    'MANUFACTURE_OF_FERTILIZERS_AND_AGROCHEMICALS',
    'MANUFACTURE_OF_PLASTICS_AND_SYNTHETIC_RUBBER_IN_PRIMARY_FORMS',
    'MANUFACTURE_OF_PAINTS_VARNISHES_AND_PRINTING_INK',
    'MANUFACTURE_OF_SOAP_DETERGENTS_AND_PERSONAL_CARE_PRODUCTS',
    'MANUFACTURE_OF_OTHER_CHEMICAL_PRODUCTS',
  ],
  CIVIC_AND_SOCIAL_ORGANIZATION: [
    'MEMBERSHIP_ORGANIZATIONS',
    'SOCIAL_ADVOCACY_SERVICES',
    'COMMUNITY_AND_NEIGHBORHOOD_ORGANIZATIONS',
  ],
  CIVIL_ENGINEERING: [
    'ROAD_AND_RAILWAY_CONSTRUCTION',
    'UTILITY_PROJECTS_CONSTRUCTION',
    'OTHER_CIVIL_ENGINEERING_PROJECTS',
  ],
  COMMERCIAL_REAL_ESTATE: [
    'REAL_ESTATE_ACTIVITIES_WITH_OWN_OR_LEASED_PROPERTY',
    'REAL_ESTATE_ACTIVITIES_ON_A_FEE_OR_CONTRACT_BASIS',
    'DEVELOPMENT_OF_BUILDING_PROJECTS',
    'COMMERCIAL_PROPERTY_MANAGEMENT',
  ],
  COMPUTER_AND_NETWORK_SECURITY: [
    'CYBERSECURITY_SERVICES',
    'COMPUTER_PROGRAMMING_AND_CONSULTANCY',
    'DATA_PROCESSING_AND_HOSTING',
    'IT_INFRASTRUCTURE_MANAGEMENT',
  ],
  COMPUTER_GAMES: [
    'GAME_PUBLISHING',
    'GAME_DEVELOPMENT',
    'DIGITAL_DISTRIBUTION_PLATFORMS',
  ],
  COMPUTER_HARDWARE: [
    'COMPUTER_AND_PERIPHERALS_MANUFACTURING',
    'WHOLESALE_OF_COMPUTERS_PERIPHERALS_AND_SOFTWARE',
    'RETAIL_SALE_OF_COMPUTERS_AND_SOFTWARE',
    'REPAIR_OF_COMPUTERS_AND_PERIPHERAL_EQUIPMENT',
  ],
  COMPUTER_NETWORKING: [
    'MANUFACTURE_OF_COMMUNICATION_EQUIPMENT',
    'WIRED_TELECOMMUNICATIONS_ACTIVITIES',
    'WIRELESS_TELECOMMUNICATIONS_ACTIVITIES',
    'COMPUTER_FACILITIES_MANAGEMENT_ACTIVITIES',
    'DATA_PROCESSING_AND_HOSTING',
  ],
  COMPUTER_SOFTWARE: [
    'SOFTWARE_PUBLISHING',
    'COMPUTER_PROGRAMMING_ACTIVITIES',
    'COMPUTER_CONSULTANCY_ACTIVITIES',
    'DATA_PROCESSING_AND_HOSTING',
  ],
  INTERNET: [
    'DATA_PROCESSING_HOSTING_AND_RELATED_ACTIVITIES',
    'WEB_PORTALS',
    'ONLINE_PUBLISHING_AND_CONTENT_PLATFORMS',
    'OTHER_INFORMATION_TECHNOLOGY_AND_COMPUTER_SERVICES',
  ],
  CONSTRUCTION: [
    'RESIDENTIAL_BUILDING_CONSTRUCTION',
    'NON_RESIDENTIAL_BUILDING_CONSTRUCTION',
    'CIVIL_ENGINEERING_PROJECTS',
    'ELECTRICAL_PLUMBING_AND_OTHER_INSTALLATION_SERVICES',
    'BUILDING_COMPLETION_AND_FINISHING',
    'DEMOLITION_AND_SITE_PREPARATION',
  ],
  CONSUMER_ELECTRONICS: [
    'CONSUMER_ELECTRONICS_MANUFACTURING',
    'WHOLESALE_OF_ELECTRONIC_AND_TELECOM_EQUIPMENT',
    'RETAIL_SALE_OF_AUDIO_AND_VIDEO_EQUIPMENT',
    'REPAIR_OF_CONSUMER_ELECTRONICS',
  ],
  CONSUMER_GOODS: [
    'HOUSEHOLD_GOODS_MANUFACTURING',
    'WHOLESALE_OF_HOUSEHOLD_GOODS',
    'RETAIL_SALE_OF_HOUSEHOLD_GOODS',
  ],
  CONSUMER_SERVICES: [
    'PERSONAL_CARE_SERVICES',
    'TRAVEL_AGENCY_AND_TOUR_OPERATOR_ACTIVITIES',
    'OTHER_RESERVATION_SERVICES',
    'FUNERAL_AND_RELATED_ACTIVITIES',
    'DRY_CLEANING_AND_LAUNDRY_SERVICES',
  ],
  COSMETICS: [
    'MANUFACTURE_OF_PERFUMES_AND_TOILET_PREPARATIONS',
    'WHOLESALE_OF_PERFUMERY_AND_COSMETICS',
    'RETAIL_SALE_OF_COSMETIC_AND_TOILET_ARTICLES',
  ],
  DEFENSE_AND_SPACE: [
    'DEFENCE_ACTIVITIES',
    'MANUFACTURE_OF_WEAPONS_AND_AMMUNITION',
    'MANUFACTURE_OF_AIRCRAFT_AND_SPACECRAFT',
    'SPACE_TECHNOLOGY_AND_SERVICES',
    'REPAIR_AND_MAINTENANCE_OF_AIRCRAFT_AND_DEFENCE_EQUIPMENT',
  ],
  DESIGN: [
    'SPECIALISED_DESIGN_ACTIVITIES',
    'ARCHITECTURAL_AND_ENGINEERING_DESIGN',
    'ADVERTISING_AND_CREATIVE_CONSULTANCY',
  ],
  E_COMMERCE: ['B2B', 'B2C', 'D2C', 'C2C_MARKETPLACES'],
  EDUCATION_MANAGEMENT: [
    'EDUCATIONAL_SUPPORT_ACTIVITIES',
    'EDUCATION_ADMINISTRATION_SERVICES',
  ],
  E_LEARNING: [
    'ONLINE_EDUCATION_PLATFORMS',
    'EDUCATIONAL_SUPPORT_ACTIVITIES',
    'OTHER_EDUCATION_SERVICES',
  ],
  ELECTRICAL_ELECTRONIC_MANUFACTURING: [
    'MANUFACTURE_OF_ELECTRONIC_COMPONENTS',
    'MANUFACTURE_OF_ELECTRICAL_EQUIPMENT',
    'MANUFACTURE_OF_INSTRUMENTS_AND_MEASURING_DEVICES',
    'MANUFACTURE_OF_DOMESTIC_APPLIANCES',
  ],
  ENTERTAINMENT: [
    'PERFORMING_ARTS',
    'OPERATION_OF_ARTS_FACILITIES',
    'OTHER_AMUSEMENT_AND_RECREATION_ACTIVITIES',
    'SUPPORT_ACTIVITIES_TO_PERFORMING_ARTS',
  ],
  ENVIRONMENTAL_SERVICES: [
    'COLLECTION_OF_NON_HAZARDOUS_WASTE',
    'TREATMENT_AND_DISPOSAL_OF_WASTE',
    'MATERIALS_RECOVERY',
    'REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICES',
    'ENVIRONMENTAL_CONSULTING_SERVICES',
  ],
  EVENTS_SERVICES: [
    'CONVENTION_AND_TRADE_SHOW_ORGANIZERS',
    'EVENT_MANAGEMENT_SERVICES',
    'CATERING_SERVICES',
    'OTHER_RESERVATION_SERVICES',
  ],
  EXECUTIVE_OFFICE: [
    'CORPORATE_HEADQUARTERS',
    'GENERAL_PUBLIC_ADMINISTRATION_ACTIVITIES',
    'MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES',
  ],
  FACILITIES_SERVICES: [
    'COMBINED_FACILITIES_SUPPORT_SERVICES',
    'CLEANING_SERVICES',
    'LANDSCAPE_CARE_AND_MAINTENANCE',
    'SECURITY_SYSTEMS_SERVICES',
  ],
  FARMING: [
    'GROWING_OF_NON_PERENNIAL_CROPS',
    'GROWING_OF_PERENNIAL_CROPS',
    'ANIMAL_PRODUCTION',
    'MIXED_FARMING',
    'SUPPORT_ACTIVITIES_TO_AGRICULTURE',
  ],
  FINANCIAL_SERVICES: [
    'OTHER_FINANCIAL_SERVICE_ACTIVITIES',
    'FINANCIAL_LEASING',
    'ACTIVITIES_AUXILIARY_TO_FINANCIAL_SERVICES',
    'FUND_MANAGEMENT_ACTIVITIES',
    'PAYMENT_PROCESSING_SERVICES',
    'CONSUMER_LENDING',
    'BUSINESS_LENDING',
    'CONSUMER_AND_COMMERCIAL_BANKING',
    'CONSUMER_PAYMENTS',
    'CROWDFUNDING',
    'CRYPTO',
    'INTERNATIONAL_MONEY_TRANSFER',
    'PERSONAL_FINANCE',
    'KIDS_FINANCE',
    'SMBS',
    'POINT_OF_SALES',
  ],
  FINE_ART: [
    'CREATIVE_ARTS_AND_ENTERTAINMENT_ACTIVITIES',
    'MUSEUMS_AND_GALLERIES',
    'RETAIL_SALE_OF_ART_WORKS_AND_ANTIQUES',
  ],
  FISHERY: [
    'FISHING',
    'AQUACULTURE',
    'PROCESSING_AND_PRESERVING_OF_FISH_AND_SEAFOOD',
  ],
  FOOD_AND_BEVERAGES: [
    'EVENT_CATERING_AND_OTHER_FOOD_SERVICE_ACTIVITIES',
    'VERTICALISED_DIGITAL_SUPERMARKETS',
    'TECH_ENABLED_AND_ALTERNATIVE_OFFLINE_MODELS',
    'SUPERMARKETS',
    'RESTAURANT',
    'PRODUCT_DISCOVERY_AND_CURATION',
    'PET_FOOD',
    'PERSONAL_SHOPPERS',
    'ONLINE_ENABLERS',
    'NICHE_OR_LOCAL_OFFERING',
    'MEALKITS_AND_PREPARED_MEALS',
    'INTEGRATED_DIGITAL_SUPERMARKETS',
    'FOOD_AND_GROCERY_RESCUE',
    'FOOD_AND_GROCERY_DELIVERY',
    'DISTRIBUTORS_MARKETPLACE',
    'DELIVERY_SPECIALISTS',
    'BROKERS',
    'BEVERAGES',
  ],
  FUND_RAISING: [
    'CHARITABLE_FUND_RAISING_ACTIVITIES',
    'MEMBERSHIP_ORGANIZATIONS',
    'PUBLIC_RELATIONS_AND_COMMUNICATION_SERVICES',
  ],
  FURNITURE: [
    'MANUFACTURE_OF_FURNITURE',
    'WHOLESALE_OF_FURNITURE_AND_LIGHTING_EQUIPMENT',
    'RETAIL_SALE_OF_FURNITURE',
  ],
  GAMBLING_AND_CASINOS: [
    'GAMBLING_AND_BETTING_ACTIVITIES',
    'OPERATION_OF_SPORTS_FACILITIES',
    'OTHER_AMUSEMENT_AND_RECREATION_ACTIVITIES',
  ],
  GLASS_CERAMICS_AND_CONCRETE: [
    'MANUFACTURE_OF_GLASS_AND_GLASS_PRODUCTS',
    'MANUFACTURE_OF_CERAMIC_PRODUCTS',
    'MANUFACTURE_OF_ARTICLES_OF_CONCRETE_CEMENT_AND_PLASTER',
    'MANUFACTURE_OF_CEMENT_LIME_AND_PLASTER',
  ],
  GOVERNMENT_ADMINISTRATION: [
    'GENERAL_PUBLIC_ADMINISTRATION_ACTIVITIES',
    'REGULATION_OF_HEALTH_EDUCATION_AND_CULTURAL_SERVICES',
    'PUBLIC_ORDER_AND_SAFETY_ACTIVITIES',
  ],
  GOVERNMENT_RELATIONS: [
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
    'LOBBYING_AND_PUBLIC_AFFAIRS_SERVICES',
    'BUSINESS_AND_EMPLOYERS_MEMBERSHIP_ORGANIZATIONS',
  ],
  GRAPHIC_DESIGN: [
    'GRAPHIC_DESIGN_SERVICES',
    'ADVERTISING_SERVICES',
    'OTHER_PROFESSIONAL_DESIGN_SERVICES',
  ],
  HEALTH_WELLNESS_AND_FITNESS: [
    'FITNESS_CENTRES',
    'WELLNESS_SERVICES',
    'OTHER_HUMAN_HEALTH_SERVICES',
    'RECREATION_AND_SPORTS_ACTIVITIES',
  ],
  HIGHER_EDUCATION: [
    'TERTIARY_EDUCATION',
    'EDUCATIONAL_SUPPORT_ACTIVITIES',
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_SOCIAL_SCIENCES',
  ],
  HOSPITAL_AND_HEALTH_CARE: [
    'HOSPITAL_ACTIVITIES',
    'MEDICAL_AND_DENTAL_PRACTICE_ACTIVITIES',
    'OTHER_HUMAN_HEALTH_ACTIVITIES',
    'RESIDENTIAL_NURSING_CARE_ACTIVITIES',
    'SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION',
  ],
  HOSPITALITY: [
    'HOTELS_AND_SIMILAR_ACCOMMODATION',
    'HOLIDAY_AND_SHORT_STAY_ACCOMMODATION',
  ],
  HUMAN_RESOURCES: [
    'EMPLOYMENT_PLACEMENT_AGENCIES',
    'TEMPORARY_EMPLOYMENT_AGENCY_ACTIVITIES',
    'HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_SERVICES',
    'MANAGEMENT_CONSULTANCY_ACTIVITIES',
  ],
  IMPORT_AND_EXPORT: [
    'WHOLESALE_ON_A_FEE_OR_CONTRACT_BASIS',
    'NON_SPECIALISED_WHOLESALE_TRADE',
    'FREIGHT_TRANSPORT_BY_ROAD',
    'SEA_AND_COASTAL_FREIGHT_WATER_TRANSPORT',
    'AIR_FREIGHT_TRANSPORT',
    'CUSTOMS_AGENCY_AND_FREIGHT_FORWARDING_SERVICES',
  ],
  INDIVIDUAL_AND_FAMILY_SERVICES: [
    'SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION',
    'CHILD_DAY_CARE_ACTIVITIES',
    'RESIDENTIAL_CARE_ACTIVITIES',
    'COUNSELING_SERVICES',
  ],
  INDUSTRIAL_AUTOMATION: [
    'MANUFACTURE_OF_INSTRUMENTS_AND_CONTROL_SYSTEMS',
    'INSTALLATION_OF_INDUSTRIAL_MACHINERY_AND_EQUIPMENT',
    'ENGINEERING_DESIGN_AND_CONSULTING_SERVICES',
    'INDUSTRIAL_PROCESS_AUTOMATION_SERVICES',
  ],
  INFORMATION_SERVICES: [
    'NEWS_AGENCY_ACTIVITIES',
    'OTHER_INFORMATION_SERVICE_ACTIVITIES',
    'DATA_PROCESSING_HOSTING_AND_RELATED_ACTIVITIES',
    'WEB_PORTALS',
  ],
  INFORMATION_TECHNOLOGY_AND_SERVICES: [
    'COMPUTER_PROGRAMMING_CONSULTANCY_AND_RELATED_ACTIVITIES',
    'DATA_PROCESSING_HOSTING_AND_RELATED_ACTIVITIES',
    'WEB_PORTALS',
    'SOFTWARE_PUBLISHING',
    'COMPUTER_FACILITIES_MANAGEMENT_ACTIVITIES',
    'IT_SUPPORT_AND_MANAGED_SERVICES',
  ],
  INSURANCE: [
    'LIFE_INSURANCE',
    'NON_LIFE_INSURANCE',
    'REINSURANCE',
    'ACTIVITIES_AUXILIARY_TO_INSURANCE_AND_PENSION_FUNDING',
  ],
  INTERNATIONAL_AFFAIRS: [
    'FOREIGN_AFFAIRS_ADMINISTRATION',
    'ACTIVITIES_OF_INTERNATIONAL_ORGANIZATIONS',
    'INTERNATIONAL_DEVELOPMENT_ACTIVITIES',
  ],
  INTERNATIONAL_TRADE_AND_DEVELOPMENT: [
    'INTERNATIONAL_TRADE_SERVICES',
    'DEVELOPMENT_ORGANIZATIONS',
    'NON_SPECIALISED_WHOLESALE_TRADE',
  ],
  INVESTMENT_BANKING: [
    'INVESTMENT_BANKING',
    'SECURITIES_TRADING',
    'CORPORATE_FINANCE_ADVISORY',
    'ADMINISTRATION_OF_FINANCIAL_MARKETS',
  ],
  INVESTMENT_MANAGEMENT: [
    'ASSET_MANAGEMENT',
    'PORTFOLIO_MANAGEMENT_SERVICES',
    'ACTIVITIES_OF_TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
  ],
  JUDICIARY: [
    'JUDICIAL_COURTS',
    'JUSTICE_ADMINISTRATION_SERVICES',
    'LEGAL_SUPPORT_SERVICES',
  ],
  LAW_ENFORCEMENT: [
    'POLICE_SERVICES',
    'PUBLIC_ORDER_AND_SAFETY_ACTIVITIES',
    'SECURITY_SERVICES',
  ],
  LAW_PRACTICE: [
    'LEGAL_PRACTICE',
    'NOTARIAL_SERVICES',
    'ARBITRATION_AND_MEDIATION',
    'INTELLECTUAL_PROPERTY_LEGAL_SERVICES',
  ],
  LEGAL_SERVICES: [
    'LEGAL_SERVICES',
    'ARBITRATION_AND_MEDIATION',
    'PATENT_AND_COPYRIGHT_AGENCY_SERVICES',
    'NOTARIAL_SERVICES',
  ],
  LEGISLATIVE_OFFICE: [
    'LEGISLATIVE_ACTIVITIES',
    'GOVERNMENT_BODIES',
    'PUBLIC_ADMINISTRATION_AND_DEFENCE',
  ],
  LEISURE_TRAVEL_AND_TOURISM: [
    'TRAVEL_AGENCY_AND_TOUR_OPERATOR_ACTIVITIES',
    'OTHER_RESERVATION_SERVICES',
    'HOTELS_AND_SIMILAR_ACCOMMODATION',
    'AMUSEMENT_AND_THEME_PARK_ACTIVITIES',
  ],
  LIBRARIES: [
    'LIBRARY_AND_ARCHIVES_ACTIVITIES',
    'CULTURAL_EDUCATION_SERVICES',
    'MUSEUM_ACTIVITIES_AND_OPERATION_OF_HISTORICAL_SITES',
  ],
  LOGISTICS_AND_SUPPLY_CHAIN: [
    'FREIGHT_TRANSPORT_BY_ROAD',
    'FREIGHT_RAIL_TRANSPORT',
    'SEA_AND_COASTAL_FREIGHT_WATER_TRANSPORT',
    'INLAND_FREIGHT_WATER_TRANSPORT',
    'AIR_FREIGHT_TRANSPORT',
    'CARGO_HANDLING',
    'WAREHOUSING_AND_STORAGE',
    'OTHER_TRANSPORTATION_SUPPORT_ACTIVITIES',
  ],
  LUXURY_GOODS_AND_JEWELRY: [
    'MANUFACTURE_OF_JEWELLERY_AND_RELATED_ARTICLES',
    'WHOLESALE_OF_JEWELLERY_AND_LUXURY_GOODS',
    'RETAIL_SALE_OF_WATCHES_AND_JEWELLERY',
  ],
  MACHINERY: [
    'MANUFACTURE_OF_GENERAL_PURPOSE_MACHINERY',
    'MANUFACTURE_OF_SPECIAL_PURPOSE_MACHINERY',
    'REPAIR_OF_MACHINERY_AND_EQUIPMENT',
    'WHOLESALE_OF_MACHINERY_EQUIPMENT_AND_SUPPLIES',
  ],
  MANAGEMENT_CONSULTING: [
    'BUSINESS_AND_MANAGEMENT_CONSULTANCY',
    'STRATEGY_CONSULTING',
    'OPERATIONS_AND_PROCESS_IMPROVEMENT_CONSULTING',
  ],
  MARITIME: [
    'SEA_AND_COASTAL_PASSENGER_WATER_TRANSPORT',
    'SEA_AND_COASTAL_FREIGHT_WATER_TRANSPORT',
    'SERVICE_ACTIVITIES_INCIDENTAL_TO_WATER_TRANSPORTATION',
    'PORT_AND_HARBOUR_OPERATIONS',
    'SHIPBUILDING_AND_REPAIR',
  ],
  MARKET_RESEARCH: [
    'MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING',
    'DATA_ANALYTICS_AND_CONSUMER_INSIGHTS_SERVICES',
  ],
  MARKETING_AND_ADVERTISING: [
    'ADVERTISING_AGENCIES',
    'MEDIA_REPRESENTATION',
    'MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING',
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
    'DIGITAL_MARKETING_SERVICES',
  ],
  MECHANICAL_OR_INDUSTRIAL_ENGINEERING: [
    'ENGINEERING_ACTIVITIES_AND_RELATED_TECHNICAL_CONSULTANCY',
    'MANUFACTURE_OF_GENERAL_PURPOSE_MACHINERY',
    'MANUFACTURE_OF_SPECIAL_PURPOSE_MACHINERY',
    'INSTALLATION_OF_INDUSTRIAL_MACHINERY_AND_EQUIPMENT',
  ],
  MEDIA_PRODUCTION: [
    'MOTION_PICTURE_VIDEO_AND_TELEVISION_PROGRAMME_PRODUCTION',
    'POST_PRODUCTION_SERVICES',
    'SOUND_RECORDING_AND_MUSIC_PUBLISHING',
    'TELEVISION_PROGRAMMING_AND_BROADCASTING',
  ],
  MEDICAL_DEVICES: [
    'MANUFACTURE_OF_MEDICAL_AND_DENTAL_INSTRUMENTS_AND_SUPPLIES',
    'WHOLESALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS',
    'RETAIL_SALE_OF_MEDICAL_AND_ORTHOPAEDIC_GOODS',
    'REPAIR_OF_MEDICAL_EQUIPMENT',
  ],
  MEDICAL_PRACTICE: [
    'GENERAL_MEDICAL_PRACTICE_ACTIVITIES',
    'SPECIALIST_MEDICAL_PRACTICE_ACTIVITIES',
    'DIAGNOSTIC_IMAGING_SERVICES',
    'OTHER_HUMAN_HEALTH_ACTIVITIES',
  ],
  MENTAL_HEALTH_CARE: [
    'RESIDENTIAL_CARE_FOR_MENTAL_HEALTH_AND_SUBSTANCE_ABUSE',
    'OTHER_HUMAN_HEALTH_ACTIVITIES',
    'COUNSELING_AND_PSYCHOTHERAPY_SERVICES',
    'SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION',
  ],
  MILITARY: [
    'DEFENCE_ACTIVITIES',
    'PUBLIC_ORDER_AND_SAFETY_ACTIVITIES',
    'MANUFACTURE_OF_WEAPONS_AND_AMMUNITION',
    'SUPPORT_ACTIVITIES_FOR_DEFENCE_OPERATIONS',
  ],
  MINING_AND_METALS: [
    'MINING_OF_COAL_AND_LIGNITE',
    'EXTRACTION_OF_CRUDE_PETROLEUM_AND_NATURAL_GAS',
    'MINING_OF_METAL_ORES',
    'OTHER_MINING_AND_QUARRYING',
    'SUPPORT_ACTIVITIES_FOR_MINING',
    'CASTING_OF_METALS',
  ],
  MOBILITY: [
    'FINANCE_AND_INSURANCE',
    'MAPPING_AND_NAVIGATION',
    'MICRO_MOBILITY',
    'MOBILITY_SERVICES',
    'PARKING_AND_SMART_CITY',
    'RIDE_SHARING',
    'VEHICLE_MARKEPLACE_AND_AFTERMARKET',
  ],
  MOTION_PICTURES_AND_FILM: [
    'MOTION_PICTURE_PRODUCTION',
    'MOTION_PICTURE_DISTRIBUTION',
    'MOTION_PICTURE_PROJECTION',
    'POST_PRODUCTION_SERVICES',
  ],
  MUSEUMS_AND_INSTITUTIONS: [
    'MUSEUM_ACTIVITIES_AND_OPERATION_OF_HISTORICAL_SITES',
    'BOTANICAL_AND_ZOOLOGICAL_GARDENS_AND_NATURE_RESERVES',
    'LIBRARY_AND_ARCHIVES_ACTIVITIES',
  ],
  MUSIC: [
    'SOUND_RECORDING_AND_MUSIC_PUBLISHING',
    'MUSIC_PERFORMANCE_ACTIVITIES',
    'OPERATION_OF_ARTS_FACILITIES',
  ],
  NANOTECHNOLOGY: [
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_NATURAL_SCIENCES_AND_ENGINEERING',
    'MANUFACTURE_OF_ELECTRONIC_COMPONENTS',
    'ADVANCED_MATERIALS_MANUFACTURING',
  ],
  NEWSPAPERS: [
    'PUBLISHING_OF_NEWSPAPERS_JOURNALS_AND_PERIODICALS',
    'NEWS_AGENCY_ACTIVITIES',
    'PRINTING_ACTIVITIES',
    'RETAIL_SALE_OF_NEWSPAPERS_AND_STATIONERY',
  ],
  NONPROFIT_ORGANIZATION_MANAGEMENT: [
    'ACTIVITIES_OF_OTHER_MEMBERSHIP_ORGANIZATIONS',
    'CHARITABLE_FUND_RAISING_ACTIVITIES',
    'SOCIAL_WORK_ACTIVITIES_WITHOUT_ACCOMMODATION',
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
  ],
  OIL_AND_ENERGY: [
    'EXTRACTION_OF_CRUDE_PETROLEUM',
    'EXTRACTION_OF_NATURAL_GAS',
    'SUPPORT_ACTIVITIES_FOR_PETROLEUM_AND_NATURAL_GAS_EXTRACTION',
    'MANUFACTURE_OF_REFINED_PETROLEUM_PRODUCTS',
    'ELECTRIC_POWER_GENERATION_TRANSMISSION_AND_DISTRIBUTION',
    'TRADE_OF_GAS_THROUGH_MAINS',
  ],
  ONLINE_MEDIA: [
    'WEB_PORTALS',
    'DATA_PROCESSING_AND_HOSTING',
    'OTHER_INFORMATION_SERVICES',
    'ONLINE_PUBLISHING_OF_JOURNALS_AND_PERIODICALS',
    'DIGITAL_NEWS_AND_MEDIA_AGGREGATION',
  ],
  OUTSOURCING_OFFSHORING: [
    'BUSINESS_PROCESS_OUTSOURCING_SERVICES',
    'CALL_CENTRES_AND_TELEPHONE_BASED_SUPPORT_SERVICES',
    'COMPUTER_FACILITIES_MANAGEMENT_ACTIVITIES',
    'BACK_OFFICE_SUPPORT_AND_DATA_PROCESSING',
  ],
  PACKAGE_FREIGHT_DELIVERY: [
    'POSTAL_ACTIVITIES',
    'COURIER_ACTIVITIES',
    'FREIGHT_TRANSPORT_BY_ROAD',
    'CARGO_HANDLING',
    'WAREHOUSING_AND_STORAGE',
  ],
  PACKAGING_AND_CONTAINERS: [
    'MANUFACTURE_OF_PAPER_AND_PAPERBOARD_CONTAINERS',
    'MANUFACTURE_OF_PLASTIC_PACKING_GOODS',
    'MANUFACTURE_OF_GLASS_CONTAINERS',
    'WHOLESALE_OF_PACKAGING_MATERIALS',
  ],
  PAPER_AND_FOREST_PRODUCTS: [
    'MANUFACTURE_OF_PULP_PAPER_AND_PAPERBOARD',
    'MANUFACTURE_OF_CORRUGATED_PAPER_AND_CONTAINERS',
    'LOGGING',
    'SAWMILLING_AND_PLANING_OF_WOOD',
    'WHOLESALE_OF_WOOD_AND_CONSTRUCTION_MATERIALS',
  ],
  PERFORMING_ARTS: [
    'PERFORMING_ARTS',
    'SUPPORT_ACTIVITIES_TO_PERFORMING_ARTS',
    'OPERATION_OF_ARTS_FACILITIES',
  ],
  PHARMACEUTICALS: [
    'MANUFACTURE_OF_PHARMACEUTICALS_MEDICINAL_CHEMICAL_AND_BOTANICAL_PRODUCTS',
    'WHOLESALE_OF_PHARMACEUTICAL_GOODS',
    'RETAIL_SALE_OF_PHARMACEUTICAL_AND_MEDICAL_GOODS',
    'BIOPHARMACEUTICAL_RESEARCH_AND_DEVELOPMENT',
  ],
  PHILANTHROPY: [
    'TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
    'GRANT_MAKING_ACTIVITIES',
    'CHARITABLE_FUND_RAISING_ACTIVITIES',
    'ACTIVITIES_OF_OTHER_MEMBERSHIP_ORGANIZATIONS',
  ],
  PHOTOGRAPHY: [
    'PHOTOGRAPHIC_ACTIVITIES',
    'RETAIL_SALE_OF_PHOTOGRAPHIC_EQUIPMENT',
    'IMAGING_AND_PHOTO_PROCESSING_SERVICES',
  ],
  PLASTICS: [
    'MANUFACTURE_OF_PLASTICS_IN_PRIMARY_FORMS',
    'MANUFACTURE_OF_PLASTIC_PRODUCTS',
    'WHOLESALE_OF_CHEMICAL_PRODUCTS',
    'RECYCLING_OF_PLASTIC_MATERIALS',
  ],
  POLITICAL_ORGANIZATION: [
    'ACTIVITIES_OF_POLITICAL_ORGANIZATIONS',
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
    'CIVIC_AND_SOCIAL_ORGANIZATIONS',
  ],
  PRIMARY_SECONDARY_EDUCATION: [
    'PRIMARY_EDUCATION',
    'SECONDARY_EDUCATION',
    'EDUCATIONAL_SUPPORT_ACTIVITIES',
  ],
  PRINTING: [
    'PRINTING',
    'SERVICE_ACTIVITIES_RELATED_TO_PRINTING',
    'MANUFACTURE_OF_PRINTING_INK',
  ],
  PROFESSIONAL_TRAINING_AND_COACHING: [
    'OTHER_EDUCATION_N_E_C',
    'EDUCATIONAL_SUPPORT_ACTIVITIES',
    'BUSINESS_AND_MANAGEMENT_TRAINING',
    'COACHING_SERVICES',
  ],
  PROGRAM_DEVELOPMENT: [
    'COMPUTER_PROGRAMMING_ACTIVITIES',
    'SOFTWARE_PUBLISHING',
    'COMPUTER_CONSULTANCY_ACTIVITIES',
  ],
  PUBLIC_POLICY: [
    'PUBLIC_ADMINISTRATION_AND_DEFENCE_POLICY_PLANNING',
    'POLICY_RESEARCH_SERVICES',
    'ACTIVITIES_OF_POLITICAL_ORGANIZATIONS',
  ],
  PUBLIC_RELATIONS_AND_COMMUNICATIONS: [
    'PUBLIC_RELATIONS_AND_COMMUNICATION_ACTIVITIES',
    'MEDIA_REPRESENTATION',
    'MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING',
    'CORPORATE_COMMUNICATIONS_SERVICES',
  ],
  PUBLIC_SAFETY: [
    'PUBLIC_ORDER_AND_SAFETY_ACTIVITIES',
    'FIRE_SERVICE_ACTIVITIES',
    'DISASTER_AND_EMERGENCY_RESPONSE_ACTIVITIES',
  ],
  PUBLISHING: [
    'BOOK_PUBLISHING',
    'PUBLISHING_OF_NEWSPAPERS_JOURNALS_AND_PERIODICALS',
    'OTHER_PUBLISHING_ACTIVITIES',
    'SOFTWARE_PUBLISHING',
  ],
  RAILROAD_MANUFACTURE: [
    'MANUFACTURE_OF_RAILWAY_LOCOMOTIVES_AND_ROLLING_STOCK',
    'REPAIR_OF_TRANSPORT_EQUIPMENT',
    'WHOLESALE_OF_MACHINERY_AND_EQUIPMENT',
  ],
  RANCHING: [
    'ANIMAL_PRODUCTION',
    'SUPPORT_ACTIVITIES_FOR_ANIMAL_PRODUCTION',
    'PROCESSING_OF_MEAT_AND_MEAT_PRODUCTS',
  ],
  REAL_ESTATE: [
    'AGGREGATORS',
    'MARKETPLACES',
    'NEW_WAY_OF_LIVING',
    'NO_AGENT_NEEDED',
    'PROPERTY_AGENT_AND_AGENT_MATCHING',
    'PROPERTY_MANAGEMENT',
    'PROPERTY_SEARCH',
    'SHORT_TERM_RENTALS',
    'TRADITIONAL_RE_AGENCIES',
  ],
  RECREATIONAL_FACILITIES_AND_SERVICES: [
    'OPERATION_OF_SPORTS_FACILITIES',
    'OTHER_AMUSEMENT_AND_RECREATION_ACTIVITIES',
    'PARKS_AND_RECREATIONAL_ACTIVITIES',
  ],
  RELIGIOUS_INSTITUTIONS: [
    'ACTIVITIES_OF_RELIGIOUS_ORGANIZATIONS',
    'RELIGIOUS_EDUCATION',
    'CHARITABLE_ACTIVITIES_BY_RELIGIOUS_ORGANIZATIONS',
  ],
  RENEWABLES_AND_ENVIRONMENT: [
    'ELECTRIC_POWER_GENERATION_FROM_RENEWABLE_SOURCES',
    'MANUFACTURE_OF_RENEWABLE_ENERGY_EQUIPMENT',
    'ENVIRONMENTAL_CONSULTING_ACTIVITIES',
    'WASTE_COLLECTION_AND_MATERIALS_RECOVERY',
  ],
  RESEARCH: [
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_NATURAL_SCIENCES_AND_ENGINEERING',
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_ON_SOCIAL_SCIENCES_AND_HUMANITIES',
    'MARKET_RESEARCH_AND_PUBLIC_OPINION_POLLING',
  ],
  RETAIL: [
    'RETAIL_SALE_IN_NON_SPECIALISED_STORES',
    'RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO',
    'RETAIL_SALE_OF_OTHER_GOODS_IN_SPECIALISED_STORES',
    'RETAIL_SALE_VIA_STALLS_AND_MARKETS',
    'RETAIL_SALE_VIA_MAIL_ORDER_OR_INTERNET',
  ],
  SECURITY_AND_INVESTIGATIONS: [
    'PRIVATE_SECURITY_ACTIVITIES',
    'SECURITY_SYSTEMS_SERVICE_ACTIVITIES',
    'INVESTIGATION_ACTIVITIES',
  ],
  SEMICONDUCTORS: [
    'MANUFACTURE_OF_ELECTRONIC_COMPONENTS',
    'MANUFACTURE_OF_LOADED_ELECTRONIC_BOARDS',
    'WHOLESALE_OF_ELECTRONIC_COMPONENTS',
    'RANDD_IN_MICROELECTRONICS',
  ],
  SHIPBUILDING: [
    'BUILDING_OF_SHIPS_AND_FLOATING_STRUCTURES',
    'BUILDING_OF_PLEASURE_AND_SPORTING_BOATS',
    'REPAIR_AND_MAINTENANCE_OF_SHIPS_AND_BOATS',
  ],
  SPORTING_GOODS: [
    'MANUFACTURE_OF_SPORTS_GOODS',
    'WHOLESALE_OF_SPORTING_GOODS',
    'RETAIL_SALE_OF_SPORTING_EQUIPMENT',
  ],
  SPORTS: [
    'SPORTS_CLUB_ACTIVITIES',
    'OPERATION_OF_SPORTS_FACILITIES',
    'SPORTS_AND_RECREATION_INSTRUCTION',
    'OTHER_SPORTS_ACTIVITIES',
  ],
  STAFFING_AND_RECRUITING: [
    'EMPLOYMENT_PLACEMENT_AGENCIES',
    'TEMPORARY_EMPLOYMENT_AGENCY_ACTIVITIES',
    'HUMAN_RESOURCES_PROVISION_AND_MANAGEMENT_OF_HUMAN_RESOURCES_FUNCTIONS',
  ],
  SUPERMARKETS: [
    'RETAIL_SALE_IN_NON_SPECIALISED_STORES_WITH_FOOD_BEVERAGES_OR_TOBACCO_PREDOMINATING',
    'RETAIL_SALE_OF_FOOD_BEVERAGES_AND_TOBACCO_IN_SPECIALISED_STORES',
    'WHOLESALE_OF_FOOD_BEVERAGES_AND_TOBACCO',
    'E_COMMERCE_OF_GROCERIES',
  ],
  TELECOMMUNICATIONS: [
    'WIRED_TELECOMMUNICATIONS_ACTIVITIES',
    'WIRELESS_TELECOMMUNICATIONS_ACTIVITIES',
    'SATELLITE_TELECOMMUNICATIONS_ACTIVITIES',
    'OTHER_TELECOMMUNICATIONS_ACTIVITIES',
    'DATA_PROCESSING_AND_HOSTING_SERVICES',
  ],
  TEXTILES: [
    'PREPARATION_AND_SPINNING_OF_TEXTILE_FIBRES',
    'WEAVING_OF_TEXTILES',
    'FINISHING_OF_TEXTILES',
    'MANUFACTURE_OF_OTHER_TEXTILES',
    'MANUFACTURE_OF_CARPETS_AND_RUGS',
  ],
  THINK_TANKS: [
    'POLICY_RESEARCH_INSTITUTES',
    'RESEARCH_AND_EXPERIMENTAL_DEVELOPMENT_SOCIAL_SCIENCES',
    'PUBLIC_POLICY_ADVISORY_SERVICES',
  ],
  TOBACCO: [
    'MANUFACTURE_OF_TOBACCO_PRODUCTS',
    'WHOLESALE_OF_TOBACCO_PRODUCTS',
    'RETAIL_SALE_OF_TOBACCO_PRODUCTS',
  ],
  TRANSLATION_AND_LOCALIZATION: [
    'TRANSLATION_AND_INTERPRETATION_ACTIVITIES',
    'LOCALIZATION_SERVICES',
    'PUBLISHING_SUPPORT_SERVICES',
  ],
  TRANSPORTATION_TRUCKING_RAILROAD: [
    'FREIGHT_TRANSPORT_BY_ROAD',
    'PASSENGER_RAIL_TRANSPORT',
    'FREIGHT_RAIL_TRANSPORT',
    'URBAN_AND_SUBURBAN_PASSENGER_LAND_TRANSPORT',
    'CARGO_HANDLING',
    'WAREHOUSING_AND_STORAGE',
    'OTHER_TRANSPORTATION_SUPPORT_ACTIVITIES',
  ],
  UTILITIES: [
    'ELECTRIC_POWER_GENERATION_TRANSMISSION_AND_DISTRIBUTION',
    'MANUFACTURE_OF_GAS_DISTRIBUTION_OF_GASEOUS_FUELS_THROUGH_MAINS',
    'STEAM_AND_AIR_CONDITIONING_SUPPLY',
    'WATER_COLLECTION_TREATMENT_AND_SUPPLY',
    'SEWERAGE',
    'WASTE_MANAGEMENT_AND_MATERIALS_RECOVERY',
  ],
  VENTURE_CAPITAL_AND_PRIVATE_EQUITY: [
    'TRUSTS_FUNDS_AND_SIMILAR_FINANCIAL_ENTITIES',
    'VENTURE_CAPITAL_ACTIVITIES',
    'PRIVATE_EQUITY_ACTIVITIES',
    'ACTIVITIES_AUXILIARY_TO_FINANCIAL_SERVICES',
  ],
  VETERINARY: [
    'VETERINARY_ACTIVITIES',
    'MANUFACTURE_OF_VETERINARY_PHARMACEUTICAL_PRODUCTS',
    'RETAIL_SALE_OF_PET_FOOD_AND_PET_SUPPLIES',
  ],
  WAREHOUSING: [
    'WAREHOUSING_AND_STORAGE',
    'CARGO_HANDLING',
    'OTHER_TRANSPORTATION_SUPPORT_ACTIVITIES',
    'FULFILMENT_AND_DISTRIBUTION_SERVICES',
  ],
  WHOLESALE: [
    'NON_SPECIALISED_WHOLESALE_TRADE',
    'WHOLESALE_OF_FOOD_BEVERAGES_AND_TOBACCO',
    'WHOLESALE_OF_HOUSEHOLD_GOODS',
    'WHOLESALE_OF_MACHINERY_EQUIPMENT_AND_SUPPLIES',
    'WHOLESALE_OF_INFORMATION_AND_COMMUNICATIONS_EQUIPMENT',
  ],
  WINE_AND_SPIRITS: [
    'MANUFACTURE_OF_WINES',
    'MANUFACTURE_OF_SPIRITS',
    'WHOLESALE_OF_BEVERAGES',
    'RETAIL_SALE_OF_BEVERAGES_IN_SPECIALISED_STORES',
  ],
  WIRELESS: [
    'WIRELESS_TELECOMMUNICATIONS_ACTIVITIES',
    'SATELLITE_TELECOMMUNICATIONS_ACTIVITIES',
    'TELECOMMUNICATIONS_INFRASTRUCTURE_OPERATION',
    'DATA_PROCESSING_AND_HOSTING',
  ],
  WRITING_AND_EDITING: [
    'EDITORIAL_SERVICES',
    'CONTENT_WRITING',
    'PUBLISHING_SERVICES',
    'NEWS_AGENCY_ACTIVITIES',
  ],
}
